window.slate = window.slate || {};
window.theme = window.theme || {};
var $ = window.jQuery;

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

/* global jQuery, slate */
slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  jQuery(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

jQuery.extend(slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = jQuery(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = jQuery.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = jQuery('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    jQuery('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;
      // updateModelMeasure(variant.sku);
      if (typeof myFunction === 'function') { processFilteredProducts()}
      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.KitVariants = (function() {

    /**
     * Variant constructor
     *
     * @param {object} options - Settings from `product.js`
     */
    function KitVariants(options) {
      this.$container = options.$container;
      this.product = options.product;
      this.kitComponents = options.kitComponents;
      this.singleOptionSelector = options.singleOptionSelector;
      this.originalSelectorId = options.originalSelectorId;
      // history state is a carry over from the main variant implementation.
      // kits do not have a URL representation for a particular configuration, so at present 
      // history state is not a supported option.
      this.enableHistoryState = options.enableHistoryState;
    //   this.currentVariants = this.kitComponents.map(function(val, idx, arr) {
    //       return this._getVariantFromOptions(idx);
    //   });
  
      $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));

      this._initImages();
    }
  
    KitVariants.prototype = $.extend({}, KitVariants.prototype, {
  
      /**
       * Get the currently selected options from add-to-cart form. Works with all
       * form input elements.
       *
       * @param {object} component - component context for the current operation
       * @return {array} options - Values of currently selected variants
       */
      _getCurrentOptions: function(component) {
        var selector = this.singleOptionSelector + "[data-product='" + component.id + "']";
        var currentOptions = $.map($(selector, this.$container), function(element) {
          var $element = $(element);
          var type = $element.attr('type');
          var currentOption = {};
  
          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');
  
              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');
  
            return currentOption;
          }
        });
  
        // remove any unchecked input values if using radio buttons or checkboxes
        currentOptions = slate.utils.compact(currentOptions);
  
        return currentOptions;
      },
  
      /**
       * Find variant based on selected values.
       *
       * @param {object} component - component context for the current operation
       * @param  {array} selectedValues - Values of variant inputs
       * @return {object || undefined} found - Variant object from product.variants
       */
      _getVariantFromOptions: function(component) {
        var selectedValues = this._getCurrentOptions(component);
        var variants = component.variants;
        var found = false;
  
        variants.forEach(function(variant) {
          var satisfied = true;
  
          selectedValues.forEach(function(option) {
            if (satisfied) {
              satisfied = (option.value === variant[option.index]);
            }
          });
  
          if (satisfied) {
            found = variant;
          }
        });
  
        return found || null;
      },
  
      /**
       * Event handler for when a variant input changes.
       */
      _onSelectChange: function(event) {
        var id = $(event.currentTarget).attr('data-product');
        var component = this.kitComponents[id];
        var variant = this._getVariantFromOptions(component);
  
        this.$container.trigger({
          type: 'variantKitChange',
          component: component,
          variant: variant
        });
  
        if (!variant) {
          return;
        }
  
        this._updateMasterSelect(variant, component);
        this._updateImages(variant);
        // this._updatePrice(variant);
        // this.currentVariant = variant;
  
        // if (this.enableHistoryState) {
        //   this._updateHistoryState(variant);
        // }
      },
  
      /**
       * Trigger event when variant image changes
       *
       * @param  {object} variant - Currently selected variant
       * @return {event}  variantImageChange
       */
      _updateImages: function(variant) {
        $('.input-color[data-swatch-input]:checked').each(function() {
          var $input = $(this);
          var $val = "Kit " + $input.val();
          var product = $input.data('product');
          $(".kit-thumbnail-media img[data-product='" + product + "']").each(function() {
            var $img = $(this);
            if( $img.data("alt") === $val){
              $img.addClass('active');
            }
            else {
              $img.removeClass('active');
            }
          });
        });
      },
      _initImages: function() {
        $('.kit-thumbnail-media img:first-child()').addClass('active');
      },
  
      /**
       * Trigger event when variant price changes.
       *
       * @param  {object} variant - Currently selected variant
       * @return {event} variantPriceChange
       */
      _updatePrice: function(variant) {
        if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
          return;
        }
  
        this.$container.trigger({
          type: 'variantPriceChange',
          variant: variant
        });
      },
  
      /**
       * Update history state for product deeplinking
       *
       * @param {object} variant - Currently selected variant
       */
      _updateHistoryState: function(variant) {
        if (!history.replaceState || !variant) {
          return;
        }
  
        var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
        window.history.replaceState({path: newurl}, '', newurl);
      },
  
      /**
       * Update hidden master select of variant change
       *
       * @param {object} variant - Currently selected variant
       * @param {object} component - The component for the variant
       */
      _updateMasterSelect: function(variant, component) {
        var selector = this.originalSelectorId + "[data-product='" + component.id + "']"
        $(selector, this.$container)[0].value = variant.id;
      }
    });
  
    return KitVariants;
  })();
  

/*================ Global ================*/
/**
 * Global Configurations
 * ------------------------------------------------------------------------------
 */
theme.config = {
  // Media queries & breakpoints based on src/styles/tools/variables.scss.liquid
  mediaQueries: {
    xs: 'screen and (max-width: 29.99em)',
    smallDown: 'screen and (max-width: 47.99em)',
    small: 'screen and (min-width: 30em) and (max-width: 47.99em)',
    smallUp: 'screen and (min-width: 30em)',
    mediumDown: 'screen and (max-width: 63.99em)',
    medium: 'screen and (min-width: 48em) and (max-width: 63.99em)',
    mediumUp: 'screen and (min-width: 48em)',
    largeDown: 'screen and (max-width: 79.99em)',
    large: 'screen and (min-width: 64em) and (max-width: 79.99em)',
    largeUp: 'screen and (min-width: 64em)',
    widescreen: 'screen and (min-width: 80em)'
  },
  breakpoints: {
    small: 480,
    medium: 768,
    large: 1024,
    widescreen: 1280
  }
};
if ((typeof ShopifyAPI) === 'undefined') {
  ShopifyAPI = {};
}

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var $body = $(document.body),
    params = {
      type: 'POST',
      url: '/cart/update.js',
      data: 'note=' + attributeToString(note),
      dataType: 'json',
      beforeSend: function() {
        $body.trigger('beforeUpdateCartNote.ajaxCart', note);
      },
      success: function(cart) {
        if ((typeof callback) === 'function') {
          callback(cart);
        } else {
          ShopifyAPI.onCartUpdate(cart);
        }
        $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
      },
      error: function(XMLHttpRequest, textStatus) {
        $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      },
      complete: function(jqxhr, text) {
        $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
      }
    };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status + '): ' + data.description);
  }
};

ShopifyAPI.getCartErrorMessage = function(payload) {
  if (!payload) return '';
  var description = payload.errors || payload.description || payload.reason;
  if (typeof normalizeCartErrorDescription === 'function') {
    return normalizeCartErrorDescription(description) || payload.message || '';
  }
  if (!description) return payload.message || '';
  if (typeof description === 'string') return description;
  if (Array.isArray(description)) return description.join('; ');
  if (typeof description === 'object') {
    return Object.values(description).flat().join('; ');
  }
  return String(description);
};

ShopifyAPI.pushAddToCartDataLayer = function(form) {
  if (!window.dataLayer || typeof window.dataLayer.push !== 'function') return;
  var $form = form ? jQuery(form) : jQuery();
  if (!$form.length) $form = jQuery('.product-form');
  if (!$form.length) return;
  var variantInput = $form.find('*[name="id"]');
  var quantityInput = $form.find('input[name="quantity"]');
  var itemQuantity = quantityInput.length > 0 ? quantityInput.val() : 1;
  var productId = $form.find('.pid').val();
  window.dataLayer.push({
    event: 'ee_addToCart',
    name: $form.find('.ptitle').val(),
    id: productId,
    price: $form.find('.pprice').val(),
    brand: $form.find('.pbrand').val(),
    product_type: $form.find('.ptype').val(),
    category: $form.find('.pcollection').val(),
    quantity: itemQuantity,
    variant: variantInput.val(),
    g_product_id: 'shopify_US_' + productId + '_' + variantInput.val()
  });
};

ShopifyAPI.notifyItemAdded = function(line_item, form) {
  jQuery(document.body).trigger('afterAddItem.ajaxCart', [line_item, form]);
  try { callWairSize(line_item); } catch (e) {}
};

ShopifyAPI.notifyItemError = function(errorSource, textStatus) {
  var xhr = errorSource;
  if (!xhr || typeof xhr.responseText !== 'string') {
    xhr = {
      responseText: typeof errorSource === 'string' ? errorSource : JSON.stringify(errorSource || {}),
      status: (errorSource && errorSource.status) || 0
    };
  }
  jQuery(document.body).trigger('errorAddItem.ajaxCart', [xhr, textStatus || 'error']);
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  ShopifyAPI.pushAddToCartDataLayer(form);
  var $body = $(document.body),
    params = {
      type: 'POST',
      url: '/cart/add.js',
      data: jQuery(form).serialize(),
      dataType: 'json',
      beforeSend: function(jqxhr, settings) {
        $body.trigger('beforeAddItem.ajaxCart', form);
      },
      success: function(line_item) {
        if ((typeof callback) === 'function') {
          callback(line_item, form);
        } else {
          ShopifyAPI.onItemAdded(line_item, form);
        }
        ShopifyAPI.notifyItemAdded(line_item, form);
      },
      error: function(XMLHttpRequest, textStatus) {
        if ((typeof errorCallback) === 'function') {
          errorCallback(XMLHttpRequest, textStatus);
        } else {
          ShopifyAPI.onError(XMLHttpRequest, textStatus);
        }
        ShopifyAPI.notifyItemError(XMLHttpRequest, textStatus);
      },
      complete: function(jqxhr, text) {
        $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
      }
    };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  $(document.body).trigger('beforeGetCart.ajaxCart');
  jQuery.getJSON('/cart.js', function(cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    } else {
      ShopifyAPI.onCartUpdate(cart);
    }
    $(document.body).trigger('afterGetCart.ajaxCart', cart);
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var $body = $(document.body),
    params = {
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=' + quantity + '&line=' + line,
      dataType: 'json',
      beforeSend: function() {
        $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
      },
      success: function(cart) {
        if ((typeof callback) === 'function') {
          callback(cart);
        } else {
          ShopifyAPI.onCartUpdate(cart);
        }
        $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
      },
      error: function(XMLHttpRequest, textStatus) {
        $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      },
      complete: function(jqxhr, text) {
        $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
      }
    };
  jQuery.ajax(params);
};

/*============================================================================
  Add-to-cart spinner/checkmark state (see snippets/add-to-cart-icons.liquid).
  Keeps the legacy `ajaxCart.setAddToCartIconState` name that the PDP,
  sticky ATC, and quickshop already call.
==============================================================================*/
var ajaxCart = (function() {
  var BUTTON_SELECTOR = '[data-add-to-cart], #atc-top[data-sticky-atc], .mobile-sticky-atc__v2-trigger, .product-modal__add-to-cart';
  var addedTimeout;

  // state: 'adding' | 'added' | 'idle'
  function setAddToCartIconState(state) {
    clearTimeout(addedTimeout);
    document.querySelectorAll(BUTTON_SELECTOR).forEach(function(button) {
      button.classList.toggle('is-adding', state === 'adding');
      button.classList.toggle('is-added', state === 'added');
    });

    if (state === 'added') {
      addedTimeout = setTimeout(function() {
        setAddToCartIconState('idle');
      }, 1000);
    }
  }

  return {
    setAddToCartIconState: setAddToCartIconState
  };
})();

/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function() {
  function Drawer(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.nodes = {
      $parent: $('html').add('body'),
      $page: $('#page-container')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  }

  Drawer.prototype.init = function() {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
  };

  Drawer.prototype.open = function(evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to nodes.$page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    if(!this.drawerIsOpen){
    	$.getJSON('/cart.js', function(cart) {
          if(cart.items.length > 0){
            var cartId = cart.token;
            var cartTotalValue = cart.total_price;
            var cartTotalQuantity = cart.item_count;
            var cartCurrency = cart.currency;
            var cartItemsName = [];
            var cartItemsBrand = [];
            var cartItemsType = [];
            var cartItemsSku = [];
            var cartItemsId = [];
            var cartItemsVariantId = [];
            var cartItemsVariantTitle = [];
            var cartItemsPrice = [];
            var cartItemsQuantity = [];
            var cartItemsQuantity = [];
            var cartGProductIds = [];

            $.each(cart.items, function(key,val) {
              cartItemsName.push(val.title);
              cartItemsBrand.push(val.vendor);
              cartItemsType.push(val.product_type);
              cartItemsSku.push(val.sku);
              cartItemsId.push(val.product_id);
              cartItemsVariantId.push(val.variant_id);
              cartItemsVariantTitle.push(val.title);
              cartItemsPrice.push(parseFloat(parseInt(val.original_price)/100));
              cartItemsQuantity.push(val.quantity);
              cartGProductIds.push("shopify_US_"+val.product_id+"_"+val.variant_id);
            });
            window.dataLayer.push({
              event: 'ee_checkout',
              page_type: 'cart',
              name: cartItemsName,
              brand: cartItemsBrand,
              product_type: cartItemsType,
              sku: cartItemsSku,
              id: cartItemsId,
              variant_id: cartItemsVariantId,
              variant: cartItemsVariantTitle,
              price: cartItemsPrice,
              quantity: cartItemsQuantity,
              cart_id: cart.token,
              currency: cartCurrency,
              totalValue: parseFloat(cart.total_price)/100,
              totalQuantity: cart.item_count,
              g_product_id: cartGProductIds
            });
          }
        });
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(
      this.config.openClass + ' ' + this.config.dirOpenClass
    );
    this.drawerIsOpen = true;

    // Set focus on drawer
    slate.a11y.trapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === 'function'
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();

    return this;
  };

  Drawer.prototype.close = function() {
    if (!this.drawerIsOpen) {
      // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition();

    this.nodes.$parent.removeClass(
      this.config.dirOpenClass + ' ' + this.config.openClass
    );

    this.drawerIsOpen = false;

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    this.unbindEvents();
  };

  Drawer.prototype.bindEvents = function() {
    this.nodes.$parent.on(
      'keyup.drawer',
      $.proxy(function(evt) {
        // close on 'esc' keypress
        if (evt.keyCode === 27) {
          this.close();
          return false;
        } else {
          return true;
        }
      }, this)
    );

    // Lock scrolling on mobile
    this.nodes.$page.on('touchmove.drawer', function() {
      return false;
    });

    this.nodes.$page.on(
      'click.drawer',
      $.proxy(function() {
        this.close();
        return false;
      }, this)
    );
  };

  Drawer.prototype.unbindEvents = function() {
    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
  };

  return Drawer;
})();

/**
 * s-modal — Size Guide open/close, focus trap, and custom element.
 */
(function () {
  var FOCUSABLE =
    'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])';
  var lastOpener = null;
  var trapHandler = null;

  function isNewSizeGuideEnabled() {
    return document.body.classList.contains('seed-new-size-guide');
  }

  function getModal() {
    return document.getElementById('SizeGuideModal');
  }

  function isModalOpen(modal) {
    return !!(modal && modal.classList.contains('open'));
  }

  function getFocusable(modal) {
    return Array.prototype.filter.call(modal.querySelectorAll(FOCUSABLE), function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
    });
  }

  function isFocusInsideModal(modal, active) {
    return !!(active && (active === modal || modal.contains(active)));
  }

  function trapFocus(modal) {
    releaseFocus();

    trapHandler = function (event) {
      if (event.key !== 'Tab' || !isModalOpen(modal)) return;

      var nodes = getFocusable(modal);
      var active = document.activeElement;

      if (!nodes.length) {
        event.preventDefault();
        modal.focus();
        return;
      }

      var first = nodes[0];
      var last = nodes[nodes.length - 1];
      var leavingStart = event.shiftKey && (active === first || active === modal || !isFocusInsideModal(modal, active));
      var leavingEnd = !event.shiftKey && (active === last || !isFocusInsideModal(modal, active));

      if (leavingStart) {
        event.preventDefault();
        last.focus();
      } else if (leavingEnd) {
        event.preventDefault();
        first.focus();
      }
    };

    document.addEventListener('keydown', trapHandler);
  }

  function moveFocusIntoModal(modal) {
    function focusModal() {
      modal.focus();
    }

    if (typeof window.requestAnimationFrame === 'function') {
      window.requestAnimationFrame(focusModal);
      return;
    }

    focusModal();
  }

  function releaseFocus() {
    if (!trapHandler) return;
    document.removeEventListener('keydown', trapHandler);
    trapHandler = null;
  }

  function resolveOpener(opener) {
    if (opener && opener.nodeType === 1) return opener;
    var active = document.activeElement;
    if (active && active !== document.body) return active;
    return null;
  }

  function openSizeGuideModal(opener) {
    if (!isNewSizeGuideEnabled()) return;

    var modal = getModal();
    if (!modal) return;

    lastOpener = resolveOpener(opener);
    modal.classList.add('open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('js-modal-open');

    if (!modal.hasAttribute('tabindex')) {
      modal.setAttribute('tabindex', '-1');
    }

    trapFocus(modal);
    moveFocusIntoModal(modal);
  }

  function closeSizeGuideModal() {
    var modal = getModal();
    if (!isModalOpen(modal)) return;

    modal.classList.remove('open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('js-modal-open', 'js-focusable-widget-open');
    releaseFocus();

    if (lastOpener && typeof lastOpener.focus === 'function') {
      lastOpener.focus();
    }

    lastOpener = null;
  }

  function handleSizeGuideClick(event) {
    var opener =
      event && event.currentTarget && event.currentTarget.nodeType === 1
        ? event.currentTarget
        : null;

    if (isNewSizeGuideEnabled()) {
      openSizeGuideModal(opener);
    } else if (typeof window.scrollToSizeGuide === 'function') {
      window.scrollToSizeGuide();
    }

    return false;
  }

  window.openSizeGuideModal = function (event) {
    var opener =
      event && event.currentTarget && event.currentTarget.nodeType === 1
        ? event.currentTarget
        : null;
    openSizeGuideModal(opener);
    return false;
  };

  window.handleSizeGuideClick = handleSizeGuideClick;

  window.closeSizeGuideModal = function () {
    closeSizeGuideModal();
    return false;
  };

  class Modal extends HTMLElement {
    open() {
      openSizeGuideModal();
    }

    close() {
      closeSizeGuideModal();
    }
  }

  if (!customElements.get('s-modal')) {
    customElements.define('s-modal', Modal);
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var opener = target.closest(
      '.wrap-text-next-to-wair-button, .size-guide-modal__trigger'
    );
    if (opener) {
      event.preventDefault();
      handleSizeGuideClick({ currentTarget: opener });
      return;
    }

    if (target.closest('[js-close-size-guide]')) {
      event.preventDefault();
      closeSizeGuideModal();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' || event.code === 'Escape') {
      closeSizeGuideModal();
    }
  });
})();

/**
 * Mobile Navigation Script
 * ------------------------------------------------------------------------------
 */

theme.MobileNav = (function() {
	var selectors = {
		mobileNavDrawer: '#mobile-nav-drawer'
	};
	var cache = {};

	function init() {
		cacheSelectors();
		initDrawer();
	}

	function cacheSelectors() {
		cache = {
			mobileNavDrawer: $(selectors.mobileNavDrawer)
		};
	}
	

	function initDrawer() {
		// Add required classes to HTML
		$('.js-drawer-open-left')
			.attr('aria-controls', 'mobile-nav-drawer')
			.attr('aria-expanded', 'false');

		theme.MobileNavDrawer = new theme.Drawers('mobile-nav-drawer', 'left');
	}

	return {
		init: init
	};
})();

window.CartUtils = window.CartUtils || {};

(function() {
  var _trapFocusHandlers = {};

  CartUtils.subscriptions = {
    subscribers: {},
    subscribe: function(eventName, callback) {
      if (this.subscribers[eventName] === undefined) {
        this.subscribers[eventName] = [];
      }
      this.subscribers[eventName] = this.subscribers[eventName].concat(callback);
      var self = this;
      return function unsubscribe() {
        self.subscribers[eventName] = self.subscribers[eventName].filter(function(cb) {
          return cb !== callback;
        });
      };
    },
    publish: function(eventName, data) {
      if (this.subscribers[eventName]) {
        this.subscribers[eventName].forEach(function(callback) {
          callback(data);
        });
      }
    }
  };

  CartUtils.a11y = {
    getFocusableElements: function(container) {
      return Array.from(container.querySelectorAll(
        "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      ));
    },
    trapFocus: function(container, elementToFocus) {
      elementToFocus = elementToFocus || container;
      var elements = this.getFocusableElements(container);
      var first = elements[0];
      var last = elements[elements.length - 1];
      this.removeTrapFocus();
      _trapFocusHandlers.focusin = function(event) {
        if (event.target !== container && event.target !== last && event.target !== first) return;
        document.addEventListener('keydown', _trapFocusHandlers.keydown);
      };
      _trapFocusHandlers.focusout = function() {
        document.removeEventListener('keydown', _trapFocusHandlers.keydown);
      };
      _trapFocusHandlers.keydown = function(event) {
        if (event.code.toUpperCase() !== 'TAB') return;
        if (event.target === last && !event.shiftKey) {
          event.preventDefault();
          first.focus();
        }
        if ((event.target === container || event.target === first) && event.shiftKey) {
          event.preventDefault();
          last.focus();
        }
      };
      document.addEventListener('focusout', _trapFocusHandlers.focusout);
      document.addEventListener('focusin', _trapFocusHandlers.focusin);
      elementToFocus.focus();
    },
    removeTrapFocus: function(elementToFocus) {
      document.removeEventListener('focusin', _trapFocusHandlers.focusin);
      document.removeEventListener('focusout', _trapFocusHandlers.focusout);
      document.removeEventListener('keydown', _trapFocusHandlers.keydown);
      if (elementToFocus) elementToFocus.focus();
    }
  };

  CartUtils.prepareTransition = function(element) {
    var clearTransitioning = function() {
      element.classList.remove('is-transitioning');
      if (element._transitionEndHandler) {
        element.removeEventListener('transitionend', element._transitionEndHandler);
        element._transitionEndHandler = null;
      }
      clearTimeout(element._transitionTimeout);
      element._transitionTimeout = null;
    };

    if (element._transitionEndHandler) {
      element.removeEventListener('transitionend', element._transitionEndHandler);
    }

    element._transitionEndHandler = function(event) {
      if (event.target !== element) return;
      var property = event.propertyName || '';
      if (property !== 'transform' && property !== '-webkit-transform') return;
      clearTransitioning();
    };

    element.addEventListener('transitionend', element._transitionEndHandler);

    var props = ['transition-duration', '-moz-transition-duration', '-webkit-transition-duration', '-o-transition-duration'];
    var duration = 0;
    var computedStyles = getComputedStyle(element);
    props.forEach(function(prop) {
      if (!duration) duration = parseFloat(computedStyles.getPropertyValue(prop));
    });

    if (duration > 0) {
      element.classList.add('is-transitioning');
      element.offsetWidth;
      clearTimeout(element._transitionTimeout);
      element._transitionTimeout = setTimeout(clearTransitioning, duration * 1000 + 100);
    }
  };

  CartUtils.debounce = function(fn, wait) {
    var t;
    return function() {
      var args = arguments;
      var context = this;
      clearTimeout(t);
      t = setTimeout(function() {
        fn.apply(context, args);
      }, wait);
    };
  };
})();

/**
 * Focusable Widget Class
 * --------------------------------------------------------------
 * @summary High-level general Class for creating focusable widgets
 * (drawers, modals, etc). Provides css-based open/close/toggle
 * functionality, as well as programatically manipulation of the widget,
 * and handles a11y.
 *
 * @usage class widget extends FocusableWidget {...}
 *
 * @emits focusable-widget:open on document
 * @emits focusable-widget:close on document
 * @emits <config.name>:open on document
 * @emits <config.name>:close on document
 * @emits <#id>:open on document
 * @emits <#id>:close on document
 * @emits open on element
 * @emits close on element
 *
 * The following parameters are attributes that any children of FocusableWidget
 * element accepts
 * @param id - required
 * @param open - Query Selector to all the widget's open triggers
 * @param close - Query Selector to all the widget's close triggers
 * @param [open-class] - Optional class to add to widget when opened
 * @param [body-open-class] - Optional class to add to body when opened
 * @class
 */
var FocusableWidget = (function() {
  var prepareTransition = CartUtils.prepareTransition;
  var a11y = CartUtils.a11y;

  return class FocusableWidget extends HTMLElement {
    /**
     * Creates Focusable Widget
     * @param {Object} config - Configuration object
     * @param {String} config.name - widget name, used for classnames and for providing useful error messages
     * @param {String} config.background - query selector to widget background
     * @param {Array} [config.widgetOpenClasses] - optional classes to add to widget when opened
     * @param {Array} [config.bodyOpenClasses] - optional classes to add to body when widget is opened
     * @param {Object} [config.attributes] - optional attributes to add to element upon initialization.
     *                                       example: {'data-custom-attr': true }
     */
    constructor(config) {
      config = config || {};
      super();

      if (!config.name) throw new Error('Focusable Widget must have a name');
      if (!this.id) throw new Error(config.name + ' must have an id');
      if (!config.background) throw new Error('Focusable Widget(' + config.name + ') must have a background');

      /**
       * Save client config for reinit method
       * @private
       */
      this._clientConfig = config;

      this._init(config);
    }

    /**
     * Opens widget. If already opened, does nothing.
     * @usage document.querySelector('#CartDrawer').open()
     * @returns {HTMLElement} widget
     * @public
     */
    open() {
      if (this._isOpen) return;
      if (!this._opener) this._rememberOpener(document.activeElement);
      this._closeFocusableWidgets();
      return this.toggle();
    }

    /**
     * Closes widget. If already closed, does nothing.
     * @usage document.querySelector('#CartDrawer').close()
     * @returns {HTMLElement} widget
     * @public
     */
    close() {
      if (!this._isOpen) return;
      return this.toggle();
    }

    /**
     * Toggles widget.
     * @usage document.querySelector('#CartDrawer').toggle()
     * @returns {HTMLElement} widget
     * @public
     */
    toggle() {
      var self = this;
      var isClosing = this._isOpen;
      prepareTransition(this);

      function applyToggle() {
        self._toggleClasses();
        self._toggleAccessibilityAttributes();
        self._afterToggleClasses();
      }

      if (isClosing) {
        requestAnimationFrame(applyToggle);
      } else {
        requestAnimationFrame(function() {
          requestAnimationFrame(applyToggle);
        });
      }

      return this;
    }

    _afterToggleClasses() {

      if (!this._isOpen) {
        a11y.trapFocus(this);
        this._bindEvents();
        this._dispatchEvents(this._events.open, ['open']);
      } else {
        this._returnFocusToOpener();
        this._unbindEvents();
        this._dispatchEvents(this._events.close, ['close']);
      }

      this._isOpen = !this._isOpen;
    }

    /**
     * Reinitializes the widget
     * @usage document.querySelector('#CartDrawer').reinitWidget()
     * @public
     */
    reinitWidget() {
      this._init(this._clientConfig);
    }

    /**
     * @usage const open = document.querySelector('#CartDrawer').isOpen;
     * @type {Boolean}
     * @public
     */
    get isOpen() {
      return this._isOpen;
    }

    // ======================================================== PRIVATE METHODS

    /**
     * Initializes entire logic and state
     * @param {Object} config - constructor config param
     * @private
     */
    _init(config) {
      var name = config.name;
      var background = config.background;
      var widgetOpenClasses = config.widgetOpenClasses || [];
      var bodyOpenClasses = config.bodyOpenClasses || [];
      var attributes = config.attributes || {};

      /** @type {String} @private */
      this._name = name;

      /** @type {Boolean} @private */
      this._isOpen = false;

      /** @type {HTMLElement|null} @private */
      this._opener = null;

      /**
       * @property {String} background - widget background selector
       * @property {String} open - selector to all open triggers
       * @property {String} close - selector to all close triggers
       * @private
       */
      this._selectors = {
        background: background,
        open: this.getAttribute('open'),
        close: this.getAttribute('close')
      };

      /**
       * Nodes the widget depends on
       * @property {HTMLElement} background - widget background
       * @private
       */
      this._nodes = {
        background: document.querySelector(this._selectors.background)
      };

      /**
       * Widget events fired on actions to document
       * @private
       */
      this._events = {
        open: ['focusable-widget:open', name + ':open', this.id + ':open'],
        close: ['focusable-widget:close', name + ':close', this.id + ':close']
      };

      /**
       * Private Widget configuration
       * @property {HTMLAllCollection} open - open triggers
       * @property {HTMLAllCollection} close - close triggers
       * @property {Array} attributes - attributes added to widget upon initialization
       * @property {Array} widgetOpenClasses - classes added to widget when opened
       * @property {String} bodyOpenClasses - classes added to body when widget opened
       * @private
       */
      this._config = {
        open: document.querySelectorAll(this._selectors.open),
        close: document.querySelectorAll(this._selectors.close),
        attributes: Object.assign({
          'data-focusable-widget': 'true',
          'aria-hidden': 'true',
          tabindex: 0
        }, attributes),
        widgetOpenClasses: ['open', this.getAttribute('open-class')].concat(widgetOpenClasses),
        bodyOpenClasses: [
          'js-focusable-widget-open',
          'js-' + name + '-open',
          this.getAttribute('body-open-class')
        ].concat(bodyOpenClasses)
      };

      this._validateConfig();
      this._addAccessibilityAttributes();
      this._setupListeners();
    }

    /**
     * Validates widget config, throwing useful errors if invalid
     * @private
     */
    _validateConfig() {
      if (!this._config.open || !this._config.open.length) {
        console.warn('WARN: ' + this._name + ': no open triggers found. Check your ' + this._name + ' \'open\' attribute, or add a trigger (if needed)');
      }
      if (!this._config.close || !this._config.close.length) {
        throw new Error(this._name + ': invalid close trigger selector, no elements found. Check your ' + this._name + ' \'close\' attribute');
      }
    }

    /**
     * Setups initialization event listeners
     * @private
     */
    _setupListeners() {
      var self = this;
      this._config.open.forEach(function(open) {
        open.addEventListener('click', self._open.bind(self));
      });
      this._config.close.forEach(function(close) {
        close.addEventListener('click', self._close.bind(self));
      });
      this.addEventListener('click', function(e) { e.stopPropagation(); });
    }

    _rememberOpener(element) {
      if (!this._isFocusableOpener(element)) return;
      this._opener = element;
    }

    _isFocusableOpener(element) {
      if (!element || typeof element.focus !== 'function') return false;
      if (element === document.body || element === document.documentElement) return false;
      if (!document.contains(element) || this.contains(element)) return false;
      var style = window.getComputedStyle(element);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
      return element.getClientRects().length > 0;
    }

    _getFocusReturnElement() {
      if (this._isFocusableOpener(this._opener)) return this._opener;
      var triggers = this._selectors.open ? document.querySelectorAll(this._selectors.open) : [];
      for (var i = 0; i < triggers.length; i++) {
        if (this._isFocusableOpener(triggers[i])) return triggers[i];
      }
      return null;
    }

    _returnFocusToOpener() {
      var opener = this._getFocusReturnElement();
      this._opener = null;
      a11y.removeTrapFocus();
      if (this.contains(document.activeElement)) {
        document.activeElement.blur();
      }
      if (!opener) return;
      requestAnimationFrame(function() {
        opener.focus();
      });
    }

    /**
     * Internal open wrapper, to keep our public methods clean, internally deals with event object
     * @param {object} event
     * @private
     */
    _open(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
        this._rememberOpener(event.currentTarget);
      }
      this.open();
    }

    /**
     * Internal close wrapper, to keep our public methods clean, internally deals with event object
     * @param {object} event
     * @private
     */
    _close(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      this.close();
    }

    /**
     * Closes any open focusable widgets
     * @private
     */
    _closeFocusableWidgets() {
      document.querySelectorAll('[data-focusable-widget].open').forEach(function(widget) {
        widget.close();
      });
    }

    /**
     * Dispatches an array of custom events on document
     * @param {Array} globalEvents - this._events.<event>
     * @param {Array} elementEvents - events to dispatch on the element
     * @private
     */
    _dispatchEvents(globalEvents, elementEvents) {
      globalEvents.forEach(function(e) {
        document.dispatchEvent(new CustomEvent(e));
      });
      if (elementEvents && elementEvents.length) {
        var self = this;
        elementEvents.forEach(function(e) {
          self.dispatchEvent(new CustomEvent(e));
        });
      }
    }

    /**
     * Binds events needed for opened widget
     * @private
     * @note Backdrop click is deferred so the same click that opened the drawer
     *       does not immediately close it (see theme.Drawers open + stopPropagation pattern).
     */
    _bindEvents() {
      var self = this;
      this._boundClose = this._onBackgroundClose.bind(this);
      this._boundKeyUp = this._onKeyUp.bind(this);
      this._boundTouchMove = this._onTouchMove.bind(this);
      document.addEventListener('keyup', this._boundKeyUp);
      if (this._nodes.background) {
        clearTimeout(this._backdropBindTimeout);
        this._backdropBindTimeout = setTimeout(function() {
          if (!self.isOpen || !self._nodes.background) return;
          self._nodes.background.addEventListener('click', self._boundClose);
          self._nodes.background.addEventListener('touchmove', self._boundTouchMove);
        }, 300);
      }
    }

    /**
     * Closes widget when backdrop is clicked, ignoring clicks from open triggers
     * @param {object} event
     * @private
     */
    _onBackgroundClose(event) {
      if (event && this._config.open) {
        for (var i = 0; i < this._config.open.length; i++) {
          if (this._config.open[i].contains(event.target)) return;
        }
      }
      this._close(event);
    }

    /**
     * Unbinds events added when widget was opened
     * @private
     */
    _unbindEvents() {
      clearTimeout(this._backdropBindTimeout);
      document.removeEventListener('keyup', this._boundKeyUp);
      if (this._nodes.background) {
        this._nodes.background.removeEventListener('click', this._boundClose);
        this._nodes.background.removeEventListener('touchmove', this._boundTouchMove);
      }
    }

    /**
     * Toggles classes based on current widget state
     * @private
     */
    _toggleClasses() {
      var self = this;
      if (this._isOpen) {
        // Body classes
        this._config.bodyOpenClasses.forEach(function(className) {
          if (!className) return;
          document.body.classList.remove(className);
        });

        // Widget Classes
        this._config.widgetOpenClasses.forEach(function(className) {
          if (!className) return;
          self.classList.remove(className);
        });
      } else {
        // Body classes
        this._config.bodyOpenClasses.forEach(function(className) {
          if (!className) return;
          document.body.classList.add(className);
        });

        // Widget Classes
        this._config.widgetOpenClasses.forEach(function(className) {
          if (!className) return;
          self.classList.add(className);
        });
      }
    }

    /**
     * Toggles a11y attributes based on current widget state
     * @private
     */
    _toggleAccessibilityAttributes() {
      if (this._isOpen) {
        this.setAttribute('aria-hidden', 'true');
        this.setAttribute('tabindex', '-1');
        this._config.open.forEach(function(open) { open.setAttribute('aria-expanded', 'false'); });
        this._config.close.forEach(function(close) { close.setAttribute('aria-expanded', 'false'); });
      } else {
        this.setAttribute('aria-hidden', 'false');
        this.setAttribute('tabindex', '0');
        this._config.open.forEach(function(open) { open.setAttribute('aria-expanded', 'true'); });
        this._config.close.forEach(function(close) { close.setAttribute('aria-expanded', 'true'); });
      }
    }

    /**
     * Adds a11y attributes to widget and triggers
     * @private
     */
    _addAccessibilityAttributes() {
      var self = this;
      var addA11yAttributes = function(el) {
        el.setAttribute('tabindex', '0');
        el.setAttribute('aria-expanded', 'false');
        el.setAttribute('aria-controls', self.id);
      };

      for (var attr in this._config.attributes) {
        this.setAttribute(attr, this._config.attributes[attr]);
      }
      this._config.open.forEach(addA11yAttributes);
      this._config.close.forEach(addA11yAttributes);
    }

    /**
     * Closes widget on esc key press
     * @param {object} event
     * @private
     */
    _onKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.close();
    }

    /**
     * Lock scrolling on mobile
     * @returns {Boolean}
     * @private
     */
    _onTouchMove() {
      return false;
    }
  };
})();

/**
 * Drawer Component
 * --------------------------------------------------------------------
 * @summary drawer custom element component, must have an id, position and
 * specified open/close triggers. There must be a close trigger inside
 * the drawer container.
 *
 * See parent focusable-widget.js events and public methods for complete documentation.
 *
 * @usage <s-drawer id="MyDrawer" position="left" open="[open-my-drawer]" close="[close-my-drawer]">CONTENT</s-drawer>
 * @usage to manipulate programatically: document.querySelector('#MyDrawer').open();
 *
 * @emits drawer:open on document
 * @emits drawer:close on document
 * @emits <#id>:open on document
 * @emits <#id>:close on document
 * @emits open on element
 * @emits close on element
 *
 * The following parameters are attributes that the <s-drawer> element takes
 * @param id - required
 * @param position - 'left', 'right', 'top', 'bottom'
 * @param open - Query Selector to all the drawer's open triggers
 * @param close - Query Selector to all the drawer's close triggers
 * @param [open-class] - Optional class to add to drawer when opened
 * @param [body-open-class] - Optional class to add to body when opened
 * @module
 *
 * If you must extend the drawer's functionality, use inheritance:
 * class Ajaxcart extends Drawer {...}
 */
var Drawer = (function() {
  /**
   * @extends FocusableWidget
   */
  return class Drawer extends FocusableWidget {
    constructor() {
      super({
        name: 'drawer',
        background: '.drawer-background'
      });

      var position = this.getAttribute('position');
      if (!position) throw new Error('drawer must have position attribute');

      /** @type {string} @private */
      this._position = position;

      // Add position class to body when drawer opens
      this._config.bodyOpenClasses.push('js-drawer-' + position + '-open');

      // Legacy theme CSS (drawers.scss, site-header.scss) expects js-drawer-open-{position}
      this._config.bodyOpenClasses.push('js-drawer-open-' + position);

      // This makes it persist if the widget gets re-initialized
      this._clientConfig.bodyOpenClasses = [
        'js-drawer-' + position + '-open',
        'js-drawer-open-' + position
      ];
    }

    /**
     * Drawer position: 'top', 'right', 'bottom', 'left'
     * @usage const position = document.querySelector('#CartDrawer').position;
     * @type {string}
     * @public
     */
    get position() {
      return this._position;
    }
  };
})();

if (!customElements.get('s-drawer')) {
  customElements.define('s-drawer', Drawer);
}

var QuantityInput = (function() {
  return class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');
      this.changeEvent = new Event('change', { bubbles: true });
      var self = this;
      this.querySelectorAll('button').forEach(function(button) {
        button.addEventListener('click', self.onButtonClick.bind(self));
      });
    }

    onButtonClick(event) {
      event.preventDefault();
      if (!this.input) return;

      var previousValue = this.input.value;
      var step = parseInt(this.input.step, 10) || 1;
      var current = parseInt(this.input.value, 10) || 0;
      var min = parseInt(this.input.min, 10);
      var max = parseInt(this.input.max, 10);
      var next = event.currentTarget.name === 'plus' ? current + step : current - step;

      if (!isNaN(min)) next = Math.max(min, next);
      if (!isNaN(max)) next = Math.min(max, next);

      this.input.value = next;

      if (previousValue !== this.input.value) {
        this.input.dispatchEvent(this.changeEvent);
      }
    }
  };
})();

if (!customElements.get('quantity-input')) {
  customElements.define('quantity-input', QuantityInput);
}

var LoadingSpinner = (function() {
  return class LoadingSpinner extends HTMLElement {
    constructor() {
      super();
      var html = '<style>' +
        ':host { display: none; position: absolute; top: 0; right: 0; bottom: 0; left: 0; width: 100%; height: 100%; justify-content: center; align-items: center; }' +
        ':host([loading]) { display: flex; }' +
        '.background { position: absolute; inset: 0; width: 100%; height: 100%; background: var(--background, transparent); opacity: var(--bg-opacity, 0.5); z-index: 1; }' +
        '.loading-spinner { display: flex; justify-content: center; align-items: center; position: absolute; width: var(--width, 20px); height: var(--height, 20px); color: var(--color, black); z-index: 2; animation: seed-loading-spinner 1s linear infinite; }' +
        '.loading-spinner svg { fill: currentColor; width: 100%; }' +
        '@keyframes seed-loading-spinner { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }' +
        '</style>' +
        '<div class="background"></div>' +
        '<div class="loading-spinner"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 145 145"><path d="M72.5,145C32.6,145,.07,112.54,0,72.64H5c.07,37.14,30.35,67.36,67.5,67.36s67.5-30.28,67.5-67.5S109.72,5,72.5,5V0c39.98,0,72.5,32.52,72.5,72.5s-32.52,72.5-72.5,72.5Z" /></svg></div>';
      var template = document.createElement('template');
      template.innerHTML = html;
      this.attachShadow({ mode: 'open' });
      this.shadowRoot.appendChild(template.content.cloneNode(true));
    }
  };
})();

if (!customElements.get('loading-spinner')) {
  customElements.define('loading-spinner', LoadingSpinner);
}

var debounce = CartUtils.debounce;
var subscriptions = CartUtils.subscriptions;
var a11y = CartUtils.a11y;

function getCartSectionIds(sections) {
  var ids = sections.map(function(section) {
    return section.section || section.id;
  });
  return ids.filter(function(id, index) {
    return ids.indexOf(id) === index;
  });
}

function getSectionRenderTarget(section) {
  if (section.documentTarget) {
    return document.querySelector(section.selector);
  }
  var root = document.getElementById(section.id);
  if (!root) return null;
  if (!section.selector) return root;
  return root.querySelector(section.selector) || root;
}

function renderSectionTargets(sections, sectionsHtml, getSectionInnerHTML) {
  sections.forEach(function(section) {
    var sectionKey = section.section || section.id;
    if (!sectionsHtml || !sectionsHtml[sectionKey]) return;
    var html = getSectionInnerHTML(sectionsHtml[sectionKey], section.selector);

    if (section.id === 'cart-count' || section.section === 'cart-count') {
      var countTargets = document.querySelectorAll('.cart-count');
      if (countTargets.length) {
        countTargets.forEach(function(target) {
          target.innerHTML = html;
        });
        return;
      }
    }

    var target = getSectionRenderTarget(section);
    if (!target) return;
    target.innerHTML = html;
  });
}

function getSectionInnerHTML(html, selector) {
  var doc = new DOMParser().parseFromString(html, 'text/html');
  var el = doc.querySelector(selector || '.shopify-section');
  return el ? el.innerHTML : '';
}

function publishCartUpdate(event) {
  subscriptions.publish(window.PUB_SUB_EVENTS.cartUpdate, event);
}

var cartRecsRefreshTimer;

function resetCartRecsAnchor() {
  var container = document.getElementById('cart-recs-container');
  if (!container) return false;
  container.innerHTML = '<input type="hidden" id="cart-recs-anchor">';
  return true;
}

function normalizeCartRecColorLabels() {
  document.querySelectorAll('#cart-recs-container .rec_color span').forEach(function(span) {
    var text = span.textContent.trim();
    if (/^COLOR\s*:?\s*$/.test(text)) {
      span.textContent = /:\s*$/.test(text) ? 'Color:' : 'Color';
    }
  });
}

function scheduleCartRecColorLabelNormalize() {
  [100, 400, 900, 1600].forEach(function(delay) {
    setTimeout(normalizeCartRecColorLabels, delay);
  });
}

function initCartRecColorLabelObserver() {
  if (initCartRecColorLabelObserver.observer) return;

  var drawer = document.querySelector('#CartDrawer');
  if (!drawer) return;

  initCartRecColorLabelObserver.observer = new MutationObserver(function() {
    if (initCartRecColorLabelObserver.isNormalizing) return;
    initCartRecColorLabelObserver.isNormalizing = true;
    normalizeCartRecColorLabels();
    initCartRecColorLabelObserver.isNormalizing = false;
  });
  initCartRecColorLabelObserver.observer.observe(drawer, { childList: true, subtree: true });
}

function refreshCartDrawerRecommendations() {
  if (!resetCartRecsAnchor()) return;
  if (!(window.DY && typeof window.DY.API === 'function')) return;

  window.DY.API('callback', function() {
    window.DY.API('track_pageview');
    scheduleCartRecColorLabelNormalize();
  });
}

function scheduleCartDrawerRecommendationsRefresh(delay) {
  if (typeof delay !== 'number') {
    delay = 475;
  }

  if (cartRecsRefreshTimer) {
    clearTimeout(cartRecsRefreshTimer);
  }

  cartRecsRefreshTimer = setTimeout(function() {
    cartRecsRefreshTimer = null;
    refreshCartDrawerRecommendations();
  }, delay);
}

function initCartDrawerRecommendations() {
  if (initCartDrawerRecommendations.initialized) return;
  initCartDrawerRecommendations.initialized = true;

  initCartRecColorLabelObserver();

  function onCartDrawerOpen() {
    refreshCartDrawerRecommendations();
    scheduleCartDrawerRecommendationsRefresh();
    scheduleCartRecColorLabelNormalize();
  }

  document.addEventListener('CartDrawer:open', onCartDrawerOpen);

  var drawer = document.querySelector('#CartDrawer');
  if (drawer) {
    drawer.addEventListener('open', onCartDrawerOpen);
  }

  subscriptions.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function() {
    requestAnimationFrame(function() {
      refreshCartDrawerRecommendations();
      scheduleCartDrawerRecommendationsRefresh(150);
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCartDrawerRecommendations);
} else {
  initCartDrawerRecommendations();
}

function renderCartDrawerSections(sections, sectionsHtml) {
  renderSectionTargets(sections, sectionsHtml, getSectionInnerHTML);
  requestAnimationFrame(function() {
    refreshCartDrawerRecommendations();
    scheduleCartDrawerRecommendationsRefresh();
    if (typeof window.initQuickshopAfterCartUpdate === 'function') {
      window.initQuickshopAfterCartUpdate();
    }
    if (typeof window.addCustomBorderBlackToAjaxCart === 'function') {
      window.addCustomBorderBlackToAjaxCart();
    }
  });
}

var CartRemoveButton = (function() {
  return class CartRemoveButton extends HTMLElement {
    constructor() {
      super();
      var self = this;
      this.addEventListener('click', function(event) {
        event.preventDefault();
        var cartItems = self.closest('cart-items') || self.closest('cart-drawer-items');
        cartItems.updateQuantity(self.dataset.index, 0);
      });
    }
  };
})();

var CartItems = (function() {
  return class CartItems extends HTMLElement {
    constructor() {
      super();
      var self = this;
      var debouncedOnChange = debounce(function(event) {
        self.onChange(event);
      }, 300);
      this.addEventListener('change', debouncedOnChange.bind(this));
    }

    connectedCallback() {
      var self = this;
      this.cartUpdateUnsubscriber = subscriptions.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function(event) {
        if (event.source === 'cart-items') return;
        self.onCartUpdate();
      });
    }

    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
    }

    onChange(event) {
      this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
    }

    onCartUpdate() {
      fetch(window.routes.cart_url + '?section_id=cart__main')
        .then(function(response) { return response.text(); })
        .then(function(responseText) {
          var html = new DOMParser().parseFromString(responseText, 'text/html');
          var sourceQty = html.querySelector('cart-items');
          if (sourceQty) this.innerHTML = sourceQty.innerHTML;
        }.bind(this))
        .catch(function(e) { console.error(e); });
    }

    getSectionsToRender() {
      var cartPage = document.getElementById('CartPage-CartItems');
      if (!cartPage) return [];
      return [{
        id: 'CartPage-CartItems',
        section: cartPage.dataset.id,
        selector: '[js-cart-page-contents]'
      }];
    }

    updateQuantity(line, quantity, name) {
      var self = this;
      this.enableLoading(line);
      var sections = this.getSectionsToRender();
      var body = JSON.stringify({
        line: line,
        quantity: quantity,
        sections: getCartSectionIds(sections),
        sections_url: window.location.pathname
      });

      fetch(window.routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: body
      })
        .then(function(response) { return response.text(); })
        .then(function(state) {
          var parsedState = JSON.parse(state);
          var quantityElement = document.getElementById('Quantity-' + line) || document.getElementById('Drawer-quantity-' + line);
          var items = document.querySelectorAll('[js-cart-item]');

          if (parsedState.errors) {
            quantityElement.value = quantityElement.getAttribute('value');
            self.updateLiveRegions(line, parsedState.errors);
            return;
          }

          var cartDrawerWrapper = document.querySelector('cart-drawer');
          renderSectionTargets(self.getSectionsToRender(), parsedState.sections, getSectionInnerHTML);

          var updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
          var message = '';
          if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value, 10)) {
            message = typeof updatedValue === 'undefined'
              ? 'There was an error while updating your cart. Please try again.'
              : 'You can only add ' + updatedValue + ' of this item to your cart.';
          }
          self.updateLiveRegions(line, message);

          var lineItem = document.getElementById('CartItem-' + line) || document.getElementById('CartDrawer-Item-' + line);
          if (lineItem && lineItem.querySelector('[name="' + name + '"]')) {
            if (cartDrawerWrapper) {
              a11y.trapFocus(cartDrawerWrapper, lineItem.querySelector('[name="' + name + '"]'));
            } else {
              lineItem.querySelector('[name="' + name + '"]').focus();
            }
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            a11y.trapFocus(
              cartDrawerWrapper.querySelector('[js-empty-cart]'),
              cartDrawerWrapper.querySelector('[js-cart-continue-link]')
            );
          } else if (document.querySelector('[js-cart-item]') && cartDrawerWrapper) {
            a11y.trapFocus(cartDrawerWrapper, document.querySelector('[js-cart-item-image]'));
          }

          publishCartUpdate({ source: 'cart-items', sections: parsedState.sections });
        })
        .catch(function(error) {
          console.log(error);
          self.querySelectorAll('.loading-overlay').forEach(function(overlay) {
            overlay.classList.add('hidden');
          });
          var errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
          if (errors) errors.textContent = 'There was an error while updating your cart. Please try again.';
        })
        .finally(function() {
          self.disableLoading(line);
        });
    }

    updateLiveRegions(line, message) {
      var lineItemError = document.getElementById('Line-item-error-' + line) || document.getElementById('CartDrawer-LineItemError-' + line);
      if (lineItemError) lineItemError.innerHTML = message;
    }

    getSectionInnerHTML(html, selector) {
      return getSectionInnerHTML(html, selector);
    }

    enableLoading(line) {
      var mainCartItems = document.getElementById('CartPage-CartItems') || document.getElementById('CartDrawer-CartItems');
      if (mainCartItems) mainCartItems.classList.add('cart__items--disabled');
      this.querySelectorAll('#CartItem-' + line + ' loading-spinner, #CartDrawer-Item-' + line + ' loading-spinner').forEach(function(spinner) {
        spinner.setAttribute('loading', '');
      });
      document.activeElement.blur();
    }

    disableLoading(line) {
      var mainCartItems = document.getElementById('CartPage-CartItems') || document.getElementById('CartDrawer-CartItems');
      if (mainCartItems) mainCartItems.classList.remove('cart__items--disabled');
      this.querySelectorAll('#CartItem-' + line + ' loading-spinner, #CartDrawer-Item-' + line + ' loading-spinner').forEach(function(spinner) {
        spinner.removeAttribute('loading');
      });
    }
  };
})();

var CartNote = (function() {
  return class CartNote extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', debounce(function(event) {
        fetch(window.routes.cart_update_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: event.target.value })
        });
      }, 500));
    }
  };
})();

var CartDrawer = (function() {
  var drawerHeaderSection = { id: 'cart', selector: '[js-cart-drawer-header]', documentTarget: true };

  return class CartDrawer extends HTMLElement {
    connectedCallback() {
      var openCart = new URLSearchParams(window.location.search).get('viewcart');
      this.cartDrawer = document.querySelector('#CartDrawer');
      if (openCart === 'true' && this.cartDrawer) {
        this.cartDrawer.open();
      }

      var self = this;
      this._cartUpdateUnsubscriber = subscriptions.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function(event) {
        if (!event || !event.sections) return;
        self.refreshDrawerHeader(event.sections);
      });
    }

    disconnectedCallback() {
      if (this._cartUpdateUnsubscriber) this._cartUpdateUnsubscriber();
    }

    refreshDrawerHeader(sectionsHtml) {
      renderSectionTargets([drawerHeaderSection], sectionsHtml, getSectionInnerHTML);
    }

    renderContents(parsedState) {
      renderCartDrawerSections(this.getSectionsToRender(), parsedState.sections);
    }

    refreshSections() {
      var self = this;
      return fetch(window.location.pathname + '?sections=' + getCartSectionIds(this.getSectionsToRender()).join(','))
        .then(function(response) { return response.json(); })
        .then(function(sections) {
          self.renderContents({ sections: sections });
          return sections;
        });
    }

    getSectionInnerHTML(html, selector) {
      selector = selector || '.shopify-section';
      return getSectionInnerHTML(html, selector);
    }

    getSectionsToRender() {
      return [
        { id: 'cart', selector: '[js-cart-drawer-header]', documentTarget: true },
        { id: 'cart', selector: '[js-cart-drawer-contents]', documentTarget: true },
        { id: 'cart-count', selector: '.shopify-section' }
      ];
    }

    setActiveElement(element) {
      this.activeElement = element;
    }
  };
})();

var CartDrawerItems = (function() {
  return class CartDrawerItems extends CartItems {
    onCartUpdate() {
      // cart-drawer listens for cartUpdate and refreshes [js-cart-drawer-header].
    }

    getSectionsToRender() {
      return [
        { id: 'cart', section: 'cart', selector: '[js-cart-drawer-header]', documentTarget: true },
        { id: 'cart', section: 'cart', selector: '[js-cart-drawer-contents]', documentTarget: true },
        { id: 'cart-count', section: 'cart-count', selector: '.shopify-section' }
      ];
    }

    updateQuantity(line, quantity, name) {
      var self = this;
      this.enableLoading(line);
      var body = JSON.stringify({
        line: line,
        quantity: quantity,
        sections: getCartSectionIds(this.getSectionsToRender()),
        sections_url: window.location.pathname
      });

      fetch(window.routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: body
      })
        .then(function(response) { return response.text(); })
        .then(function(state) {
          var parsedState = JSON.parse(state);
          var quantityElement = document.getElementById('Drawer-quantity-' + line);
          var items = document.querySelectorAll('[js-cart-item]');

          if (parsedState.errors) {
            if (quantityElement) quantityElement.value = quantityElement.getAttribute('value');
            self.updateLiveRegions(line, parsedState.errors);
            return;
          }

          var cartDrawerWrapper = document.querySelector('cart-drawer');
          renderCartDrawerSections(self.getSectionsToRender(), parsedState.sections);

          var updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
          var message = '';
          if (quantityElement && items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value, 10)) {
            message = typeof updatedValue === 'undefined'
              ? 'There was an error while updating your cart. Please try again.'
              : 'You can only add ' + updatedValue + ' of this item to your cart.';
          }
          self.updateLiveRegions(line, message);

          if (parsedState.item_count === 0 && cartDrawerWrapper) {
            a11y.trapFocus(
              cartDrawerWrapper.querySelector('[js-empty-cart]'),
              cartDrawerWrapper.querySelector('[js-cart-continue-link]')
            );
          }

          publishCartUpdate({ source: 'cart-items', sections: parsedState.sections });
        })
        .catch(function(error) {
          console.log(error);
          var errors = document.getElementById('CartDrawer-CartErrors');
          if (errors) errors.textContent = 'There was an error while updating your cart. Please try again.';
        })
        .finally(function() {
          self.disableLoading(line);
        });
    }
  };
})();

if (!customElements.get('cart-remove-button')) customElements.define('cart-remove-button', CartRemoveButton);
if (!customElements.get('cart-items')) customElements.define('cart-items', CartItems);
if (!customElements.get('cart-note')) customElements.define('cart-note', CartNote);
if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);
if (!customElements.get('cart-drawer-items')) customElements.define('cart-drawer-items', CartDrawerItems);

// ATC → cart-open timing. Start only after client-side validation so a
// failed size/form check cannot leave a pending timer for the next attempt.
// See https://developer.mozilla.org/en-US/docs/Web/API/console/time_static
var ATC_TO_CART_OPEN_TIMER = 'add-to-cart-to-drawer-open';
var atcTimerPending = false;

function endAtcToCartOpenTimer() {
  if (!atcTimerPending) return;
  atcTimerPending = false;
  console.timeEnd(ATC_TO_CART_OPEN_TIMER);
  console.log('cart open');
}

function cancelAtcToCartOpenTimer() {
  if (!atcTimerPending) return;
  atcTimerPending = false;
  console.timeEnd(ATC_TO_CART_OPEN_TIMER);
}

function startAtcToCartOpenTimer() {
  if (atcTimerPending) {
    console.timeEnd(ATC_TO_CART_OPEN_TIMER);
  }
  atcTimerPending = true;
  console.log('atc button clicked');
  console.time(ATC_TO_CART_OPEN_TIMER);
}

document.addEventListener('CartDrawer:open', endAtcToCartOpenTimer);

var ProductMain = (function() {
  var subscriptions = CartUtils.subscriptions;

  return class ProductMain extends HTMLElement {
    constructor() {
      super();
      this._selectors = {
        addToCart: '[js-add-to-cart], .product-form__cart-submit',
        error: '[js-error-message]',
        form: '[js-product-form], .product-form'
      };
    }

    connectedCallback() {
      this.buttons = this.querySelectorAll(this._selectors.addToCart);
      this._initProductForm();
      this.addEventListener('click', this.onAddToCartClick.bind(this));
    }

    _initProductForm() {
      this.form = this.querySelector(this._selectors.form);
      if (!this.form) return;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-drawer');
      this.cartDrawer = document.querySelector('#CartDrawer');
    }

    _formNeedsSizeOrAmountSelection() {
      if (!this.form || !this.form.querySelector) return false;

      var giftInputs = this.form.querySelectorAll('.input-gift_card');
      if (giftInputs.length) {
        return !this.form.querySelector('.input-gift_card:checked');
      }

      var sizeSection = this.form.querySelector('.swatch-selection.size-selection');
      if (!sizeSection) return false;
      return !sizeSection.querySelector('input:checked');
    }

    _selectionErrorMessage() {
      if (this.form && this.form.querySelectorAll('.input-gift_card').length) {
        return 'Please select an amount.';
      }
      return 'Please select a size.';
    }

    onAddToCartClick(evt) {
      var inAtcControl = evt.target && evt.target.closest
        ? evt.target.closest(this._selectors.addToCart + ', .wrap_add-to-bag_button, #add-to-cart-button')
        : null;
      if (!inAtcControl) return;
      if (!this._formNeedsSizeOrAmountSelection()) return;
      evt.preventDefault();
      if (typeof evt.stopImmediatePropagation === 'function') {
        evt.stopImmediatePropagation();
      }
      cancelAtcToCartOpenTimer();
      ajaxCart.setAddToCartIconState('idle');
      this.handleErrorMessage(this._selectionErrorMessage());
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (typeof evt.stopImmediatePropagation === 'function') {
        evt.stopImmediatePropagation();
      }
      this.handleErrorMessage();

      if (this._formNeedsSizeOrAmountSelection()) {
        cancelAtcToCartOpenTimer();
        ajaxCart.setAddToCartIconState('idle');
        this.handleErrorMessage(this._selectionErrorMessage());
        return;
      }

      if (typeof this.form.checkValidity === 'function' && !this.form.checkValidity()) {
        cancelAtcToCartOpenTimer();
        ajaxCart.setAddToCartIconState('idle');
        if (typeof this.form.reportValidity === 'function') this.form.reportValidity();
        return;
      }

      startAtcToCartOpenTimer();
      ajaxCart.setAddToCartIconState('adding');
      this._disableButtons();
      ShopifyAPI.pushAddToCartDataLayer(this.form);

      var config = {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }
      };
      var formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', getCartSectionIds(this.cart.getSectionsToRender()).join(','));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(window.routes.cart_add_url, config)
        .then(function(response) { return response.json(); })
        .then(function(response) {
          if (response.status) {
            var errorMessage = ShopifyAPI.getCartErrorMessage(response);
            subscriptions.publish(window.PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message
            });
            ShopifyAPI.notifyItemError(response, 'error');
            cancelAtcToCartOpenTimer();
            ajaxCart.setAddToCartIconState('idle');
            this.handleErrorMessage(errorMessage);
            this.error = true;
            return;
          }
          if (!this.cart) {
            cancelAtcToCartOpenTimer();
            ShopifyAPI.notifyItemAdded(response, this.form);
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          ajaxCart.setAddToCartIconState('added');
          ShopifyAPI.notifyItemAdded(response, this.form);
          subscriptions.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            sections: response.sections
          });
          this.cart.renderContents(response);
          if (this.cartDrawer) {
            if (this.cartDrawer._isOpen) endAtcToCartOpenTimer();
            this.cartDrawer.open();
          }
        }.bind(this))
        .catch(function(e) {
          console.error(e);
          ShopifyAPI.notifyItemError(e, 'error');
          cancelAtcToCartOpenTimer();
          ajaxCart.setAddToCartIconState('idle');
          this.handleErrorMessage('There was an error while adding this item to your cart. Please try again.');
        }.bind(this))
        .finally(function() {
          this._enableButtons();
        }.bind(this));
    }

    handleErrorMessage(errorMessage) {
      this.errorMessageWrapper = this.querySelector(this._selectors.error);
      if (!this.errorMessageWrapper) return;
      if (errorMessage) {
        this.errorMessageWrapper.textContent = errorMessage;
        this.errorMessageWrapper.classList.remove('hidden');
        this.errorMessageWrapper.removeAttribute('hidden');
        if (typeof this.errorMessageWrapper.focus === 'function') {
          this.errorMessageWrapper.focus();
        }
      } else {
        this.errorMessageWrapper.textContent = '';
        this.errorMessageWrapper.classList.add('hidden');
        this.errorMessageWrapper.setAttribute('hidden', '');
      }
    }

    _disableButtons() {
      this.buttons.forEach(function(button) {
        button.setAttribute('disabled', '');
        var loader = button.querySelector('loading-spinner');
        if (loader) loader.setAttribute('loading', '');
      });
    }

    _enableButtons() {
      this.buttons.forEach(function(button) {
        button.removeAttribute('disabled');
        var loader = button.querySelector('loading-spinner');
        if (loader) loader.removeAttribute('loading');
      });
    }
  };
})();

if (!customElements.get('s-product')) {
  customElements.define('s-product', ProductMain);
}

/*============================================================================
  Cart Confirmation Popup
  Replaces slide cart with confirmation popup after add to cart.
==============================================================================*/
theme.CartConfirmationPopup = (function() {
  'use strict';
  /*global theme, slate, jQuery */

  var selectors = {
    popup: '#CartConfirmationPopup',
    close: '[js-ajaxcart-confirmation-close]',
    imageLink: '[js-ajaxcart-confirmation-image]',
    img: '[js-ajaxcart-confirmation-img]',
    title: '[js-ajaxcart-confirmation-title]',
    optionRow: '[js-ajaxcart-confirmation-option1], [js-ajaxcart-confirmation-option2], [js-ajaxcart-confirmation-option3]',
    qty: '[js-ajaxcart-confirmation-qty]',
    qtyLabel: '[js-ajaxcart-confirmation-qty-label]',
    qtyValue: '[js-ajaxcart-confirmation-qty-value]',
    price: '[js-ajaxcart-confirmation-price]',
    viewCartBtn: '.ajaxcart-confirmation__btn--primary',
    checkoutBtn: '.ajaxcart-confirmation__btn--secondary',
    cartCount: '[js-ajaxcart-confirmation-cart-count]'
  };

  var config = {
    autoCloseMs: 5000,
    trackingNavigationDelayMs: 200,
    noImageUrl: '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif'
  };

  var $popup, $imageLink, $img, $title, $price, $viewCartBtn, $checkoutBtn, $cartCount;
  var $qtyLabel, $qtyValue;
  var $optionRows = [];
  var _lastAddedItem = null;
  var _autoCloseTimer = null;
  var _variationClass = 'atc-confirmation-variation--1';

  /*============================================================================
    PRIVATE
  ==============================================================================*/
  function _setElements() {
    var $container = $popup;
    $imageLink = $container.find(selectors.imageLink);
    $img = $container.find(selectors.img);
    $title = $container.find(selectors.title);
    $price = $container.find(selectors.price);
    $viewCartBtn = $container.find(selectors.viewCartBtn);
    $checkoutBtn = $container.find(selectors.checkoutBtn);
    $cartCount = $container.find(selectors.cartCount);
    $qtyLabel = $container.find(selectors.qtyLabel);
    $qtyValue = $container.find(selectors.qtyValue);

    $optionRows = [];
    $container.find(selectors.optionRow).each(function() {
      var $row = $(this);
      $optionRows.push({
        $row: $row,
        $label: $row.find('.ajaxcart-confirmation__option-label'),
        $value: $row.find('.ajaxcart-confirmation__option-value')
      });
    });
  }

  function _eventListeners() {
    $popup.on('click', selectors.close, _close);
    $viewCartBtn.on('click', _viewCartClick);
    $checkoutBtn.on('click', _checkoutClick);

    var $content = $popup.find('.ajaxcart-confirmation__content');
    $content.on('mouseenter', _onPopupMouseEnter);
    $content.on('mouseleave', _onPopupMouseLeave);
  }

  function _isEnabled() {
    var hasBodyClass = document.body && document.body.classList.contains(_variationClass);
    var mainContent = document.getElementById('MainContent');
    var hasMainContentClass = mainContent && mainContent.classList.contains(_variationClass);
    return hasBodyClass || hasMainContentClass;
  }

  function _onPopupMouseEnter() {
    if (window.matchMedia && window.matchMedia('(min-width: 768px)').matches) {
      clearTimeout(_autoCloseTimer);
      _autoCloseTimer = null;
    }
  }

  function _onPopupMouseLeave() {
    if (window.matchMedia && window.matchMedia('(min-width: 768px)').matches && $popup && $popup.hasClass('is-visible')) {
      _autoCloseTimer = setTimeout(_close, config.autoCloseMs);
    }
  }

  /*============================================================================
    PRIVATE - ACTIONS
  ==============================================================================*/
  function _close() {
    if (!$popup || !$popup.length) return;

    clearTimeout(_autoCloseTimer);
    _autoCloseTimer = null;
    $popup.removeClass('is-visible');
    $popup.attr('aria-hidden', 'true');
  }

  function _trackEvent(eventName) {
    if (!window.DY || typeof window.DY.API !== 'function') return;

    DY.API('event', { name: eventName });
  }

  function _navigateWithTracking(url, eventName) {
    var hasDy = window.DY && typeof window.DY.API === 'function';

    if (hasDy) {
      _trackEvent(eventName);
    }

    _close();

    if (!hasDy) {
      window.location.href = url;
      return;
    }

    window.setTimeout(function() {
      window.location.href = url;
    }, config.trackingNavigationDelayMs);
  }

  function _viewCartClick(evt) {
    evt.preventDefault();
    _navigateWithTracking('/cart', 'ATC Modal View Bag Click');
  }

  function _checkoutClick(evt) {
    evt.preventDefault();
    _navigateWithTracking('/checkout', 'ATC Modal Checkout Click');
  }

  /*============================================================================
    PRIVATE - ITEM DATA
  ==============================================================================*/
  function _normalizeItem(item) {
    if (!item) return null;
    if (item.items && item.items.length) {
      return item.items[0];
    }
    return item;
  }

  function _getFromCart(item, cart) {
    if (!item || !cart || !cart.items || !cart.items.length) return item;

    var variantId = item.variant_id || item.id;
    var cartItem = null;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === variantId || cart.items[i].id === variantId) {
        cartItem = cart.items[i];
        break;
      }
    }

    if (!cartItem) return item;

    return $.extend({}, cartItem, {
      quantityAdded: item.quantityAdded != null ? item.quantityAdded : item.quantity
    });
  }

  function _displayData(item) {
    var handle = item.product_handle || item.handle || '';
    var imgSrc = item.image || (item.featured_image && item.featured_image.url) || '';
    var title = item.product_title || item.title || item.name || '';
    var price = item.price != null && item.price !== '' ? item.price : (item.final_price || item.discounted_price || item.original_price || item.line_price || 0);
    var qty = (item.quantityAdded != null ? parseInt(item.quantityAdded, 10) : parseInt(item.quantity, 10)) || 1;

    return {
      productUrl: handle ? '/products/' + handle : '/cart',
      imgSrc: imgSrc,
      title: title,
      price: price,
      quantity: qty
    };
  }

  function _imageUrl(imgUrl) {
    if (!imgUrl || typeof imgUrl !== 'string') return config.noImageUrl;
    imgUrl = String(imgUrl).trim();
    if (!imgUrl) return config.noImageUrl;
    if (imgUrl.indexOf('_small') === -1 && imgUrl.indexOf('_large') === -1 && imgUrl.indexOf('_medium') === -1) {
      imgUrl = imgUrl.replace(/(\.[^.]*)$/, '_large$1');
    }
    if (imgUrl.indexOf('http:') === 0) {
      imgUrl = imgUrl.replace('http:', '');
    }
    return imgUrl;
  }

  /*============================================================================
    PRIVATE - OPTION PAIRS
  ==============================================================================*/
  function _getPairs(opts) {
    var pairs = [];
    if (opts && opts.length) {
      opts.forEach(function(opt) {
        if (opt.name && opt.value) {
          pairs.push({ name: opt.name, value: opt.value });
        }
      });
    }
    return pairs;
  }

  function _setVariant(item, productOpts) {
    var pairs = [];
    var values = item.variant_options || [];

    values.forEach(function(val, i) {
      if (!val || val === 'Default Title') return;

      var name = (productOpts && productOpts[i]) ? productOpts[i] : '';
      pairs.push({ name: name, value: val });
    });

    return pairs;
  }

  function _getOptions(item, callback) {
    var pairs = _getPairs(item.options_with_values);

    if (pairs.length) {
      callback(pairs);
      return;
    }

    if (item.variant_title && item.variant_title !== 'Default Title') {
      callback([{ name: '', value: item.variant_title }]);
      return;
    }

    if (!item.variant_options || !item.variant_options.length) {
      callback([]);
      return;
    }

    var handle = item.product_handle || item.handle;
    if (!handle) {
      callback([]);
      return;
    }

    $.getJSON('/products/' + handle + '.json', function(data) {
      var productOpts = data.product && data.product.options;
      callback(_setVariant(item, productOpts));
    });
  }

  /*============================================================================
    PRIVATE - RENDER
  ==============================================================================*/
  function _setOption(row, pair) {
    if (pair && pair.value) {
      row.$label.text(pair.name ? pair.name + ':' : '');
      row.$value.text(pair.value);
      row.$row.show();
    } else {
      row.$row.hide();
    }
  }

  function _render(item, optionPairs, cart) {
    var data = _displayData(item);

    $imageLink.attr('href', data.productUrl);
    $img.attr('src', _imageUrl(data.imgSrc)).attr('alt', data.title);
    $title.attr('href', data.productUrl).text(data.title);
    $qtyLabel.text('Qty:');
    $qtyValue.text(data.quantity);
    $price.text(slate.Currency.formatMoney(data.price, theme.moneyFormat));

    $optionRows.forEach(function(row, i) {
      _setOption(row, optionPairs[i]);
    });

    if ($cartCount.length && cart && typeof cart.item_count !== 'undefined') {
      $cartCount.text(cart.item_count);
    }

    $popup.removeClass('is-visible').addClass('is-visible');
    $popup.attr('aria-hidden', 'false');

    clearTimeout(_autoCloseTimer);
    _autoCloseTimer = setTimeout(_close, config.autoCloseMs);
  }

  /*============================================================================
    PUBLIC
  ==============================================================================*/
  function init() {
    if (!_isEnabled()) return;

    $popup = $(selectors.popup);
    if (!$popup.length) return;

    _setElements();
    _eventListeners();
  }

  function show(item, cart) {
    if (!_isEnabled() || !$popup || !$popup.length) return;

    item = _normalizeItem(item);
    if (!item) return;

    item = _getFromCart(item, cart);

    _getOptions(item, function(optionPairs) {
      _render(item, optionPairs, cart);
    });
  }

  function setLastAddedItem(item) {
    _lastAddedItem = item;
  }

  function getLastAddedItem() {
    var item = _lastAddedItem;
    _lastAddedItem = null;
    return item;
  }

  return {
    init: init,
    show: show,
    setLastAddedItem: setLastAddedItem,
    getLastAddedItem: getLastAddedItem
  };
})();

jQuery(document).ready(function() {
  theme.CartConfirmationPopup.init();
});

theme.Accordion = (function(){
  var selectors = {
    header: '[js-accordion-header]',
    content: '[js-accordion-content]'
  }

function Accordion(container) {
    this.$container = $(container);
    this.$header = $(selectors.header, this.$container)
    this.$content = $(selectors.content, this.$container)

    this.$header.on('click', toggleAccordion.bind(this));

    function toggleAccordion(evt) {
      var $el = $(evt.currentTarget)
      if($el.attr('aria-expanded') == 'true'){
        //this stops the slide up triggering the parent;
        $el.siblings().slideUp(400, function() {
          $(this).attr('aria-hidden', true);
        })
        // This is closing the children accordions when the parent accordion is closed.
        $el.siblings(selectors.content).find(selectors.header).each(function(){
              $(this).attr('aria-expanded', false);
              $(this).siblings(selectors.content).slideUp(400, function() {
                  $(this).attr('aria-hidden', true);
              });
        })
        $el.attr('aria-expanded', false);
      } else {
        $el.parent().siblings().children(selectors.content , this.$container).slideUp(400, function(){
          $(this).attr('aria-hidden', true);
        });
        $el.parent().siblings().children(selectors.header , this.$container).attr('aria-expanded', false);
        $el.siblings(selectors.content).slideDown().attr('aria-hidden', false);
        $el.attr('aria-expanded', true);
      }
    }
  }

  return Accordion;
})();

document.addEventListener("DOMContentLoaded", function() {
  var $promoSlick = $("[js-promo-slick]");

  if ($promoSlick.length > 0) {
    var $autoplay = $promoSlick.attr("data-autoplay") === "true";
    var $speed = parseInt($promoSlick.attr("data-autoplay-speed")) * 1000 || 5000;

    if (typeof $.fn.slick === "function" && $promoSlick.children().length > 0) {
      $promoSlick.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: $autoplay,
        autoplaySpeed: $speed,
        arrows: $("body").hasClass("new-home-page-layout"),
        prevArrow: $promoSlick.find(".promo-bar__left-arrow"),
        nextArrow: $promoSlick.find(".promo-bar__right-arrow"),
        dots: false,
        fade: true
      });
    }
  }
});
theme.LoginToggle = (function(){
    var selectors = {
      accountButton: '[js-account-button]',
      accountDropdown: '[js-account-dropdown]',
      closeButton: '[js-account-close]'
    }
  
  function LoginToggle() {
    $(selectors.accountButton).on('click', function() {
        $(selectors.accountDropdown).toggle();
    })

    $(selectors.closeButton).on('click', function() {
      $(selectors.accountDropdown).hide();
    })
  }
  
  return LoginToggle;
  })();
if ($('.nav').hasClass('transparent')) {
  $(window).scroll(function () {
    if ($(window).scrollTop() >= 50) {
      $('.nav').removeClass('transparent');
    } else {
      $('.nav').addClass('transparent');
    }
  });


  function checkPosition() {
    if (window.matchMedia('(max-width: 786px)').matches) {
      $(".nav-main").addClass("nav--mobile");
    } else {
      $(".nav-main").addClass("nav--desktop");
    }
  }

  jQuery(function(){
    checkPosition();
  });
}
/**
* Swatches Script
* ------------------------------------------------------------------------------
*/

theme.swatches = (function() {
    if (!$('.swatch').length) {
      return;
    }

    initializeSwatchImageFallbacks();
   
    var $swatchInput = $('[data-swatch-input]');
    var namespace = '.swatch';
   
    $swatchInput.on('change' + namespace, updateSingleOptionSelector);
   
    function updateSingleOptionSelector(evt) {
      
      var $el = $(evt.currentTarget);
      var optionIndex = $el.closest('.swatch').attr('data-option-index');
      var optionProduct = $el.closest('.swatch').attr('data-option-product');
      var optionValue = $el.val();
      var selector = [
        "[data-single-option-selector]",
        "[data-option-index='option" + optionIndex + "']",
        "[data-product='" + optionProduct + "']"
      ].join('');
      $el.closest('form')
        .find(selector)
        .val(optionValue)
        .trigger('change');
      // Option 0 means it is color
      if (optionIndex == 0) {
        updateTextNearColorHeader($el);
      }
    }

    
    if ($('#SingleOptionSelector-0').length) {
      var $selected = $('#SingleOptionSelector-0').find("option:selected").val()
      $(".swatch-element[data-value='" + $selected + "'] input").prop("checked", true)
    }
    
    

    $('[js-swatch-label], .header').keypress( function( e ) {
        var $this = $(this);
          var code = e.keyCode || e.which;
          if( code === 13 ) {
            $this.trigger("click")
          }
    })

    function initializeSwatchImageFallbacks() {
      $('[js-swatch-label][data-primary-img]').each(function() {
        var label = this;
        var primary = label.getAttribute('data-primary-img');
        var fallback = label.getAttribute('data-fallback-img');

        if (!primary || !fallback || primary === fallback) {
          return;
        }

        var probe = new Image();
        probe.onerror = function() {
          label.style.backgroundImage = 'url(' + fallback + ')';
        };
        probe.src = primary;
      });
    }
})();


/* Add ' + ' symbol if there are more colors of the product than you need */
/* Besides PDP page and BS-filter widget */
var numbers_of_colors = 5
$(".homepage-featured-products .product-card, #z-supply-spring-2021-collection .product-card").each(function() {
  $(this).find(".swatch-element").each(function(index_color) {
    if (index_color < numbers_of_colors) {
    } else if (numbers_of_colors == index_color) {
      $(this).replaceWith('<a>+</a>');
    } else {
      $(this).remove();
    }
  });
});

function removeOldColorName() {
  $('.color-header').each(function() {
    $(this).find('.wrap_color_name').remove();
    $(this).text($(this).text().trim().replaceAll(":", ""));
  });
}

function textUpdator(id) {
  removeOldColorName();
  let labelElement = document.getElementById(id);
  if (labelElement != null) {
    let swatch = $(labelElement).closest('.swatch');

    var $div = $(swatch).find(".color-header");

    $div.find('.wrap_color_name').remove();
    $div.text($div.text().replaceAll(':', '') + ':');
    $div.append(`<span class='wrap_color_name'>&nbsp;${getActiveColor()}</span>`);
  }
}
/* Update info when first upload and variant changed */
function updateTextNearColorHeader(el) {
  try {
    textUpdator(el.attr('id'));
  } catch (error) {
    console.error("An error occurred:", error.message);
    if (error instanceof ReferenceError) {
      console.log("Skipping due to an undefined variable.");
    }
  }
}

window.addEventListener("load", function(){
  // updateTextNearColorHeader();
});

$('.product-form').on('change', function() {
  // updateTextNearColorHeader();
});

theme.FooterSubscription = (function(){

    function FooterSubscription(){
        var currentWindow = window.location.toString();

        if(currentWindow.indexOf('newsletter&form_type=customer') != -1) {
            var newsletterSubheader = document.getElementsByClassName('footer-newsletter__subheader')[0];
            newsletterSubheader.innerHTML = 'Email already registered to our newsletter';
        }
    }
    
    return FooterSubscription;
})()
function klavioAddedToCartViaAjax(response) {
  if (typeof _learnq === 'undefined') {
    return;
  }
  var item = {
    Brand: response.vendor,
    Categories: '',
    CompareAtPrice: '',
    ImageURL: response.image,
    Name: response.title,
    Price: (response.price/100).toLocaleString("en-US", {style:"currency", currency:"USD"}),
    ProductID: response.id,
    URL: ("https://zsupplyclothing.com/"+response.url)
  };
  _learnq.push(['track', 'Added to Cart', item]);
}

function klavioPageView() {
  if (typeof _learnq === 'undefined') {
    return;
  }
  console.log("klavioPageView");
  var klavioPageViewResponse = _learnq.push(['track', 'Page View', { pageUrl: window.location.href }]);
  console.log(klavioPageViewResponse);
}
// This function waits for an element to be present in the DOM
jQuery(document).ready(function() {
  waitForElm(".bxc .bx-2-heading").then((elm) => {
    var colorForLabel = $(elm).closest('.bxc').find(".bx-row-text").find("div").css("color");
    $(elm).closest('.bxc').find('.bx-inputwrap label').css('color', colorForLabel);

    $(elm).removeAttr('role').removeAttr('aria-level');
    $(elm).find(".bx-row-text-headline").children().attr('role', 'heading').attr('aria-level', '2');
    $(elm).find('.bx-row-input input[type="email"]').before('<label for="email">Email</label>');
  }).catch((err) => {
    console.error("Error waiting for element:", err);
  });

  waitForElm(".bxc .bx-step.bx-active-step").then((activeStep) => {
    const $activeStep = $(activeStep);
    const $focusableInput = $activeStep
      .find('.bx-row-input input[type="email"]:visible, .bx-row-input input[type="tel"]:visible')
      .first();
    const $closeButton = $activeStep.find('.bx-row-submit button[data-click="close"]');

    requestAnimationFrame(() => {
      if ($focusableInput.length) {
        $focusableInput.trigger('focus');
      } else if (document.activeElement && $closeButton.length && document.activeElement === $closeButton[0]) {
        $closeButton[0].blur();
      }
    });
  }).catch((err) => {
    console.error("Error waiting for BounceX step:", err);
  });
});
// Adds the 'is-resizing' state class to the body when resizing the browser window. Removes it when not resizing.
// This was added to stop unwanted animations/transitions between certain breakpoints.

let resizeTimer;

window.addEventListener('resize', () => {
  document.body.classList.add('is-resizing');
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    document.body.classList.remove('is-resizing');
  }, 400);
});

function getDyTestReplacementImageUrl(targets) {
              console.log('INSIDE getDyTestReplacementImageUrl(targets)');
              const productColorCodes = [...new Set(productJSON.variants.map(v => v.sku.split("-")[1]))];
              for (const colorCode of productColorCodes) {
                const colorTargets = targets.filter(t => t.image.includes(`_${colorCode}_`) && t.slug === productJSON.handle);
                
                if (colorTargets.length) {
                  const imageUrl = colorTargets[0].image;
                  const activeColor = productJSON.variants.find(v => v.sku.includes(`-${colorCode}-`))?.option1;
                  const videoEl = $(`.product-media[js-product-video][data-alt="${activeColor}"]`);
                  const imageEl = $(`.product-media[js-open-image-zoom][data-alt="${activeColor}"]`).first().clone(true);
                  imageEl.find('source').remove();

                  if (!activeColor || !videoEl.length || !imageEl.length) return false;
                 
                  imageEl.find('img').attr('src', imageUrl);
                  imageEl.attr('data-image-src', imageUrl);
                  videoEl.replaceWith(imageEl);

                  return imageUrl;
                }
              }

              return false;
      }

// Add User Ip to localStorage
function addUserIp() {
    if (localStorage.userIp === null || localStorage.userIp === undefined) {
      $.getJSON('https://jsonip.com/?callback=?').done(function(data) {
          var ip_address = window.JSON.parse(JSON.stringify(data, null, 2));
          ip_address = ip_address.ip;
          localStorage.setItem('userIp', ip_address);
      });
    }
}

function updateToSignOutBtn() {
  // If user is logged in, change the sign in add sign out btn
  var $signInBtn = $('.mobile-nav a[href="/account/login"]');
  var $signOutBtn = $signInBtn.clone();
  $signOutBtn.text("Sign Out");
  $signOutBtn.attr("href", "/account/logout");
  $signInBtn.attr("href", "/account");
  // Append after the sign in btn
  $signInBtn.after($signOutBtn);
}

document.addEventListener("DOMContentLoaded", function(){
  addUserIp();
  if(ShopifyAnalytics.meta.page.customerId) {
    updateToSignOutBtn();
  }
  if (typeof initProductCardSizeSwatchAddToCart === 'function') initProductCardSizeSwatchAddToCart();
});


// window.addEventListener("load", function(){
//     // Hide shopify preview bar for iOS users if they have already closed it
//     var previewBarIframe = document.getElementById("preview-bar-iframe");
//     if (previewBarIframe) {
//       // Observe the element's style changes
//       var observer = new MutationObserver(function (mutations) {
//         mutations.forEach(function (mutation) {
//           if (mutation.attributeName === "style") {
//             if (previewBarIframe.style.display === "none") {
//               // Save the visibility status of the element in session storage
//               window.sessionStorage.setItem("preview-bar-iframe-hidden", "true");
//             } else {
//               // Remove the visibility status from session storage
//               window.sessionStorage.removeItem("preview-bar-iframe-hidden");
//             }
//           }
//         });
//       }); 

//       // Start observing the element
//       observer.observe(previewBarIframe, {
//         attributes: true,
//         attributeFilter: ["style"]
//       });

//       // Check if the visibility status of the element is saved in session storage
//       if (window.sessionStorage.getItem("preview-bar-iframe-hidden") === "true") {
//         previewBarIframe.style.display = "none";
//       }
//     }
// });

function normalizeCartErrorDescription(description) {
  if (!description) return '';
  if (typeof description === 'string') return description;
  if (Array.isArray(description)) return description.join('; ');
  if (typeof description === 'object') {
    var values = Object.values(description).flat();
    return values.join('; ');
  }
  return String(description);
}

function reportCartAddFailure(payload) {
  console.error('cart_add_failed', payload);

  if (window.LogRocket && typeof window.LogRocket.track === 'function') {
    try {
      window.LogRocket.track('cart_add_failed', payload);
    } catch (logRocketError) {
      console.error('Failed to track cart_add_failed in LogRocket', logRocketError);
    }
  }
}

function addProductToCartViaAjaxAndUpdateCartDrawer(variantId, quantity, options) {
  options = options || {};

  if (typeof ajaxCart !== 'undefined' && typeof ajaxCart.setAddToCartIconState === 'function') {
    ajaxCart.setAddToCartIconState('adding');
  }

  fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity,
        sections: 'cart,cart-count',
        sections_url: window.location.pathname
      })
    })
    .then(function(response) {
      if (!response.ok) {
        return response.text().then(function(rawBody) {
          var responseJson = null;
          try {
            responseJson = rawBody ? JSON.parse(rawBody) : null;
          } catch (jsonParseError) {}

          var description = responseJson && responseJson.description ? normalizeCartErrorDescription(responseJson.description) : '';
          var message = responseJson && responseJson.message ? responseJson.message : '';
          var status = responseJson && responseJson.status ? responseJson.status : response.status;
          var reason = description || message || response.statusText || 'Unknown cart/add failure';

          var failurePayload = {
            endpoint: '/cart/add.js',
            cartAction: 'add',
            status: status,
            statusText: response.statusText || '',
            reason: reason,
            variantId: variantId,
            quantity: quantity,
            pathname: window.location.pathname,
            rawBody: rawBody || ''
          };

          reportCartAddFailure(failurePayload);
          if (typeof ajaxCart !== 'undefined' && typeof ajaxCart.setAddToCartIconState === 'function') {
            ajaxCart.setAddToCartIconState('idle');
          }
          if (window.ShopifyAPI && typeof ShopifyAPI.notifyItemError === 'function') {
            ShopifyAPI.notifyItemError(responseJson || failurePayload, 'error');
          }
          if (typeof options.onError === 'function') options.onError(failurePayload);
          return null;
        });
      }

      return response.json().catch(function(parseError) {
        reportCartAddFailure({
          endpoint: '/cart/add.js',
          cartAction: 'add',
          status: response.status,
          statusText: response.statusText || '',
          reason: 'Invalid JSON in /cart/add.js success response',
          parseError: parseError && parseError.message ? parseError.message : String(parseError),
          variantId: variantId,
          quantity: quantity,
          pathname: window.location.pathname
        });
        throw parseError;
      });
    })
    .then(function(data) {
      if (!data) return;

      if (typeof ajaxCart !== 'undefined' && typeof ajaxCart.setAddToCartIconState === 'function') {
        ajaxCart.setAddToCartIconState('added');
      }

      if (window.ShopifyAPI && typeof ShopifyAPI.notifyItemAdded === 'function') {
        ShopifyAPI.notifyItemAdded(data, document.querySelector('.product-form'));
      }

      try {
        slate.a11y.removeTrapFocus({
          $container: $('#quickshop-modal'),
          namespace: 'quickshop_focus'
        });

        $(".product-modal__container").removeClass("active");
        $(".product-modal__content").empty();
        $("body").css("overflow", "");
        const now = new Date(Date.now()).toLocaleString();
        console.log('Item Added to Cart:' + now);
        if (typeof options.onAfterCartLoad === 'function') {
          options._pendingOnAfterCartLoad = options.onAfterCartLoad;
        }
        if (
          theme &&
          data &&
          theme.CartConfirmationPopup &&
          (
            (document.body && document.body.classList.contains('atc-confirmation-variation--1')) ||
            (document.getElementById('MainContent') && document.getElementById('MainContent').classList.contains('atc-confirmation-variation--1'))
          )
        ) {
          data.quantityAdded = parseInt(quantity, 10) || 1;
          theme.CartConfirmationPopup.setLastAddedItem(data);
        }
        var cartDrawer = document.querySelector('cart-drawer');
        var drawer = document.querySelector('#CartDrawer');
        var showConfirmation = theme &&
          theme.CartConfirmationPopup &&
          (
            (document.body && document.body.classList.contains('atc-confirmation-variation--1')) ||
            (document.getElementById('MainContent') && document.getElementById('MainContent').classList.contains('atc-confirmation-variation--1'))
          );

        if (cartDrawer && data.sections) {
          cartDrawer.renderContents(data);
        }

        if (showConfirmation && theme.CartConfirmationPopup.getLastAddedItem()) {
          fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              theme.CartConfirmationPopup.show(theme.CartConfirmationPopup.getLastAddedItem(), cart);
            });
        } else if (drawer) {
          drawer.open();
        }

        if (typeof options._pendingOnAfterCartLoad === 'function') {
          options._pendingOnAfterCartLoad();
        }
        if (typeof customAddedToCartCallback === 'function') {
          customAddedToCartCallback(data);
        }
        if (typeof klavioAddedToCartViaAjax === 'function') {
          klavioAddedToCartViaAjax(data);
        }
      } catch (e) {
        console.log("Error in Pledge plugin on AJAX cart drawer: " + e);
        if (typeof options.onError === 'function') options.onError(e);
      }
    })
    .catch(function(error) {
      console.error('Failed to add product variant to cart:', error);
      if (typeof ajaxCart !== 'undefined' && typeof ajaxCart.setAddToCartIconState === 'function') {
        ajaxCart.setAddToCartIconState('idle');
      }
      if (window.ShopifyAPI && typeof ShopifyAPI.notifyItemError === 'function') {
        ShopifyAPI.notifyItemError(error, 'error');
      }
      if (typeof options.onError === 'function') options.onError(error);
    });
}


function waitForElm(selector) {
  /* This function waits for an element on a webpage to become available before resolving a promise, 
  using a MutationObserver to monitor changes to the page's DOM. 
  It's a useful tool for scripts that need to interact with elements that may not be immediately available. */
  return new Promise(resolve => {
      if (document.querySelector(selector)) {
          return resolve(document.querySelector(selector));
      }

      const observer = new MutationObserver(mutations => {
          if (document.querySelector(selector)) {
              resolve(document.querySelector(selector));
              observer.disconnect();
          }
      });

      try {
        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      } catch(error) {
        console.error(error);
      }
  });
}

function changeClassOnColorPickerOnCollectionPage() {
  $(document).off('click.productCardSwatchActive', '.product-card__swatch-border').on('click.productCardSwatchActive', '.product-card__swatch-border', function () {
    $(this).closest('.product-card__text-container').find('.product-card__swatch-border').removeClass('active');
    $(this).addClass('active');
  });
  function updateSizeSwatchOosForCard($colorBtn) {
    var availableSizesStr = $colorBtn.attr('data-available-sizes');
    var availableSizes = availableSizesStr ? availableSizesStr.split(',').map(function(s) { return s.trim(); }).filter(Boolean) : [];
    var $card = $colorBtn.closest('.product-card');
    if (!$card.find('.product-card__swatch-border').length) return;
    $card.find('.product-card__size-swatch').each(function() {
      var sizeValue = $(this).attr('data-size-value');
      if (availableSizes.indexOf(sizeValue) === -1) {
        $(this).addClass('product-oos');
      } else {
        $(this).removeClass('product-oos');
      }
    });
  }
	  $(document).off('click.productCardSwatchUpdates', '.product-card__swatch-border').on('click.productCardSwatchUpdates', '.product-card__swatch-border', function() {
	    var $colorBtn = $(this);
	    updateSizeSwatchOosForCard($colorBtn);
	    if (typeof updateWhenClickOnColorSwatch === 'function') {
	      updateWhenClickOnColorSwatch($colorBtn);
	    }
	  });
  $('.product-card').each(function() {
    var $active = $(this).find('.product-card__swatch-border.active');
    if ($active.length) updateSizeSwatchOosForCard($active);
  });
}

function hidePlusIconIfColorsLessThanFour() {
  $('.product-card__swatch-container').each(function() {
      var swatchCount = $(this).find('button').length;
      var plusSign = $(this).find('a');
      if (swatchCount < 4) {
          plusSign.addClass('d-none');
      }
  });
}

function initializeProductCardSwatchImageFallbacks(scope) {
  var root = scope && scope.querySelectorAll ? scope : document;
  var cache = initializeProductCardSwatchImageFallbacks.cache || {};
  initializeProductCardSwatchImageFallbacks.cache = cache;

  root.querySelectorAll('[data-primary-img][data-fallback-img]').forEach(function(swatch) {
    if (swatch.getAttribute('data-fallback-initialized') === 'true') return;
    swatch.setAttribute('data-fallback-initialized', 'true');

    var primary = swatch.getAttribute('data-primary-img');
    var fallback = swatch.getAttribute('data-fallback-img');
    if (!primary || !fallback || primary === fallback) return;

    if (cache[primary] === 'fallback') {
      swatch.style.backgroundImage = 'url(' + fallback + ')';
      return;
    }

    if (cache[primary] === 'primary') return;

    if (cache[primary] && cache[primary].pending) {
      cache[primary].pending.push({ element: swatch, fallback: fallback });
      return;
    }

    cache[primary] = { pending: [{ element: swatch, fallback: fallback }] };
    var probe = new Image();
    probe.onload = function() {
      cache[primary] = 'primary';
    };
    probe.onerror = function() {
      var pending = cache[primary].pending || [];
      pending.forEach(function(item) {
        item.element.style.backgroundImage = 'url(' + item.fallback + ')';
      });
      cache[primary] = 'fallback';
    };
    probe.src = primary;
  });
}

function handleizeString(str) {
  if (!str) return '';
  return String(str).toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9_]+/g, '-').replace(/(^-|-$)/g, '');
}

function initProductCardSizeSwatchAddToCart() {
  $(document).on('click', '.product-card__size-swatch:not(.product-oos)', function(e) {
    e.preventDefault();
    e.stopPropagation();
    var $btn = $(this);
    var variantId = $btn.attr('data-variant-id');
    var variantIdsByColor = $btn.attr('data-variant-ids-by-color');
    if (variantIdsByColor) {
      try {
        var map = JSON.parse(variantIdsByColor.replace(/&quot;/g, '"'));
        var $card = $btn.closest('.product-card');
        var $activeColor = $card.find('.product-card__swatch-border.active');
        var colorName = $activeColor.length ? $activeColor.attr('data-swatch-name') : '';
        if (colorName && map) {
          var handleized = handleizeString(colorName);
          if (handleized && map[handleized]) {
            variantId = map[handleized];
          }
        }
      } catch (err) {}
    }
    if (variantId && typeof addProductToCartViaAjaxAndUpdateCartDrawer === 'function') {
      addProductToCartViaAjaxAndUpdateCartDrawer(variantId, 1);
    }
  });
}

function addColorTitleOnHover() {
  const swatches = document.querySelectorAll('.product-card__swatch');

  swatches.forEach(swatch => {
      swatch.addEventListener('mouseenter', () => {
          const colorName = swatch.parentElement.getAttribute('aria-label');
          if (colorName) {
              const style = document.createElement('style');
              style.id = 'dynamic-style';
              style.innerHTML = `
                .product-card__swatch::after {
                      content: "${colorName}";
                  }
              `;
              document.head.appendChild(style);
          }
      });

      swatch.addEventListener('mouseleave', () => {
          const style = document.getElementById('dynamic-style');
          if (style) {
              style.remove();
          }
      });
  });
}

function isClpFlatlayCollection() {
  let pathname = window.location.pathname;
  const routeRoot = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, '');
  if (routeRoot && pathname.indexOf(routeRoot + '/') === 0) {
    pathname = pathname.slice(routeRoot.length);
  }
  return /^\/collections\/(sweaters-cardigans|jackets-outerwear)\/?$/.test(pathname);
}

function isClpFlatlayHoverEnabled() {
  return document.body.classList.contains('cro-clp-flatlay-hover')
    && isClpFlatlayCollection()
    && shouldEnableProductCardHoverImage();
}

function findClpFlatlayImage(images, activeSrc) {
  const prefix = (activeSrc || '').split('/').pop().toUpperCase().match(/^([A-Z]+\d+[A-Z]?)_([A-Z0-9]+)_/);
  if (!prefix) return null;
  const findByStyle = style => images.find(image => {
    const filename = (image.src || '').split('/').pop().split('?')[0].toUpperCase();
    return filename.startsWith(style + '_' + prefix[2] + '_') && filename.includes('FLATLAY');
  });
  const exactMatch = findByStyle(prefix[1]);
  if (exactMatch) return exactMatch;

  // Only tolerate the filename S mismatch within this product's images and color.
  // Keep exact matches preferred and leave product/SKU identifiers unchanged.
  const alternateStyle = prefix[1].endsWith('S')
    ? prefix[1].slice(0, -1)
    : (/\d$/.test(prefix[1]) ? prefix[1] + 'S' : null);
  return alternateStyle ? findByStyle(alternateStyle) || null : null;
}

$(function() {
  if (!isClpFlatlayCollection() || !window.matchMedia) return;
  const desktop = window.matchMedia('(min-width: 768px) and (hover: hover) and (pointer: fine)');
  let wasDesktop = desktop.matches;
  let enabled = isClpFlatlayHoverEnabled();
  const refresh = function() {
    const nextEnabled = isClpFlatlayHoverEnabled();
    const becameDesktop = desktop.matches && !wasDesktop;
    wasDesktop = desktop.matches;
    if (nextEnabled === enabled && !becameDesktop) return;
    enabled = nextEnabled;
    if (enabled || becameDesktop) {
      clpHoverEffect();
    }
    $('#spot-content .product-card__image-container').trigger('cro:flatlay-update');
  };
  new MutationObserver(refresh).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  if (typeof desktop.addEventListener === 'function') {
    desktop.addEventListener('change', refresh);
  } else if (typeof desktop.addListener === 'function') {
    desktop.addListener(refresh);
  }
});

function shouldEnableProductCardHoverImage() {
  if (!window.matchMedia) return false;
  if (!window.dyClpHoverImageTestEnabled) return false;
  return window.matchMedia("(min-width: 768px) and (hover: hover) and (pointer: fine)").matches;
}

function applySecondImage(card) {
  if (!shouldEnableProductCardHoverImage()) return;

  const ratio = $(card).find(".product-card__image-ratio").first();
  if (!ratio.length) return;

  let productImages = [];
  try {
    productImages = JSON.parse($(card).attr("data-product-images") || "[]");
  } catch (e) { return; }

  const extractColorCode = function(src) {
    const filename = (src || "").split("/").pop().toUpperCase();
    const m = filename.match(/^[A-Z]+\d+[A-Z]?_([A-Z]+)_/);
    return m ? m[1] : null;
  };

  const resizeTo900 = function(url) {
    const ext = (url.match(/\.(jpg|png|gif|webp)(\?|$)/i) || [])[1] || "jpg";
    return url.replace(new RegExp("(_\\d+x)?\\." + ext, "i"), "_900x." + ext);
  };

  const cardColorName = (
    $(card).find(".product-card__swatch-border.active").attr("data-swatch-name") ||
    ""
  ).trim();

  const findBackSrc = function(colorCode, colorName) {
    const isBack = function(src) { return (src || "").toUpperCase().indexOf("_BACK") !== -1; };

    if (!colorCode && colorName) {
      const named = productImages.find(function(img) {
        return img.alt === colorName && extractColorCode(img.src);
      });
      if (named) colorCode = extractColorCode(named.src);
    }

    if (colorCode) {
      const token = "_" + colorCode + "_";
      const byCode = productImages.find(function(img) {
        const s = (img.src || "").toUpperCase();
        return s.indexOf(token) !== -1 && isBack(s);
      });
      if (byCode) return resizeTo900(byCode.src);
    }

    if (colorName) {
      const byAlt = productImages.find(function(img) {
        return img.alt === colorName && isBack(img.src);
      });
      if (byAlt) return resizeTo900(byAlt.src);
    }

    return null;
  };

  if (ratio.find("img.product-card__image__hover-image").length === 0) {
    ratio.append(
      `<img class="product-card__second-image product-card__image__hover-image" />`
    );
  }

  ratio.find("picture img.product-card__image").each(function() {
    const colorCode = extractColorCode($(this).attr("src"));
    const colorName = ($(this).attr("data-alt") || "").trim() || cardColorName;
    const backSrc = findBackSrc(colorCode, colorName);
    if (backSrc) $(this).attr("data-hover-src", backSrc);
  });

  const imageContainer = $(card).find(".product-card__image-container").first();
  if (!imageContainer.length) return;
  if (imageContainer.data("hover-image-bound")) return;

  const updateHoverImage = () => {
    const activeMedia = ratio.find(".product-card__image.active").first();
    const activeImg = ratio.find("img.product-card__image.active").first();
    let hoverImg = ratio.find("img.product-card__image__hover-image").first();
    if (!activeMedia.length || !activeImg.length || activeMedia.prop("tagName") === "VIDEO") {
      if (hoverImg.attr('data-cro-flatlay-created')) {
        hoverImg.remove();
        return;
      }
      hoverImg.removeAttr("src").attr("alt", "");
      return;
    }

    const hoverSrc = activeImg.attr("data-hover-src") || "";
    const activeSrc = activeImg.attr("src") || "";
    const flatlay = isClpFlatlayHoverEnabled() ? findClpFlatlayImage(productImages, activeSrc) : null;
    // A swatch update can remove the shared image when that color has no back image.
    if (!flatlay && hoverImg.attr('data-cro-flatlay-created')) {
      hoverImg.remove();
      return;
    }
    if (!hoverImg.length && flatlay) {
      ratio.append('<img class="product-card__second-image product-card__image__hover-image" data-cro-flatlay-created="true" />');
      hoverImg = ratio.find("img.product-card__image__hover-image").first();
    }
    if (!hoverImg.length) return;
    const existingHoverSrc = hoverImg.attr("src") || "";
    const nextSrc = flatlay
      ? resizeTo900(flatlay.src)
      : (hoverSrc || (existingHoverSrc && existingHoverSrc !== activeSrc ? existingHoverSrc : ""));
    if (nextSrc) {
      hoverImg.attr("src", nextSrc);
    } else {
      hoverImg.removeAttr("src");
    }
    hoverImg.attr("alt", activeImg.attr("alt") || "");
  };

  imageContainer.on("mouseenter focusin", updateHoverImage);
  imageContainer.on("mouseleave focusout", updateHoverImage);
  imageContainer.on('cro:flatlay-update', updateHoverImage);
  imageContainer.data("hover-image-bound", true);

  updateHoverImage();

  if (!ratio.data("hover-image-observer")) {
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class" &&
          mutation.target &&
          mutation.target.classList &&
          mutation.target.classList.contains("product-card__image")
        ) {
          updateHoverImage();
          break;
        }
      }
    });

    observer.observe(ratio[0], {
      attributes: true,
      subtree: true,
      attributeFilter: ["class"],
    });
    ratio.data("hover-image-observer", observer);
  }
}

// Reuse one viewport observer across Spot updates and CRO/viewport changes.
let clpHoverObserver;
function clpHoverEffect() {
  if (!shouldEnableProductCardHoverImage()) return;

  const initialize = (card) => {
    const variantId = $(card).attr("data-current-variant-id");
    if (!variantId || !variantId.trim()) return;
    applySecondImage(card);
    $(card).data("hover-image-loaded", true);
  };

  if (!clpHoverObserver && 'IntersectionObserver' in window) {
    clpHoverObserver = new IntersectionObserver((entries) => {
      if (!shouldEnableProductCardHoverImage()) return;
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        initialize(entry.target);
        clpHoverObserver.unobserve(entry.target);
      });
    }, { root: null, rootMargin: '200px', threshold: 0 });
  }

  $("#spot-content > .product-card").each(function(index) {
    const bound = $(this).find(".product-card__image-container").first().data("hover-image-bound");
    if (bound) return;
    const rect = this.getBoundingClientRect();
    // Preserve the initial eight-card batch; defer the rest until near the viewport.
    if (index < 8 || !clpHoverObserver || (rect.top <= window.innerHeight + 200 && rect.bottom >= -200)) {
      initialize(this);
      if (clpHoverObserver) clpHoverObserver.unobserve(this);
    } else {
      clpHoverObserver.observe(this);
    }
  });
}

function spotCustomCallBackOnProductsLoaded() {
  if (typeof updateVariantIdForLoadedProducts === 'function') { updateVariantIdForLoadedProducts(); }
  if (typeof addReviewsToProductCards === 'function') { addReviewsToProductCards(); }
  if (typeof changeClassOnColorPickerOnCollectionPage === 'function') { changeClassOnColorPickerOnCollectionPage(); }
  if (typeof hidePlusIconIfColorsLessThanFour === 'function') { hidePlusIconIfColorsLessThanFour(); }
  if (typeof initializeProductCardSwatchImageFallbacks === 'function') { initializeProductCardSwatchImageFallbacks(document.querySelector('#spot-content') || document); }
  if (typeof addColorTitleOnHover === 'function') { addColorTitleOnHover(); }
  if (typeof doubleTilesInOneRow === 'function') { doubleTilesInOneRow(); }
  if (typeof clpHoverEffect === 'function') { clpHoverEffect(); }
}

function handleProductCardColorPicker() {
  $('.tooltip-mob.hovered').removeClass('hovered');
  $(this).closest('.swatch-element').find('.tooltip-mob').addClass('hovered');
}

function showSwatchColorNameWhenHowerToColor() {
  $('.product-info__swatch-container .swatch input:checked').siblings(".tooltip-mob").addClass("hovered");
  var previousHover = null;
  $(".color__border").hover(
    function() {
      if(!$(this).closest('.swatch-element').find('input').is(':checked')) {
        previousHover = $(".tooltip-mob.hovered");
        previousHover.removeClass("hovered");
        $(this).siblings(".tooltip-mob").addClass("hovered");
      }
    }, 
    function() {
      if(!$(this).closest('.swatch-element').find('input').is(':checked')) {
        $(this).siblings(".tooltip-mob").removeClass("hovered");
        previousHover.addClass("hovered");
      }
    }
  );
}

function updateUrlVariantParam(variantId) {
  var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?variant=' + variantId;
  window.history.pushState({ path: newurl }, '', newurl);
}
function inchesToFeet(inches) {
  var feet = Math.floor(inches / 12);
  var remaining_inches = inches % 12;
  return feet + "'" + remaining_inches + "\"";
}

function convertToFeetAndInches(heightObj) {
  if (typeof heightObj === 'undefined') { return false }
  if (heightObj.unit !== 'in') {
      return 'Invalid unit';
  }

  let totalInches = heightObj.value;
  let feet = Math.floor(totalInches / 12);
  let inches = totalInches % 12;

  // Determine whole inches and fractional inches
  let wholeInches = Math.floor(inches);
  let fractionalInches = (inches - wholeInches).toFixed(1);

  // Check if fractional part is .0 then don't append it.
  return fractionalInches === '0.0' ? 
         `${feet}′${wholeInches}″` : 
         `${feet}′${wholeInches}.${fractionalInches.slice(2)}″`;
}

// klavioPageView
window.addEventListener("load", function(){
  klavioPageView();
});

$(document).ready(function() {
  // Tabs on product page
  $('#product-detail-page__tabs').find('.btn').on('click', function() {
    if($(this).hasClass('active')) {
      return;
    } else {
      $('#product-detail-page__tabs .tab, #product-detail-page__tabs .btn')
        .toggleClass('active');
    }
  });  
});
 
function formatedSKU(styleNum) {
  if (typeof styleNum != 'undefined') {
    let rightPart = styleNum.split("-").slice(1, 999).join("-");
    let leftPart = styleNum.split("-")[0];
    let lastLetter = leftPart.split("").pop().toUpperCase();
    if (lastLetter === "S") {
      return leftPart.slice(0, -1) + "-" + rightPart;
    } else {
      return styleNum;
    }
  } else {
    let sku = productJSON.variants[0].sku;
    let rightPart = sku.split('-')[1] + "-" + sku.split('-')[2]
    let leftPart = sku.split("-")[0];
    let lastLetter = leftPart.split("").pop().toUpperCase();
    if (lastLetter === "S") {
      return leftPart.slice(0, -1) + "-" + rightPart;
    } else {
      return styleNum;
    }
  }
}

function cleanAndRemoveSize(styleNum) {
  return formatedSKU(styleNum).split('-').slice(0, 2).join('-')
}

function getPureStyleNum(styleNum) {
  return formatedSKU(styleNum).split('-')[0]
}

function activateColorSelection() {
  var valueToFind = getActiveColor();
  var element = $('.input-color[value="' + valueToFind + '"]');

  if (element.length) {
    // Find and activate the closest .swatch-element.color
    var closestSwatchElement = element.closest('.swatch-element.color');
    if (closestSwatchElement.length) {
      closestSwatchElement.addClass('active');
      console.log('Class "active" added to the closest .swatch-element.color');
      
      var closestSwatch = element.closest('.swatch');
      if ( $(closestSwatch).length ) {
        var textColor = $(closestSwatch).find('.color-header').text().trim();
        var colorHeader = $(closestSwatch).find('.color-header');
        colorHeader.empty();
        colorHeader.append(textColor + '<span class="wrap_color_name">&nbsp;' + valueToFind + '</span>');
        console.log('Color name updated to "' + valueToFind + '" in the closest .swatch');
      } else {
        console.log('Closest .swatch not found.');
      }
    } else {
      console.log('Closest .swatch-element.color not found.');
    }
  } else {
    console.log('Element with value ' + valueToFind + ' not found.');
  }
}

activateColorSelection();

function isAppleSafari() {
  var ua = navigator.userAgent || '';
  var isAppleOS = /iPhone|iPad|iPod|Macintosh|Mac OS X/i.test(ua)
    || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  var isSafari = /^((?!chrome|android|crios|fxios|edgios).)*safari/i.test(ua);

  return isAppleOS && isSafari;
}

function addCustomStyleIfThisIsSafari() {
  if (!isAppleSafari()) {
    return;
  }

  const style = document.createElement('style');
  style.textContent = `
    .dynamic-checkout__content__ajaxcart {
      display: block !important;
    }
  `;
  document.head.appendChild(style);
}
addCustomStyleIfThisIsSafari();

function addCustomBorderBlackToAjaxCart() {
  waitForElm("#CartDrawer shopify-apple-pay-button").then((elm) => {
    $(elm).closest('.dynamic-checkout__content__ajaxcart').addClass('custom-border-black');
  }).catch((err) => {
    console.error("Error waiting for AJAX btns element -->:", err);
  });
}

window.addCustomBorderBlackToAjaxCart = addCustomBorderBlackToAjaxCart;

jQuery(document).ready(function() {
  addCustomBorderBlackToAjaxCart();
});

document.addEventListener('CartDrawer:open', addCustomBorderBlackToAjaxCart);

function waitGwpElem() {
  waitForElm(".ajaxcart__footer .gng-ru--btn").then((elm) => {
    // turn off click event on pledge button and add click event to ajax cart button\
    $(elm).addClass("d-none");
    $('.custom_gng-ru--btn').remove();

    // Possible issue: The line below has a hardcoded value.
    $(elm).after('<button type="button" class="btn button custom_gng-ru--btn gng-ru--btn" onclick="addProductToCartViaAjaxAndUpdateCartDrawer(41501632987236, 1);" style="white-space: nowrap; background-color: transparent; border: 1px solid; color: inherit;">'+$(elm).text()+'</button>');
  });
}

function addVariantToCartAndUpdateCartDrawer(clickedElem) {
  var variantId = clickedElem.attr("data-gwp-variant");
    storeApi.addToCart(variantId).then(function() {
    clickedElem.closest('.checkout__upsell-product').remove();
    var cart = document.querySelector('cart-drawer');
    var drawer = document.querySelector('#CartDrawer');
    if (cart) {
      cart.refreshSections().then(function() {
        if (typeof addGwpToCartDrawer === 'function') addGwpToCartDrawer();
        if (drawer) drawer.open();
      });
    } else if (drawer) {
      drawer.open();
    }
  });
}

function removeThresholdNotice() {
  $('.ajaxcart__header-inner').find("#wrap-threshold-notice").remove();
}

function formatGwpCartMessage(amountText) {
  var template = window.gwpCartMessageTemplate || ('Spend {{ amount }} ' + (window.gwpCustomMessage || 'more and get a free gift!'));
  return template
    .replace(/{{\s*amount\s*}}/g, amountText)
    .replace(/%amount%/g, amountText);
}

function buildThresholdNotice(gwpData) {
  let hide_progress_bar = gwpData.settings.hide_progress_bar;
  let cart_subtotal = Number(gwpData.cart_items_subtotal_price) || 0;
  let threshold = Number(gwpData.threshold);
  removeThresholdNotice();

  if (!Number.isFinite(threshold) || threshold <= 0) {
    return;
  }

  let cartSubtotalPercent = Math.min(100, Math.max(0, (cart_subtotal / threshold) * 100));

  let amountToThreshold = Math.max(0, threshold - cart_subtotal);

  if (amountToThreshold > 0 || gwpData.settings.cart_messaging_always_display) {
    let formattedAmountToThreshold = slate.Currency.formatMoney(amountToThreshold, theme.moneyFormat);
    
    $(`<div id="wrap-threshold-notice">
      <div class="text">
        ${formatGwpCartMessage(formattedAmountToThreshold)}
      </div>
      ${
        !hide_progress_bar
          ? `<progress id="thresholdProcess" max="100" value="${cartSubtotalPercent}">
              ${cartSubtotalPercent}%
            </progress>`
          : ''
      }
    </div>`).insertAfter("#cartPromoContainer");
  }
}

var addGwpToCartDrawerRequest;

function addGwpToCartDrawer() {
  if (addGwpToCartDrawerRequest) {
    addGwpToCartDrawerRequest.abort();
  }

  addGwpToCartDrawerRequest = $.ajax({
    url: '/pages/checkout-gwp',
    success: function(data) {
      $("#CartDrawer .checkout__upsell-product").remove();

      var parser = new DOMParser();
      var doc = parser.parseFromString(data, "text/html");
      var scriptGwpData = doc.getElementById("gwp-settings-data");
      let checkoutUpsellProduct = $(data).find('.checkout__upsell-product').has('button');

      if (scriptGwpData) {
        var gwpData = JSON.parse(scriptGwpData.textContent);
        if (gwpData.settings && gwpData.settings.enable_gwp === false) {
          removeThresholdNotice();
          return;
        }
        if (gwpData.has_gift_product == true) {
          removeThresholdNotice();
          return;
        }
        if (gwpData.settings.cart_messaging_always_display) {
          buildThresholdNotice(gwpData);
        } else {
          if (Number.isInteger(gwpData.threshold) && gwpData.threshold > 0) {
            if (gwpData.cart_items_subtotal_price >= gwpData.threshold) {
              removeThresholdNotice();
            } else {
              // Threshold isn't reached
              buildThresholdNotice(gwpData);
            }
          } else {
            // Threshold is not a number
          }
        }
      } else {
        removeThresholdNotice();
        return;
      }
  if (checkoutUpsellProduct.length) { 
    // Show GWP
        let firstElement = checkoutUpsellProduct.first();
        let productHandle = gwpData.settings.gwp_product;
        if (firstElement.find('button.btn').first().attr('data-gwp-variant') != undefined) {
          if (gwpModalWindow) {
            var dataGwpVariant = `data-gwp-variant=${firstElement.find('button').attr('data-gwp-variant')}`;
          } else {
            var dataGwpVariant = "data-gwp-variant='"+firstElement.find('button').attr('data-gwp-variant')+"' onclick='addVariantToCartAndUpdateCartDrawer($(this));'";
          }
          
        } else {
          var dataGwpVariant = ""
        }


        let buttonText = firstElement.find('button').text();
        let textUnderBtn = firstElement.find('p').text();
       
        firstElement.find('button').addClass('d-none');
        firstElement.find('p').addClass('d-none');
        $('.drawer_pledge-ajax-cart').find('div.custom-button').remove();
        if (gwpModalWindow) {
          firstElement.prepend('<div class="wrap--ajax-cart_gwp">\
                                  <div class="product-card__quick-view-trigger_only ajax-cart_gwp ajax-cart_gwp-modal" '+ dataGwpVariant +' data-free-gift-modal="true" data-product-handle="'+productHandle+'">\
                                    '+buttonText+'\
                                  </div>\
                                  <p class="text text-center">'+textUnderBtn+'</p>\
                                </div>');
        } else {
          firstElement.prepend('<div class="wrap--ajax-cart_gwp">\
                                  <div class="product_ajax_gwp_btn ajax-cart_gwp" '+ dataGwpVariant +' data-product-handle="'+productHandle+'">\
                                    '+buttonText+'\
                                  </div>\
                                  <p class="text">'+textUnderBtn+'</p>\
                                </div>');
        }
        
        $("#CartDrawer .ajaxcart__footer").prepend(firstElement);
      } else {
        // Show pledge
        if (window.pledge.status == 'true') {
          // If you need show pledge in cart drawer, uncomment this code
          // $('.ajaxcart__footer')
          //   .prepend('<style>\
          //               .ajaxcart__inner {\
          //                 height: calc(100vh - 560px) !important;\
          //               }\
          //             </style>\
          //             <div id="pledge--wrapper__pdp" class="pledge-ajax-cart drawer_pledge-ajax-cart"><div data-round-up-via-pledgeling="7149702021220" attr-js-prod-handle="donation-to-charity"></div></div>\
          //             <script>\
          //               waitGwpElem()\
          //             </script>');
        }
      }
    }
  });
}

function addedToWishList() {
  DY.API("event", { name: "Add to Wishlist" })
}

function interactedWithMainNavigation(clickedElem) {
  let linkText = $(clickedElem).text().trim();
  DY.API("event", {
      name: "Interacted with Main Navigation",
      properties: { 
        linkText: linkText
      } 
  });
}

function interactedWithFilters(filterName, action = '') {
  if (action == 'added') {
    // filter element added
    DY.API("event", {
      name: "Interacted With Filters",
      properties: { 
        filterAction: "User implement filter",
        filterName: filterName
      } 
    });
  } else {
    // filter element removed
    DY.API("event", {
      name: "Interacted With Filters",
      properties: { 
        filterAction: "User remove filter",
        filterName: filterName
      } 
  });
  }
}

function openedChat() {
  DY.API("event", {
    name: "Opened Chat"
  });
}

function usedSiteSearch(searchQuery) {
  DY.API("event", {
    name: "Used Site Search (Mobile CLP)",
    properties: {
      searchRequest: searchQuery
    }
  });
}

// Track clicks on ajax search result items (Mobile CLP only)
document.addEventListener("click", function (e) {
  const productEl = e.target.closest(".template__collection .results .product");
  if (productEl) {
    DY.API("event", {
      name: "Clicked Search Result Item (Mobile CLP)",
    });
  }
});

function clickedYouMayAlsoLike() {
  $('#shopify-section-product-you-may-also-like').find('.product-card__link').on('click', function() {
    let clickedCard = $(this).closest('.product-card');
    let prodUrl = $(clickedCard).find('a').attr('href');
    DY.API("event", {
      name: "Clicked You May Also Like",
      properties: {
        prodUrl: prodUrl
      }
    });
  });
}

function clickedYouMayAlsoLikeQuickShop() {
  $('#shopify-section-product-you-may-also-like').find('.product-card__quick-view-trigger, [data-quickshop-trigger]').on('click', function() {
    let clickedCard = $(this).closest('.product-card');
    let prodUrl = $(clickedCard).find('a').attr('href');
    DY.API("event", {
      name: "Clicked You May Also Like",
      properties: {
        quickShopType: "You May Also Like Row on PDP page",
        prodUrl: prodUrl
      }
    });
  });
}
 
function isDesktopViewport() {
  return typeof window !== "undefined"
    && typeof window.matchMedia === "function"
    && window.matchMedia("(min-width: 768px)").matches;
}

function trackClpProductCardClick() {
  if (!$("body").hasClass("template-collection")) { return; }

  $("body.template-collection").on("click", ".product-card__link", function (event) {
    // Only track clicks that navigate to PDP (not buttons or swatches)
    if ($(event.target).closest("button, .product-card__swatch-container").length) { return; }
    // Don't track clicks on image banner tiles (they have their own tracking)
    if ($(event.target).closest(".wrap_banner-image").length) { return; }
    // Don't track clicks inside search drawer
    if ($(event.target).closest("#instant-search-drawer").length) { return; }

    var $productCard = $(this).closest(".product-card");
    var productName = $productCard.find(".product-card__title").text().trim();
    var productUrl = $(this).attr("href") || "";
    var collectionHandle = window.location.pathname.split("/collections/")[1]?.split("/")[0] || "";
    var isClpVideoStyle = $productCard.attr("data-clp-video-style") === "true";

    // Measure eligible styles in both control and treatment; only imagery is class-gated.
    if (isClpFlatlayCollection() && shouldEnableProductCardHoverImage() && window.DY && typeof window.DY.API === 'function') {
      var activeImage = $productCard.find('img.product-card__image.active').first();
      var flatlayImages = [];
      try {
        flatlayImages = JSON.parse($productCard.attr('data-product-images') || '[]');
      } catch (error) { /* A card without valid images cannot participate. */ }
      if (activeImage.length && findClpFlatlayImage(flatlayImages, activeImage.attr('src'))) {
        window.DY.API('event', { name: 'Hover Flatlay Test' });
      }
    }

    DY.API("event", {
      name: "CLP Product Card Click",
      properties: {
        sourcePageUrl: window.location.href,
        productName: productName
      }
    });

    if ($productCard.attr("data-dy-summer-clp-video-test") === "true") {
      DY.API("event", {
        name: "CLP Video Style PDP Click",
        properties: {
          sourcePageUrl: window.location.href,
          productName: productName,
          productUrl: productUrl,
          collectionHandle: collectionHandle,
          testName: "dy-summer-clp-video-test",
          isClpVideoStyle: isClpVideoStyle
        }
      });
    }
  });
}

function trackClpImageTileClick() {
  if (!$("body").hasClass("template-collection")) { return; }

  // Single tile clicks
  $("body.template-collection").on("click", "#spot-content .wrap_banner-image.wrap_banner-image__regular", function (event) {
    DY.API("event", { name: "CLP Single Image Tile Click" });
  });

  // Double tile clicks
  $("body.template-collection").on("click", "#spot-content .wrap_banner-image.wrap_banner-image__double, #spot-content .wrap_banner-image.wrap_banner-image__double-row", function (event) {
    DY.API("event", { name: "CLP Double Image Tile Click" });
  });
}

function trackAjaxCheckoutClick() {
  $(document).on("click", "#CartDrawer .ajaxcart__checkout[name='checkout']", function () {
    if (!window.DY || typeof window.DY.API !== "function") { return; }
    console.log("AJAX Checkout Click");
    DY.API("event", { name: "AJAX Checkout Click" });
  });
}

function sendPdpDyEvent(eventName) {
  if (!window.DY || typeof window.DY.API !== "function") { return; }
  try {
    DY.API("event", { name: eventName });
  } catch (err) {
    // Keep DY failures from blocking PDP interactions.
  }
}

// Fire for both DY test and control — no experiment gating.
function trackPdpColorAndSizeSelectorClicks() {
  if (!$("body").hasClass("template-product") && !$("body").hasClass("template__product")) {
    return;
  }

  document.addEventListener(
    "click",
    function (event) {
      // Ignore programmatic auto-select clicks (e.g. selectActiveColor on load).
      if (!event.isTrusted) { return; }
      var target = event.target instanceof Element ? event.target : null;
      if (!target) { return; }

      // Label clicks also fire a trusted click on the associated radio; skip the input.
      if (target.tagName === "INPUT") { return; }

      if (target.closest(".product-form .swatch-element.color")) {
        sendPdpDyEvent("PDP Color Swatch Click");
        return;
      }

      if (target.closest(".product-form .size-selection .swatch-element")) {
        sendPdpDyEvent("PDP Size Selector Click");
        return;
      }

      if (
        target.closest(
          ".product-form .seed-custom-dropdown[js-product-option-selector] .seed-custom-dropdown__item, .product-form .seed-size-dropdown .seed-custom-dropdown__item, .product-form [js-seed-dropdown-item]"
        )
      ) {
        sendPdpDyEvent("PDP Size Selector Click");
        return;
      }

      if (target.closest(".mobile-sticky-atc__variant-btn")) {
        sendPdpDyEvent("PDP Size Selector Click");
      }
    },
    true
  );
}

function trackPdpCurveClicks() {
  if (!$("body").hasClass("template-product") && !$("body").hasClass("template__product")) {
    return;
  }

  document.addEventListener("click", function (event) {
    if (!event.isTrusted) { return; }
    var target = event.target instanceof Element ? event.target : null;
    if (!target) { return; }

    if (target.closest(
      '.model-size-dropdown__option[data-model-option="curve"], .model-size-dropdown__option[data-model-option="curveM"], .model-size-tabs__tab[data-model-tab="curve"], .model-size-tabs__tab[data-model-tab="curveM"]'
    )) {
      sendPdpDyEvent("PDP Curve Click");
    }
  }, true);
}

waitForElm("#wair-fit-advisor").then(() => {
  $(document).on('click', '#wair-fit-advisor', function(){
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "wair_cta_click" });

    DY.API("event", {
      name: "Clicks on WAIR"
    });
  });
});

function clickedOnProductHomePage() {
  // .swiper-slide #wrap-home-slider-section-2
  $('#wrap-home-slider-section-2').find('.swiper-slide').on('click', function(){
    let prodUrl = $(this).find('.product-card__link').attr('href');
    DY.API("event", {
      name: "Clicked On Product Home Page",
      properties: {
        prodUrl: prodUrl
      }
    });
  });
}
clickedOnProductHomePage();

// track clicks on PDP video play button
waitForElm('.plyr--stopped').then((elm) => {
  $(elm).on('click', function () {
    // do not track click if video already playing
    if (!$(this).hasClass('plyr--playing')) {
      DY.API("event", {
        name: "Clicked Video Play Button"
      });
    }
  });
});

// The code below contains part of the method calls. Some methods are called from other files
window.addEventListener("load", function(){
  //
  // interactedWithMainNavigation
  //

  $('.nav-main').find('a').on('click', function(){
    interactedWithMainNavigation($(this));
  });
  $('#mobile-nav-drawer').find('a').on('click', function(){
    interactedWithMainNavigation($(this));
  });

  // 
  // Interacted with Filters
  //
  // Target the div you want to observe
  const targetDiv = document.querySelector('.spot-breadcrumbs');

  // Create a new MutationObserver
  const observer = new MutationObserver((mutationsList) => {
    // Check each mutation in the list
    for (const mutation of mutationsList) {
      // Check if nodes were added
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        // New elements were added to the div
        for (const addedNode of mutation.addedNodes) {
          if (addedNode.nodeType === Node.ELEMENT_NODE) {
            const elementText = addedNode.textContent;
            if(!elementText.includes('Clear All')) {
              interactedWithFilters(elementText, 'added');
            }
            // You can perform any desired actions for added elements here.
          }
        } 
      }

      // Check if nodes were removed
      if (mutation.type === 'childList' && mutation.removedNodes.length > 0) {
        // Elements were removed from the div
        for (const removedNode of mutation.removedNodes) {
          if (removedNode.nodeType === Node.ELEMENT_NODE) {
            const elementText = removedNode.textContent;
            if(!elementText.includes('Clear All')) {
              interactedWithFilters(elementText);
            }
            // You can perform any desired actions for removed elements here.
          }
        }
      }
    }
  });

  // Configure the observer to watch for changes in child elements
  const config = { childList: true, subtree: true };

  // Start observing the target div (if it exists)
  if (targetDiv) {
    observer.observe(targetDiv, config);
  }

  // 
  // Clicked on ZenDeck Chat
  //
  zE('webWidget:on', 'open', function() {
    openedChat();
  });


  // Grid interrupter test event tracking
  var r=[["Promo-01START","Clicked Grid Interrupter - Free Shipping"],["SingleTile-01","Clicked Grid Interrupter - Fall Collection"],["SingleTile-03","Clicked Grid Interrupter - New Arrivals"]];
  document.addEventListener("click",function(e){var c=e.target.closest(".product-card");if(!c)return;for(var i=0;i<r.length;i++)if(c.querySelector('img[src*="'+r[i][0]+'"]')){DY.API("event",{name:r[i][1]});break}});


});

trackClpProductCardClick();
trackClpImageTileClick();
trackAjaxCheckoutClick();
trackPdpColorAndSizeSelectorClicks();
trackPdpCurveClicks();


/*================ Modules ================*/
theme.HeaderFunction = (function(){

    var selectors = {
      shopButton: '[data-text="Shop"]',
      womenButton: '[data-text="Women"]'
    }

    function HeaderFunction(container) {
        this.$container = $(container);
        var $womenButton = $(selectors.womenButton, this.$container);
        var $shopButton = $(selectors.shopButton, this.$container);

        $shopButton.hover(function(){
            $womenButton.addClass("nav-link--active");
        }, function() {
            $womenButton.removeClass("nav-link--active");
        })
    }

    return HeaderFunction;
  })();

theme.Geolocation = (function(){

    // Initialize region and country based on Shopify runtime data
    function init() {
        var countryCode = (window.Shopify && window.Shopify.country)
            ? String(window.Shopify.country).toUpperCase()
            : 'US';
        var region = (countryCode === 'US') ? 'domestic' : 'international';
        var className = (region === 'domestic') ? 'geo-domestic' : 'geo-international';
        var $body = $('body');
        $body.data('geo-country', countryCode);
        $body.data('geo-region', region);
        $body.addClass(className);
    }
  
    return {
        init: init
    };
  })();

function checkNumbersOfWishItems() {
  window._swat.wishlistCount(
    function (r) {
      if (r > 0) {
        $('#headerIdWishBtn').find('.wish-btn__empty').addClass('d-none');
        $('#headerIdWishBtn').find('.wish-btn__fill').removeClass('d-none');
      } else {
        $('#headerIdWishBtn').find('.wish-btn__empty').removeClass('d-none');
        $('#headerIdWishBtn').find('.wish-btn__fill').addClass('d-none');
      }
    }
  );
}

function checkWishStatusForLoadedProducts() {
  function checkSwatLoaded() {
    if (window._swat && typeof window._swat.fetch === 'function') {
      window._swat.fetch(function(r) {
        $('.wishlistIcon').html('<div onclick="addProdToWishList($(this))" class="wishlist__unfilled-heart"></div>');
        r.forEach(function(i) {
          var wrapperWishBtn = $(".product-card[data-current-variant-id='" + i.epi + "']").find('.wishlistIcon');
          wrapperWishBtn.html('');
          wrapperWishBtn.append('<div onclick="removeProdFromWishList($(this))" class="wishlist__filled-heart"></div>');

          // Update wishlist icon for website header
          $('#headerIdWishBtn').find('.wish-btn__empty').addClass('d-none');
          $('#headerIdWishBtn').find('.wish-btn__fill').removeClass('d-none');
        });
      });
    } else {
      // Retry after a short delay if _swat is not loaded yet
      setTimeout(checkSwatLoaded, 100); // Adjust the delay as needed
    }
  }

  // Start checking if _swat is loaded
  checkSwatLoaded();
}

function updateVariantIdForLoadedProducts() {
  $('.product-card').each(function() {
    let dataVarId = $(this).find('.product-card__swatch-container')
                                    .find('.active')
                                    .find('.product-card__swatch')
                                    .attr('data-variant-id')
    $(this).attr("data-current-variant-id", dataVarId);
    $(this).attr("data-dy-sku", dataVarId);
  });
  checkWishStatusForLoadedProducts(); 
}

// ProductCardHoverImage is loaded from product-card-hover-helpers.liquid snippet

function updateWhenClickOnColorSwatchWishList(swatchElem) {
  updateCurrentVariantAttributeForProduct(swatchElem);
  var productCard = swatchElem.closest(".product-card");
  var swatchName = swatchElem.attr("data-swatch-name");
  
  productCard.find(".product-card__image.active").removeClass('active');
  productCard.find(".product-card__image[data-alt='" + swatchName + "']").addClass('active');
  
  // Update hover image if helper is available (loaded on collection pages)
  if (window.ProductCardHoverImage) {
    ProductCardHoverImage.update(productCard, swatchName);
  }
}

function updateCurrentVariantAttributeForProduct(products_swatch) {
  products_swatch.closest('.product-card').attr("data-current-variant-id", products_swatch.find('.product-card__swatch').attr('data-variant-id'));
}

function addProdToWishList(wishlist_btn) {
  var prod_card = wishlist_btn.closest('.product-card');
  var variantId = prod_card.attr("data-current-variant-id");
  var prodId = prod_card.attr("id");
  var prodImageUrl = prod_card.find('.product-card__image.active').attr('src');
  var prodUrl = window.location.origin + prod_card.find('a.product-card__link').attr('href');
  var prodPrice = prod_card.find('.product-card__price').text().replace(/\s/g, '').replace(/\$/g, '');

  window._swat.addToWishList(
    {
      "epi": variantId,
      "du": prodUrl,
      "empi": prodId,
      "iu" : prodImageUrl,
      "pr": prodPrice,
      "et": 4
    },
    function(r) {
      setTimeout(checkWishStatusForLoadedProducts, 100);
      addedToWishList();
    }
  );
}

function removeProdFromWishList(wishlist_btn) {
  var prod_card = wishlist_btn.closest('.product-card');
  var variantId = prod_card.attr("data-current-variant-id");
  var prodId = prod_card.attr("id");
  var prodImageUrl = prod_card.find('.product-card__image.active').attr('src');
  var prodUrl = window.location.origin + prod_card.find('a.product-card__link').attr('href');
  var prodPrice = prod_card.find('.product-card__price').text().replace(/\s/g, '').replace(/\$/g, '');

  window._swat.removeFromWishList(
    {
      "epi": variantId,
      "du": prodUrl,
      "empi": prodId,
      "iu" : prodImageUrl,
      "pr": prodPrice,
      "et": 4
    },
    function(r) {
      setTimeout(checkWishStatusForLoadedProducts, 100);
      setTimeout(checkNumbersOfWishItems(), 200);
    }
  );
  
}

window.addEventListener("load", function () {
  function swymCallbackFn(){
    updateVariantIdForLoadedProducts();

    $(".product-card__swatch").on('click', function () {
      checkWishStatusForLoadedProducts();
    });
  }
  if(!window.SwymCallbacks){
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(swymCallbackFn);

  $('.swym-add-to-wishlist').on('click', function(){
    addedToWishList();
  });
});
function addReviewsToProductCards() {
  waitForElm('.template__collection .oke-sr-rating').then(() => {
    setTimeout(() => {
      $('.template__collection .oke-sr-rating').each(function(i){
        if (parseFloat(this.textContent.trim()) < 3.5) {
          $(this).closest(".js_prod-card__rating").remove();
        }
      });
    }, 100);
  });
}

/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */
function getProductJSON() {
  return window.productJSON || null;
}

function colorNameToCode(colorName) {
  var product = getProductJSON();
  if (!product || !Array.isArray(product.variants)) return null;

  var variant = product.variants.find(x => x.option1 == colorName);
  return variant && variant.sku ? variant.sku.split('-')[1] : null;
}
function countElementsBy(colorCode) {
  let count = 0;
  $('.product-media_curve').each(function() {
    const dataImageSrc = $(this).attr('data-image-src');
    if (dataImageSrc && dataImageSrc.includes(colorCode)) {
      count++;
    }
  }); 
  return count;
}
theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJSON: '[data-product-json]',
    kitComponentsJson: '[data-kit-component-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);
    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJSON, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJSON, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };
    var variantImplementation = slate.Variants;
    if(this.productSingleObject.type === "Kit") {
      var components = $(selectors.kitComponentsJson, this.$container).map(
        function(idx, elm) { 
          return JSON.parse($(elm).html()); 
        }).get();
        this.kitComponents = components.reduce(function(result, item, index) {
          result[item.id] = item;
          return result;
        }, {});

        options.kitComponents = this.kitComponents;
        variantImplementation = slate.KitVariants;
    }

    this.settings = {};
    this.namespace = '.product';
    this.variants = new variantImplementation(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);
    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantKitChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
    this.plyrVideo();
    this.checkSwatchSelection();
    this.slickProductImage();
    this.socialSharing();
    this.openSizeGuide();
    this.productZoom();
    this.filterImages();
    this.$container.on('variantChange' + this.namespace, this.filterImages.bind(this));
    this.$container.on('variantChange' + this.namespace, function(evt) {
      updatePdpGarmentSpecLine(evt.variant);
    });
    $(window).load(function() {
      // Handler for .load() called.
    });
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if ($('#add-to-cart-button').css('display') != 'flex') {
        $('#add-to-cart-button').css('display', 'flex');
      }
      updateAddToBagBtn(variant);
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      console.log('updateProductPrices', evt);
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },
    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    checkSwatchSelection: function() {
      $('.swatch-selection .color').each(function () {
        var swatchSelected = sessionStorage.getItem('swatch-selected');
        if ($(this).data('value') == swatchSelected) {
          $('.input-color[data-swatch-input]:checked').removeAttr('checked');
          $(this).find('label').click();
          $('.no-js option').each(function () {
            var text = $(this).text();
            if (text.indexOf(swatchSelected) != -1) {
              $('.no-js option:selected').removeAttr('selected');
              if ($(this).prop('disabled') == false) {
                $(this).prop('selected', true);
                return false;
              }
            }
          });
        }
      });
    },

    plyrVideo: function(evt) {
      $('.product-media').each(function() {
        var $video = $(this).find('video').not('.video__chip-on-pdp-image').first();
        if($video.length > 0) {
          var videoElement = $video[0];
          buildPlyrVideo(videoElement);
        }
      });
    },
   
    openSizeGuide: function(evt) {
      // Trigger opening of Size Guide Modal
      $("[js-size-guide]").click(function(){
        $("body").addClass("no-scroll");
        $(".product-info__tag-size-guide-modal").addClass("active");
      });

      $(".size-guide__container, [js-size-guide]").click( function(e) {
          e.stopPropagation();
      });
      // Clicking anywhere besides modal, and close button will close modal
      $(".product-info__tag-size-guide-modal, .product-info__tag-size-guide-close").click( function() {
        $("body").removeClass("no-scroll");
        $(".product-info__tag-size-guide-modal").removeClass("active");
      });
      //If Escape Key pressed close modal
      $(document).on('keyup',function(evt) {
        if (evt.keyCode == 27) {
          $("body").removeClass("no-scroll");
          $(".product-info__tag-size-guide-modal").removeClass("active");
        }
      });
    },
    socialSharing: function(evt){
      // Trigger opening of Share Modal
      $("[js-social-share]").click(function(){
        $("body").addClass("no-scroll");
        $(".product-info__tag-share-modal").addClass("active");
      });
      $(".social-sharing, [js-social-share]").click( function(e) {
          e.stopPropagation();
      });
      // Clicking anywhere besides modal, close button, and link will close modal
      $(".product-info__tag-share-modal, product-info__tag-share-close, .product-info__tag-share-modal a").click( function() {
        $("body").removeClass("no-scroll");
        $(".product-info__tag-share-modal").removeClass("active");
      });
      //If Escape Key pressed close modal
      $(document).on('keyup',function(evt) {
        if (evt.keyCode == 27) {
          $("body").removeClass("no-scroll");
          $(".product-info__tag-share-modal").removeClass("active");
        }
      });
    },
    productZoom: function(evt){
      enquire.register(theme.config.mediaQueries.mediumUp,{
        match: function(){
      $("[js-image-zoom]").click(function(event){
        // Get clicked element
        if ($(event.target).closest('.chip-on-pdp-image, .video__chip-on-pdp-image, .video-chip-player-root, .video-js, .vjs-control-bar').length) {
          return;
        }
        if( $(this).hasClass("zoom-on")){
          $(this).removeClass("zoom-on")
          $(this).children('img').css({'transform': 'scale(1)'});
          $(this).off("mouseover").off("mousemove");
        }
        else{
          $("[js-image-zoom]").removeClass("zoom-on")
          $("[js-image-zoom]").children('img').css({'transform': 'scale(1)'});
          $("[js-image-zoom]").off("mouseover").off("mousemove");

          $(this).addClass("zoom-on");
          $(this).children('img').css({'transform': 'scale('+ $(this).attr('data-scale') +')'});
          $(this)
          .on('mouseover', function(){
            $(this).children('img').css({'transform': 'scale('+ $(this).attr('data-scale') +')'});
          })
          .on('mousemove', function(e){
            $(this).children('img').css({'transform-origin': ((e.pageX - $(this).offset().left) / $(this).width()) * 100 + '% ' + ((e.pageY - $(this).offset().top) / $(this).height()) * 100 +'%'});
          })
        }
      })

          $('.size-selection .swatch-element').on('click', function() {
            if ($(this).hasClass('available')) {
              $(selectors.addToCart, this.$container).prop('disabled', false);
            }
          });
        },
        unmatch: function(){
        }
      }).register(theme.config.mediaQueries.smallDown, {
        match: function(){
          $("[js-image-zoom]").each(function(){
            $(this).children('img').css({'transform': 'scale(1)'});
            $(this).off("mouseover").off("mousemove").off("click");
          })
        },
        unmatch: function(){
        }
      })
    },
    slickProductImage: function(evt){
      if (window.removeVideoTargets && Array.isArray(window.removeVideoTargets)) {
        getDyTestReplacementImageUrl(window.removeVideoTargets);
      }
      // Clean up video targets on unload without prompting the user
      window.onunload = function() { delete window.removeVideoTargets; }; 

      enquire.register(theme.config.mediaQueries.mediumUp, {
        match: function(){
          if ( $("[js-slick-product-media]").hasClass("slick-initialized")){
            $("[js-slick-product-media]").slick("slickUnfilter")
            $("[js-slick-product-media]").slick("unslick");
          }
        },
        unmatch: function(){
        }
      }).register(theme.config.mediaQueries.smallDown, {
        match: function(){
          var $productMediaSlider = $("[js-slick-product-media]");

          $productMediaSlider.off('init.pdpMobile beforeChange.pdpMobile afterChange.pdpMobile');

          $productMediaSlider.on('init.pdpMobile', function(event, slick){
            if($('body').attr('id') !=  "gift-card" ) {
              function pin1mobTimer(){
                $('.slick-dots').before('<div id="pin2" class="pin_desk-mob d-none" onclick="pinOpenDropdown()"></div>');
                $('.pdp-pin__wrapper').detach().appendTo("#pin2");
                // curveDropDownUpdater();
              }
              setTimeout(pin1mobTimer, 2000);
            }
          });

          $productMediaSlider.on('beforeChange.pdpMobile', function (event, slick, currentSlide, nextSlide) {
            if (currentSlide === nextSlide) return;
            if (!window.dataLayer || typeof window.dataLayer.push !== 'function') return;

            const product = getProductJSON();
            const variant = getActiveVariant();
            window.dataLayer.push({
              event: 'product_slider_swipe',
              slideFrom: Number(currentSlide) + 1,
              slideTo: Number(nextSlide) + 1,
              productId: product && product.id ? String(product.id) : null,
              productName: product && product.title ? product.title : null,
              variantId: variant?.id ? String(variant.id) : null
            });
          });

          $productMediaSlider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            infinite: false
          })

          $productMediaSlider.on('afterChange.pdpMobile', function(event, slick, currentSlide){
            players.forEach(function(player) {
                player.pause(); // pause all players
            });
        
            var thisSlide = slick.$slides[currentSlide];
            var $video = $(thisSlide).find("video").not(".video__chip-on-pdp-image");

            if ($video.length > 0) {
              var currentPlayer = players.find(function(player) {
                return player.media === $video[0];
              });
              if (currentPlayer) {
                var autoplayValue = document.getElementById('dy-video-autoplay') ? document.getElementById('dy-video-autoplay').value === 'true' : false;
                if (autoplayValue) {
                  currentPlayer.play(); // play the current player
                }
              }
            }
          });
        },
        unmatch: function(){
        }
      })

    },
    filterImages: function(e){
      enquire.register(theme.config.mediaQueries.mediumUp, {
          match: function(){
            if ( $(".input-color[data-swatch-input]").length > 0 ){
              var $data = $(".input-color[data-swatch-input]:checked").val();
              $(".product-media, .product-image-zoom__image").filter(function(i, element){
                if( $(element).data("alt") === $data || $(element).data("alt") === "global" ){
                  $(element).addClass("active")
                }
                else{
                  $(element).removeClass("active")
                }
              });
            } else if ($(".input-gift_card[data-swatch-input]").length > 0) {
              var $data = $(".input-gift_card[data-swatch-input]:checked").val();
              $(".product-media, .product-image-zoom__image").filter(function(i, element){
                if( $(element).data("alt") === $data || $(element).data("alt") === "global" ){
                  $(element).addClass("active")
                }
                else{
                  $(element).removeClass("active")
                }
              });
            } else {
              // Size-only (e.g. bundles): media alt is not keyed by size — show all gallery items
              $(".product-media, .product-image-zoom__image").addClass("active");
            }
          },
          unmatch: function(){
          }
        }).register(theme.config.mediaQueries.smallDown, {
          match: function(){
            if ( $(".input-color[data-swatch-input]").length > 0 ){
              var $data = $(".input-color[data-swatch-input]:checked").val();
              $("[js-slick-product-media]").slick("slickUnfilter")
              $("[js-slick-product-media]").slick("slickFilter", function(i, element){
                return $(element).data("alt") == $data || $(element).data("alt") == "global"
              })
              $("[js-slick-product-media]").slick('slickGoTo', 0, true)
            }
          },
          unmatch: function(){
          }
        })
      window.updateVideoChipBtn?.();
    },
    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

function addBtnAlertElem() {
  removeBtnAlertElem();
  var product = getProductJSON();
  if (product && product.type && product.type.toLowerCase() !== 'gift cards') {
    function buttonTimer() {
      $('button.product-form__cart-submit').attr('disabled', 'disabled');
    }
    setTimeout(buttonTimer, 10);
  }
}
function removeBtnAlertElem() {
  $(".product-info__quantity-atc").find('.btn_size_alert').remove();
}

function checkIfTheSizeIsSelected() {
  if ($(".size-selection input:checked").length == 0) {
    return false
  } else {
    return true
  }
}

function selectSingleSizeIfOnlyOne() {
  var $sizeSwatches = $('.size-selection .swatch-element');
  if ($sizeSwatches.length === 1) {
    var $input = $sizeSwatches.find('.input-size');
    var optionValue = $input.val();

    $input.prop('checked', true).trigger('change');

    var sizeDropdown = document.querySelector('.seed-custom-dropdown[js-product-option-selector]');
    if (sizeDropdown) {
      var items = sizeDropdown.querySelectorAll('[js-seed-dropdown-item]');
      var matchingItem = null;
      for (var i = 0; i < items.length; i++) {
        if (items[i].getAttribute('data-raw-value') === optionValue) {
          matchingItem = items[i];
          break;
        }
      }
      if (!matchingItem && items.length === 1) {
        matchingItem = items[0];
      }
      if (matchingItem) {
        matchingItem.click();
      }
    }

    var selectedTextEl = document.querySelector('[js-seed-dropdown-selected-text]');
    if (selectedTextEl && $input.length) {
      var labelEl = $sizeSwatches.find('.swatch-size-label').get(0);
      if (labelEl) {
        selectedTextEl.innerHTML = labelEl.innerHTML;
      } else {
        selectedTextEl.textContent = optionValue;
      }
    }
  }
}


/* prepend "USD" label to price for international customers */
$(document).ready(function () {
  var $productJsonEl = $('[data-product-json]');
  if ($productJsonEl.length > 0) {
    window.productJSON = JSON.parse($productJsonEl.first().html());
  }
  if(window.Shopify.country && (window.Shopify.country != 'US')) {
    $('#product-price').prepend("<span class='usd-label'>USD</span>");
  }

  $('.wrap_add-to-bag-elements .wrap_add-to-bag_button').on( "click", function() {
    if ($('#add-to-cart-button').attr('disabled') == 'disabled') {
      if (!checkIfTheSizeIsSelected()) {
        addBtnAlertElem();
      }
    }
  });

  $('.swatch-size-label').click(function(){
    removeBtnAlertElem();
  });
});

function isAnySizeSelected() {
  return $('.size-selection .input-size:checked').length > 0 || $('.input-gift_card .input-gift_card').length > 0;
}

function displayInactiveAddToBagButton() {
  var product = getProductJSON();
  if(product && product.type && product.type.toLowerCase() !== 'gift cards') {
    $('#add-to-cart-button').removeClass('d-none');
    $("#add-to-cart-button").attr('disabled', "disabled");
    $('#BIS_trigger').addClass('d-none');
    addBtnAlertElem();
  }
}

function displayAddToBagButton() {
  $('#add-to-cart-button').removeClass('d-none');
  $('#BIS_trigger').addClass('d-none');
  $("#pdp-wip-display").html('');
  $('[data-add-to-cart-text]', '#add-to-cart-button').text('ADD TO BAG');
  if (isAnySizeSelected()) {
    $("#add-to-cart-button").prop('disabled', false);
  } else {
    $("#add-to-cart-button").prop('disabled', true);
  }
}

function displayEmailWaitlistButton() {
  waitForElm('#BIS_trigger').then((elm) => {
    $('#add-to-cart-button').addClass('d-none');
    $('.wrap_add-to-bag_button').prepend($('#BIS_trigger'));
    $('#BIS_trigger').removeClass('d-none');

    var product = getProductJSON();
    var hasPreorderTag = !!(product && Array.isArray(product.tags) &&
      product.tags.some(function (t) { return String(t).toLowerCase() === 'pre-order'; }));

    if (hasPreorderTag) {
      setBisButtonLabel(elm, 'JOIN THE WAITLIST');
    }
  });
}

function setBisButtonLabel(btn, newText) {
  if (!btn) return;
  var inner = btn.querySelector('.btn');
  (inner || btn).textContent = newText;
}

function changeAddToBagToSoldOut() {
  $("#add-to-cart-button")
    .removeAttr('disabled')
    .attr('disabled', "disabled");
  $('[data-add-to-cart-text]', '#add-to-cart-button').text('SOLD OUT');
  waitForElm('#BIS_trigger').then((elm) => {
    $('#BIS_trigger').addClass('d-none');
  });
}

function displayWipMessageFor(variant){
  // TODO. Not sure if we need hide Wip text if "AVAILABLE" value present
  if (["SOLD OUT", "AVAILABLE"].includes(wip_data.find(x => x.variant_id == variant.id).wip_message.toLocaleUpperCase())) {
    displayEmailWaitlistButton();
    false
  } else {
    $("#pdp-wip-display").html(wip_data.find(x => x.variant_id == variant.id).wip_message);
    displayEmailWaitlistButton();
  }
}

function updateAddToBagBtn(variant) {
  // Guard against null or undefined variant
  if (!variant) {
    return;
  }
  if (!variant.available) {
    displayWipMessageFor(variant);
  } else {
    if (!checkIfTheSizeIsSelected()) {
      displayInactiveAddToBagButton();
    } else {
      displayAddToBagButton();
    }
  }
}

function updateAvailableSizes(clickedElem) {
  $('.size-selection').find('.swatch-element').removeClass('soldout');
  var product = getProductJSON();
  if (product && Array.isArray(product.variants) && product.variants.length > 0) {
    var unavailableSizes =  product.variants.filter(item => item.available === false && item.option1.toLowerCase() ===  clickedElem[0].dataset.value.toLowerCase() );
    $.each(unavailableSizes, function( index, value ) {
      $(".swatch-element[data-value='"+value.option2+"']").addClass('soldout');
    });
  }
  seedDropDownUpdate();
}

document.addEventListener('DOMContentLoaded', function() {
  seedDropDownUpdate();
});

function seedDropDownUpdate() {
  const seedDropdowns = document.querySelectorAll('[js-seed-dropdown-item]');
  const sizeInputItems = document.querySelectorAll('[js-swatch-input]');
  const selectedText = document.querySelector('[js-seed-dropdown-selected-text]');
  const atcButton = document.querySelector('#add-to-cart-button');

  const checkedSizeInput = Array.prototype.find.call(sizeInputItems, function(input) {
    return (input.type === 'radio' && input.checked &&
            (input.classList.contains('input-size') || input.classList.contains('input-gift_card')));
  });

  if (checkedSizeInput && selectedText) {
    const matchingItem = Array.prototype.find.call(seedDropdowns, function(item) {
      return item.getAttribute('data-raw-value') === checkedSizeInput.getAttribute('value');
    });
    if (matchingItem) {
      const labelEl = matchingItem.querySelector('.seed-custom-dropdown__item-text');
      if (labelEl) {
        selectedText.innerHTML = labelEl.innerHTML;
      } else {
        selectedText.textContent = checkedSizeInput.value;
      }
    } else {
      selectedText.textContent = checkedSizeInput.value;
    }
    if (atcButton) atcButton.removeAttribute('disabled');
  } else {
    if (selectedText) selectedText.textContent = 'SELECT A SIZE';
    if (atcButton) atcButton.setAttribute('disabled', 'disabled');
  }

  for (const seedDropdown of seedDropdowns) {
    seedDropdown.classList.remove('seed-custom-dropdown__item--soldout');
  }

  for (const sizeInputItem of sizeInputItems) {
    var parent = sizeInputItem.parentElement;
    if (parent && parent.classList.contains('soldout')) {
      for (const seedDropdown of seedDropdowns) {
        if (seedDropdown.getAttribute('data-raw-value') == sizeInputItem.getAttribute('value')) {
          seedDropdown.classList.add('seed-custom-dropdown__item--soldout');
        }
      }
    }
  }
}

var players = [];

function buildPlyrVideo(videoElement) {
  if (!videoElement || $(videoElement).hasClass('video__chip-on-pdp-image')) return;

  var autoplayValue = document.getElementById('dy-video-autoplay') ? document.getElementById('dy-video-autoplay').value === 'true' : false;
  const object = convertStringToJSON( $(videoElement).attr("aria-label") );
  const plyrVideo = new Plyr(videoElement, {
    hideControls: object.hideControls === 'true' ? true : false,
    controls: autoplayValue == false ? ['progress', 'play'] : [],
    muted: object.muted === 'false' ? false : true,
    autoplay: autoplayValue
  }); 
  plyrVideo.loop = object.loop === 'false' ? false : true;
  plyrVideo.volume = object.volume ? object.volume : 0;
  plyrVideo.source.poster = '';

  // Add the player to the array
  players.push(plyrVideo);
}


function convertStringToJSON(str) {
  var result = {};
  if (typeof str !== 'string') return result;

  var arr = str.replace(/[\[\]]/g, '').split(',');
  for (var i = 0; i < arr.length; i++) {
      var temp = arr[i].split('=');
      result[temp[0]] = temp[1];
  } 
  return result;
}


function getActiveColor() {
  if (!window.location.pathname.includes('/products/')) return null;
  var product = getProductJSON();
  if (!product || !product.variants) return null;
  var v = getActiveVariant();
  return v && v.option1 != null ? v.option1 : null;
}


function getActiveVariant() {
  var product = getProductJSON();
  if (!product || !Array.isArray(product.variants)) {
    return null;
  }

  const params = new URLSearchParams(window.location.search);
  const urlVariantId = params.get('variant');

  if (urlVariantId && urlVariantId.length > 0) {
    return product.variants.find(x => x.id == urlVariantId) || null;
  }
  var btnVid = $('#add-to-cart-button').data('variant-id');
  if (btnVid != null && btnVid !== '') {
    return product.variants.find(x => x.id == btnVid) || null;
  }
  var firstAvail = product.variants.find(function(v) {
    return v.available;
  });
  return firstAvail || product.variants[0] || null;
}

jQuery(document.body).on('afterAddItem.ajaxCart', function(evt, line_item, form) {
  var product = getProductJSON();
  if (!window.location.pathname.includes('/products/') || !line_item || !product) return;
  var variant = product.variants && product.variants.find(function(v) { return v.id === line_item.variant_id; });
  if (!variant) return;
  var sizeOptionValue = variant.option2 || (variant.options && variant.options[1]);
  if (sizeOptionValue) {
    $('.size-selection .input-size, .size-selection .input-gift_card').each(function() {
      if ($(this).val() === sizeOptionValue) {
        $(this).prop('checked', true).trigger('change');
        return false;
      }
    });
  }
  updateAddToBagBtn(variant);
  seedDropDownUpdate();
});

function normalizeSwatchColorKey(value) {
  return String(value || '')
    .toLowerCase()
    .trim()
    .replace(/\s*\([^)]*\)\s*$/, '');
}

// Activate product image color swatcher
window.addEventListener("load", function(){
  if( typeof getActiveColor != 'undefined') {
    if (window.location.pathname.indexOf('/products/') !== -1) {
      activeColor = getActiveColor();
      var activeKey = normalizeSwatchColorKey(activeColor);
      $('.swatch-container').find('.swatch-element').removeClass('active');
      $('.swatch-container').find('.swatch-element').each(function () {
        var dataKey = normalizeSwatchColorKey($(this).attr('data-value'));
        if (activeKey && dataKey === activeKey) {
          $(this).addClass('active');
        }
      });
    }

    function updateActiveSwatchersSizeAndColor() {
      $('.swatch-selection').not('.size-selection').find('.swatch-element').on('click', function () {
        $('.swatch-selection').not('.size-selection').find('.swatch-element').removeClass('active');
        $(this).addClass('active');
      });
    }
    updateActiveSwatchersSizeAndColor();

    $(".product-images__each").on('click', function(){
      var imgSrc = $(this).attr('src');
      $(this).attr('src', imgSrc.replace("_540x", "_1296x"));
    });

    $('.swatch-element').find('.swatch-size-label').each(function() {
      if ($("#wip-"+$(this).data('variant-id')).length) {
          $(this).closest('.swatch-element').removeClass("soldout");
      }
    });

    $('.swatch-selection').find('.color').on('click', function() {
      try {
        updateAvailableSizes($(this));
      } catch (error) {
        console.error(error);
      }
    });

    function selectActiveColor() {
      var $fromChecked = $('.input-color[data-swatch-input]:checked').first().closest('.swatch-element.color');
      if ($fromChecked.length) {
        $fromChecked.trigger('click');
        return;
      }
      $('.swatch-selection').not('.size-selection').find('.swatch-element.active').first().trigger('click');
    }
    selectActiveColor();
  }
});

function waitForElm(selector) {
  return new Promise(resolve => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver(mutations => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });
    
    try {
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    } catch (error) {
      console.error(error);
    }
  });
}

var bisFrameSelector = '#BIS_frame, iframe[id^="BIS_"], iframe[name^="BIS_"]';
var bisFrameObserverMap = new Map();
var bisBodyObserver = null;
var bisBodyObserverActive = false;
var bisFrameA11yInitialized = false;
var bisFrameA11yTicking = false;
var bisDiscoveryPollTimer = null;
var bisDiscoveryPollDelayMs = 2000;

function isPdpPath() {
  return window.location.pathname.indexOf('/products/') !== -1;
}

function getBisFrames() {
  return Array.prototype.slice.call(document.querySelectorAll(bisFrameSelector));
}

function stopBisBodyObserver() {
  if (bisBodyObserver && bisBodyObserverActive) {
    bisBodyObserver.disconnect();
    bisBodyObserverActive = false;
  }
}

function startBisBodyObserver() {
  if (!bisBodyObserver || bisBodyObserverActive || !document.body) {
    return;
  }

  bisBodyObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
  bisBodyObserverActive = true;
}

function stopBisDiscoveryPoll() {
  if (bisDiscoveryPollTimer) {
    window.clearTimeout(bisDiscoveryPollTimer);
    bisDiscoveryPollTimer = null;
  }
}

function scheduleBisDiscoveryPoll() {
  if (bisDiscoveryPollTimer) {
    return;
  }

  bisDiscoveryPollTimer = window.setTimeout(function() {
    bisDiscoveryPollTimer = null;

    if (getBisFrames().length > 0) {
      scheduleBisDiscoveryPoll();
      return;
    }

    startBisBodyObserver();
    scheduleBisFrameAccessibilitySync();
  }, bisDiscoveryPollDelayMs);
}

function updateBisObservationMode(frameCount) {
  if (frameCount > 0) {
    stopBisBodyObserver();
    scheduleBisDiscoveryPoll();
    return;
  }

  stopBisDiscoveryPoll();
  startBisBodyObserver();
}

function isBisFrameVisible(frame) {
  if (!frame || !frame.isConnected) {
    return false;
  }

  var style = window.getComputedStyle(frame);
  var opacity = parseFloat(style.opacity || '1');
  if (
    style.display === 'none' ||
    style.visibility === 'hidden' ||
    style.pointerEvents === 'none' ||
    opacity === 0
  ) {
    return false;
  }

  var node = frame;
  while (node && node !== document.body) {
    if (node.nodeType !== 1) {
      node = node.parentElement;
      continue;
    }

    var nodeStyle = window.getComputedStyle(node);
    if (nodeStyle.display === 'none' || nodeStyle.visibility === 'hidden') {
      return false;
    }

    node = node.parentElement;
  }

  var rect = frame.getBoundingClientRect();
  if (!rect || rect.width <= 1 || rect.height <= 1) {
    return false;
  }

  var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
  var viewportWidth = window.innerWidth || document.documentElement.clientWidth;

  if (
    rect.bottom <= 0 ||
    rect.right <= 0 ||
    rect.top >= viewportHeight ||
    rect.left >= viewportWidth
  ) {
    return false;
  }

  return true;
}

function setBisFrameAccessibilityState(frame, shouldHide) {
  if (!frame) {
    return;
  }

  var hiddenByTheme = frame.getAttribute('data-bis-hidden-by-theme') === 'true';

  if (shouldHide && !hiddenByTheme) {
    frame.setAttribute(
      'data-bis-prev-aria-hidden',
      frame.hasAttribute('aria-hidden') ? frame.getAttribute('aria-hidden') : '__none__'
    );
    frame.setAttribute(
      'data-bis-prev-tabindex',
      frame.hasAttribute('tabindex') ? frame.getAttribute('tabindex') : '__none__'
    );
    frame.setAttribute('data-bis-prev-inert', frame.hasAttribute('inert') ? 'true' : 'false');
    frame.setAttribute('aria-hidden', 'true');
    frame.setAttribute('tabindex', '-1');
    frame.setAttribute('inert', '');
    frame.setAttribute('data-bis-hidden-by-theme', 'true');
    return;
  }

  if (!shouldHide && hiddenByTheme) {
    var prevAriaHidden = frame.getAttribute('data-bis-prev-aria-hidden');
    var prevTabindex = frame.getAttribute('data-bis-prev-tabindex');
    var prevInert = frame.getAttribute('data-bis-prev-inert');

    if (prevAriaHidden === '__none__') {
      frame.removeAttribute('aria-hidden');
    } else if (prevAriaHidden !== null) {
      frame.setAttribute('aria-hidden', prevAriaHidden);
    }

    if (prevTabindex === '__none__') {
      frame.removeAttribute('tabindex');
    } else if (prevTabindex !== null) {
      frame.setAttribute('tabindex', prevTabindex);
    }

    if (prevInert === 'true') {
      frame.setAttribute('inert', '');
    } else if (prevInert === 'false') {
      frame.removeAttribute('inert');
    }

    frame.removeAttribute('data-bis-prev-aria-hidden');
    frame.removeAttribute('data-bis-prev-tabindex');
    frame.removeAttribute('data-bis-prev-inert');
    frame.removeAttribute('data-bis-hidden-by-theme');
  }
}

function syncBisFrameAccessibilityState() {
  refreshBisFrameStateObservers();

  var bisFrames = getBisFrames();
  updateBisObservationMode(bisFrames.length);
  if (!bisFrames.length) {
    return;
  }

  bisFrames.forEach(function(frame) {
    setBisFrameAccessibilityState(frame, !isBisFrameVisible(frame));
  });
}

function scheduleBisFrameAccessibilitySync() {
  if (bisFrameA11yTicking) {
    return;
  }

  bisFrameA11yTicking = true;

  var runNextFrame = window.requestAnimationFrame || function(cb) {
    return window.setTimeout(cb, 16);
  };

  runNextFrame(function() {
    bisFrameA11yTicking = false;
    syncBisFrameAccessibilityState();
  });
}

function disconnectBisFrameObservers(frameState) {
  if (!frameState) {
    return;
  }

  if (frameState.frameObserver) {
    frameState.frameObserver.disconnect();
  }

  if (frameState.parentObserver) {
    frameState.parentObserver.disconnect();
  }
}

function cleanupDetachedBisFrameObservers() {
  bisFrameObserverMap.forEach(function(frameState, frame) {
    if (!document.body || !document.body.contains(frame)) {
      disconnectBisFrameObservers(frameState);
      bisFrameObserverMap.delete(frame);
    }
  });
}

function bindBisFrameObservers(frame) {
  if (!frame) {
    return;
  }

  var currentParent = frame.parentElement || null;
  var frameState = bisFrameObserverMap.get(frame);

  if (!frameState) {
    frameState = {
      frameObserver: null,
      parentObserver: null,
      parentElement: currentParent
    };

    frameState.frameObserver = new MutationObserver(scheduleBisFrameAccessibilitySync);
    frameState.frameObserver.observe(frame, {
      attributes: true,
      attributeFilter: ['style', 'class', 'hidden', 'aria-hidden']
    });

    if (currentParent) {
      frameState.parentObserver = new MutationObserver(scheduleBisFrameAccessibilitySync);
      frameState.parentObserver.observe(currentParent, {
        attributes: true,
        childList: true,
        attributeFilter: ['style', 'class', 'hidden', 'aria-hidden']
      });
    }

    bisFrameObserverMap.set(frame, frameState);
    return;
  }

  if (frameState.parentElement !== currentParent) {
    if (frameState.parentObserver) {
      frameState.parentObserver.disconnect();
      frameState.parentObserver = null;
    }

    frameState.parentElement = currentParent;

    if (currentParent) {
      frameState.parentObserver = new MutationObserver(scheduleBisFrameAccessibilitySync);
      frameState.parentObserver.observe(currentParent, {
        attributes: true,
        childList: true,
        attributeFilter: ['style', 'class', 'hidden', 'aria-hidden']
      });
    }
  }
}

function refreshBisFrameStateObservers() {
  cleanupDetachedBisFrameObservers();
  getBisFrames().forEach(bindBisFrameObservers);
}

function nodeMayContainBisFrame(node) {
  if (!node) {
    return false;
  }

  var isElementNode = node.nodeType === 1;
  var isDocumentFragmentNode = node.nodeType === 11;
  if (!isElementNode && !isDocumentFragmentNode) {
    return false;
  }

  if (isElementNode && node.matches && node.matches(bisFrameSelector)) {
    return true;
  }

  if (node.querySelector && node.querySelector(bisFrameSelector)) {
    return true;
  }

  return false;
}

function mutationTouchesBisFrame(mutations) {
  for (var i = 0; i < mutations.length; i++) {
    var mutation = mutations[i];

    if (nodeMayContainBisFrame(mutation.target)) {
      return true;
    }

    for (var j = 0; j < mutation.addedNodes.length; j++) {
      if (nodeMayContainBisFrame(mutation.addedNodes[j])) {
        return true;
      }
    }

    for (var k = 0; k < mutation.removedNodes.length; k++) {
      if (nodeMayContainBisFrame(mutation.removedNodes[k])) {
        return true;
      }
    }
  }

  return false;
}

function initBisFrameAccessibilityGuard() {
  if (bisFrameA11yInitialized || !document.body || !isPdpPath()) {
    return;
  }

  bisFrameA11yInitialized = true;

  bisBodyObserver = new MutationObserver(function(mutations) {
    if (!mutationTouchesBisFrame(mutations)) {
      cleanupDetachedBisFrameObservers();
      return;
    }

    refreshBisFrameStateObservers();
    scheduleBisFrameAccessibilitySync();
  });

  refreshBisFrameStateObservers();
  updateBisObservationMode(getBisFrames().length);
  scheduleBisFrameAccessibilitySync();

  window.addEventListener('resize', scheduleBisFrameAccessibilitySync);
  window.addEventListener('orientationchange', scheduleBisFrameAccessibilitySync);
  document.addEventListener('visibilitychange', scheduleBisFrameAccessibilitySync);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBisFrameAccessibilityGuard);
} else {
  initBisFrameAccessibilityGuard();
}

function updateModelInfoOnExpandedSelect(data, colorName) {
  var pin1 = document.querySelector("#pin1");
  if (pin1) {
    colorName = colorName.toLowerCase();
    for (var i = 0; i < data.length; i++) {
        if (data[i][colorName]) {
            var modelData = data[i][colorName];

            var firstName = modelData.model_name.split(' ')[0]; // assuming the model_name is in 'First Last' format
            var height = modelData.height ? JSON.parse(modelData.height) : {"value": "", "unit": ""};
            var size = modelData.garment_size ? JSON.parse(modelData.garment_size) : {"value": "", "unit": ""};

            var heightText = inchesToFeet(height.value) !== `0'0"` ? ` is ${inchesToFeet(height.value)}` : '';
            var sizeText = size.value !== "" ? ` | Size ${size.value}` : ` | Size S`;
            if (heightText == '' && sizeText == '' && firstName == '') {
                if (!pin1.classList.contains('d-none')) {
                    pin1.classList.add('d-none');
                }
            } else {
                if (pin1.classList.contains('d-none')) {
                    // pin1.classList.remove('d-none');
                }
                var p = document.querySelector(".pdp-pin__wrap-elem > p");
                if (p) {
                  console.log('p exists');
                  p.innerText = `${firstName}${heightText}${sizeText}`;
                } else {
                  console.log('p does not exist');
                }
            }
            return;
        }
    }
    // if no matching colorName is found, hide #pin1
    if (!pin1.classList.contains('d-none')) {
        pin1.classList.add('d-none');
    }
  }
}

function liveUpdateInfoInSizeFitTab(result) {
  if (result == 'Model:') {
    result = '';
    $('#tab_model-measure').removeClass('d-none');
    $('#tab_model-measure').addClass('d-none');
  } else {
    $('#tab_model-measure').removeClass('d-none').text(result);
  }

  $('#model_measure').text(result);
}

function liveUpdateModelMeasurements(result) {
  // if any value has a 0 in don't show this is text live
  if (!result.includes('0in')) {
    $('.wrap_model_measurements_text').text(result);
  } else {
    $('.wrap_model_measurements_text').text('');
  }
}

function liveUpdateModelHeightUnderSwitchers(height) {
    $('.wrap_model_height_text')
    .each(function() {
      if (height > 0) {
        $(this).text(`Model is ${inchesToFeet(height)}`);
      } else {
        $(this).text('');
      }
    });
}

// function buildModelMeasureText(data, colorName) {
//   colorName = colorName.toLowerCase();
//   updateModelInfoOnExpandedSelect(data, colorName);
//   var result = 'Model:';
//   for (var i = 0; i < data.length; i++) {
//     if (data[i][colorName]) {
//       var modelData = data[i][colorName];
//       if (modelData.height) {
//         var height = JSON.parse(modelData.height);
//         if (height.value !== 0) {
//           result += ` Height: ${inchesToFeet(height.value)}`;
//           updateFitText(inchesToFeet(height.value));
//         }
//       }
  
//       if (modelData.bust) {
//         var bust = JSON.parse(modelData.bust);
//         if (bust.value !== 0) {
//           result += ` Bust: ${bust.value}${bust.unit}`;
//         }
//       }
      
//       if (modelData.waist) {
//         var waist = JSON.parse(modelData.waist);
//         if (waist.value !== 0) {
//           result += ` Waist: ${waist.value}${waist.unit}`;
//         }
//       }
      
//       if (modelData.hips) {
//         var hips = JSON.parse(modelData.hips);
//         if (hips.value !== 0) {
//           result += ` Hips: ${hips.value}${hips.unit}`;
//         }
//       }
//       break; // stop the loop after finding the matching colorName
//     }
//   }
//   let currentModelData = productObjData.modelsData.find(model => model.styleNumColorCode === cleanAndRemoveSize(getActiveVariant.sku));
//   liveUpdateInfoInSizeFitTab(result);
//   liveUpdateModelHeightUnderSwitchers(currentModelData.height.value);
//   liveUpdateModelMeasurements(`Bust: ${currentModelData.bust.value}in Waist: ${currentModelData.waist.value}in Hips: ${currentModelData.hips.value}in`);
// }

function getModelByColor(colorName, models) {
  for (let i = 0; i < models.length; i++) {
      if (models[i][colorName]) {
          return models[i][colorName];
      }
  }
  return null;
}

function buildHTMLFromMeasurements(measurements) {
  var htmlString = '';
  if (measurements) {
    let measurementsObj = JSON.parse(measurements);
    // Build HTML string from measurements
    measurementsObj.forEach(measurement => {
      htmlString += `<div class="font-weight-bolder"><span class="garment_measure_title">${measurement.Measurement}:</span></div>`;
      htmlString += '<ul class="list-of-measurements mt-1">';
      for (const [key, value] of Object.entries(measurement)) {
        if (key !== 'Measurement') {
          htmlString += `<li>${key}: ${value}"</li>`;
        }
      }
      htmlString += '</ul>';
    });
  }
  return htmlString;
}

function pdpModelFieldValue(modelData, field) {
  if (!modelData || modelData[field] == null) return '';
  var raw = modelData[field];
  var val = (raw && typeof raw === 'object' && raw.value != null) ? raw.value : raw;
  if (val === '' || val === 0 || val === '0') return '';
  return String(val);
}

function pdpModelMeasurementsClause(modelData) {
  var items = [];
  var bust = pdpModelFieldValue(modelData, 'bust');
  var waist = pdpModelFieldValue(modelData, 'waist');
  var hips = pdpModelFieldValue(modelData, 'hips');
  if (bust) items.push(bust + '" bust');
  if (waist) items.push(waist + '" waist');
  if (hips) items.push(hips + '" hips');
  var withClause = '';
  if (items.length === 1) {
    withClause = ' with a ' + items[0];
  } else if (items.length === 2) {
    withClause = ' with a ' + items[0] + ' and ' + items[1];
  } else if (items.length === 3) {
    withClause = ' with a ' + items[0] + ', ' + items[1] + ', and ' + items[2];
  }
  return withClause;
}

function buildPdpSizeFitModelSentence(modelData, sizeText) {
  var height = false;
  if (modelData && typeof convertToFeetAndInches === 'function') {
    height = convertToFeetAndInches(modelData.height);
    if (height === 'Invalid unit') height = false;
  }
  var size = sizeText || 'S';
  var withClause = pdpModelMeasurementsClause(modelData);
  var core = height
    ? ('Model is ' + height + ' wearing size ' + size)
    : ('Model is wearing size ' + size);
  return core + withClause + '.';
}

function renderPdpSizeFitModelSentence(targetElem, modelData, sizeText) {
  var withClause = pdpModelMeasurementsClause(modelData).replace(/^\s+/, '');
  var sentence = buildPdpSizeFitModelSentence(modelData, sizeText);
  targetElem.text('');
  if (!withClause) {
    targetElem.text(sentence);
    return;
  }
  targetElem.append(document.createTextNode(sentence.slice(0, -(withClause.length + 2))));
  targetElem.append(document.createElement('br'));
  targetElem.append(document.createTextNode(withClause + '.'));
}

function parsePdpJsonScript(id) {
  var el = document.getElementById(id);
  if (!el) return [];
  var raw = (el.textContent || '').trim();
  if (!raw) return [];
  try {
    var parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
}

var pdpExplicitGarmentSize = '';
var pdpInitialUrlVariantId = '';
try {
  pdpInitialUrlVariantId = new URLSearchParams(window.location.search).get('variant') || '';
} catch (e) {
  pdpInitialUrlVariantId = '';
}

function pdpSizeFromVariant(variant) {
  if (!variant) return '';
  return String(variant.option2 || (variant.options && variant.options[1]) || '').trim();
}

function pdpRememberGarmentSize(size) {
  if (size) pdpExplicitGarmentSize = size;
  return pdpExplicitGarmentSize;
}

function pdpInitialUrlVariant() {
  if (!pdpInitialUrlVariantId) return null;
  var product = typeof getProductJSON === 'function' ? getProductJSON() : null;
  if (!product || !Array.isArray(product.variants)) return null;
  return product.variants.find(function(variant) {
    return variant.id == pdpInitialUrlVariantId;
  }) || null;
}

function pdpGarmentSpecSize(target, variantFromEvent) {
  var checked = document.querySelector('.size-selection .input-size:checked');
  var eventSize = pdpSizeFromVariant(variantFromEvent);

  if (checked && checked.value) {
    if (eventSize) return pdpRememberGarmentSize(eventSize);
    return pdpRememberGarmentSize(String(checked.value));
  }

  if (pdpExplicitGarmentSize) return pdpExplicitGarmentSize;

  var urlSize = pdpSizeFromVariant(pdpInitialUrlVariant());
  if (urlSize) return pdpRememberGarmentSize(urlSize);

  return (target && target.getAttribute('data-default-size')) || '';
}

function pdpNormalizeSizeKey(raw) {
  var s = String(raw || '').trim();
  if (!s) return '';
  s = s.replace(/^size\s+/i, '').trim();
  var key = s.toLowerCase().replace(/[-_]/g, ' ').replace(/\s+/g, ' ');
  var map = {
    'extra small': 'XS',
    'x small': 'XS',
    xs: 'XS',
    xsmall: 'XS',
    small: 'S',
    s: 'S',
    medium: 'M',
    m: 'M',
    large: 'L',
    l: 'L',
    'extra large': 'XL',
    'x large': 'XL',
    xl: 'XL',
    xlarge: 'XL',
    'xx large': 'XXL',
    xxl: 'XXL',
    '2x': 'XXL',
    '2xl': 'XXL'
  };
  return map[key] || s;
}

function pdpSpecValueForSize(row, sizeRaw) {
  if (!row) return '';
  var key = pdpNormalizeSizeKey(sizeRaw);
  if (key && row[key] != null && row[key] !== '') return String(row[key]);
  if (key && row['Size ' + key] != null && row['Size ' + key] !== '') return String(row['Size ' + key]);
  if (sizeRaw && row[sizeRaw] != null && row[sizeRaw] !== '') return String(row[sizeRaw]);
  return '';
}

function pdpSpecLabel(name) {
  var n = String(name || '').toUpperCase();
  if (n.indexOf('INSEAM') !== -1) return 'Inseam';
  if (n.indexOf('FRONT RISE') !== -1) return 'Front Rise';
  if (n.indexOf('LEG OPENING') !== -1) return 'Leg Opening';
  if (n.indexOf('BUST') !== -1) return 'Bust';
  if (n.indexOf('WAIST') !== -1) return 'Waist';
  if (n.indexOf('HIP') !== -1) return 'Hips';
  if (n.indexOf('LENGTH') !== -1) return 'Length';
  if (!name) return '';
  return String(name).replace(/\w\S*/g, function(word) {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  });
}

function buildPdpGarmentSpecLine(specs, sizeRaw) {
  if (!sizeRaw || !specs.length) return '';
  var inseam = '';
  var parts = [];
  for (var i = 0; i < specs.length; i++) {
    var row = specs[i];
    if (!row || !row.Measurement) continue;
    var val = pdpSpecValueForSize(row, sizeRaw);
    if (!val) continue;
    if (val.indexOf('"') === -1) val += '"';
    var label = pdpSpecLabel(row.Measurement);
    var piece = label + ': ' + val;
    if (label === 'Inseam') inseam = piece;
    else parts.push(piece);
  }
  if (inseam) parts.unshift(inseam);
  if (!parts.length) return '';
  return parts.join(' • ') + ' (Size ' + pdpNormalizeSizeKey(sizeRaw) + ')';
}

function updatePdpGarmentSpecLine(variantFromEvent) {
  var targets = document.querySelectorAll('.tab_garment-specs');
  if (!targets.length) return;
  var sizeRaw = pdpGarmentSpecSize(targets[0], variantFromEvent);
  var specs = parsePdpJsonScript('pdp-garment-specs-json').concat(
    parsePdpJsonScript('pdp-garment-specs-manual-json')
  );
  var line = buildPdpGarmentSpecLine(specs, sizeRaw);
  if (!line) {
    var fallback = targets[0].getAttribute('data-default-size') || '';
    if (fallback && fallback !== sizeRaw) line = buildPdpGarmentSpecLine(specs, fallback);
  }
  if (!line) return;
  for (var i = 0; i < targets.length; i++) {
    targets[i].textContent = line;
  }
}

function updateFitText(feetHeight) {

    if (typeof prodDescriptionObj !== 'undefined') {
      if(prodDescriptionObj['FIT']) {
        if (prodDescriptionObj['FIT'].split("Model")[0]) {
          var sizeTrueOrOversizeInfo = prodDescriptionObj['FIT'].split("Model")[0].trimEnd();
        } else {
          var sizeTrueOrOversizeInfo = "";
        }
      }
    }


     
    if ($(".fit-text").length) {
      $(".fit-text").each(function() {
        $(this).html(`<p>${sizeTrueOrOversizeInfo} Model is ${feetHeight} and wearing size S.</p>`);
      });
        
    } else if ($(".fit-text--new-pdp").length) {
      $(".fit-text--new-pdp").each(function() {
        $(this).html(`wearing size S.`);
      });
    } else {
      console.error("Div element with class 'fit-text' or 'fit-text--new-pdp' not found.");
     }
}

function getProductDetails(colorName) {
  var productDataElement = $("script[data-product-json]");
  var productData = JSON.parse(productDataElement.html());
  for(var i = 0; i < productData.variants.length; i++) {
      var variant = productData.variants[i];
      if(variant.title.includes(colorName)) {
          var skuParts = variant.sku.split('-');
          var styleNumber = skuParts[0];
          var colorCode = skuParts[1];
          return {
              styleNumber: styleNumber,
              colorCode: colorCode,
              variantId: variant.id
          };
      }
  }
  return null;
}

// This is script for size guide modal
window.addEventListener("load", function () {
  $('.size-guide-modal-element .tab-pane').hide();

  // Then show the first (or any active) one
  $('.size-guide-modal-element .tab-pane.active').show();

  // When a tab is clicked
  $('.size-guide-modal-element .nav-item .nav-link').click(function () {
    // Remove 'active' class from all tabs
    $('.size-guide-modal-element .nav-item .nav-link')
      .removeClass('active')
      .addClass('btn--white');

    // Add 'active' class to the current tab
    $(this).addClass('active');
    $(this).removeClass('btn--white');

    // Hide all tab content divs
    $('.size-guide-modal-element .tab-pane').hide();

    // Show the content div with the id equal to the button's data-target attribute
    $($(this).data('target')).show();
  });
});

var updateCssStyleForWairBtn = setInterval(function() {
  if ($('.wair-css.wair-css.wair-css .wr-text-base').length) {
    $('.wair-css.wair-css.wair-css .wr-text-base').attr('style', 'font-size: 14px !important; max-width: fit-content;');
    clearInterval(updateCssStyleForWairBtn);
  }
}, 100);

var updateCssStyleForDonationBlock = setInterval(function() {
  if ($('.gng-ru--donationBlockOuter').length) {
    $('.gng-ru--donationBlockOuter').attr('style', 'margin: 16px 0 !important;');
    clearInterval(updateCssStyleForDonationBlock);
  }
}, 100);

function updateWhenClickOnColorSwatch(swatchElem) {
  let prodCard = swatchElem.closest('.product-card');
  let varBadgeText = swatchElem.data('variant-badge-under-the-image')
  let hasCollectionBadgeData = typeof swatchElem.attr('data-badge-in-collection') !== 'undefined';

  function sanitizeCssColor(value) {
    var color = String(value || '').trim();
    var isValid = /^(#[0-9a-fA-F]{3,8}|rgba?\(\s*(\d{1,3}%?\s*,\s*){2}\d{1,3}%?(\s*,\s*(0|1|0?\.\d+|100%))?\s*\)|hsla?\(\s*\d{1,3}(deg)?\s*,\s*\d{1,3}%\s*,\s*\d{1,3}%(\s*,\s*(0|1|0?\.\d+|100%))?\s*\)|[a-zA-Z]+)$/.test(color);
    return isValid ? color : '';
  }

  if (hasCollectionBadgeData) {
    let collectionBadgeText = swatchElem.attr('data-badge-in-collection');
    let collectionBadgeSource = swatchElem.attr('data-badge-in-collection-source');
    let collectionBadge = prodCard.find('.product-card__badge-container').first();

    if (!collectionBadge.length) {
      prodCard.find('.product-card__image-ratio').append('<div class="product-card__badge-container d-none"></div>');
      collectionBadge = prodCard.find('.product-card__badge-container').first();
    }

    if (collectionBadgeText) {
      collectionBadge.text(collectionBadgeText).removeClass('d-none');
      if (collectionBadgeSource === 'product') {
        collectionBadge.css({
          backgroundColor: sanitizeCssColor(swatchElem.attr('data-product-badge-background-color')),
          color: sanitizeCssColor(swatchElem.attr('data-product-badge-text-color'))
        });
      } else {
        collectionBadge.css({
          backgroundColor: '',
          color: ''
        });
      }
    } else {
      collectionBadge.text('').addClass('d-none').css({
        backgroundColor: '',
        color: ''
      });
    }
  }

  prodCard.find('.custom-field__product-badges').addClass("d-none");
  if (varBadgeText) {
    prodCard.find('.badge__variant-level').text(varBadgeText).removeClass('d-none');
  } else {
    prodCard.find('.badge__variant-level').text('').addClass('d-none');
    if (prodCard.find('.badge__product-level').text().trim()) {
      prodCard.find('.badge__product-level').removeClass('d-none');
    }
  }
}

document.addEventListener("DOMContentLoaded", function() {
  selectSingleSizeIfOnlyOne();
  var variant = getActiveVariant();
  if (variant) {
    updateAddToBagBtn(variant);
  }
  updatePdpGarmentSpecLine();
});

const reviseATCScroll = () => {
  window.addEventListener("load", function() {
      const originalSampleFunction = window.onscroll;

      function newSampleFunction() {
          if (
            document.body.classList.contains('mobile-sticky-atc-variation--1') ||
            document.body.classList.contains('mobile-sticky-atc-variation--2')
          ) {
            return;
          }

          const scrollTopFixedBtn = 1250;
          const atcTop = document.getElementById("atc-top");
          const mainBtn = document.getElementById("add-to-cart-button");
          const show = document.body.scrollTop > scrollTopFixedBtn || document.documentElement.scrollTop > scrollTopFixedBtn;
          const showMain = show && mainBtn && !mainBtn.disabled && !mainBtn.classList.contains('d-none');
          const showMirror = show && atcTop && !showMain;

          if (atcTop) atcTop.classList.toggle("atc-active", showMirror);
          if (mainBtn) mainBtn.classList.toggle("atc-active", showMain);

          const whiteDiv = document.getElementById("white-div");
          if (whiteDiv) whiteDiv.classList.toggle("atc-active", show);
      }
      newSampleFunction();

      // Override the window.onscroll function with the new one
      window.onscroll = newSampleFunction;
  });
}

const wrapATCButton = () => {
  const whiteDiv = document.createElement('div');
  whiteDiv.id = "white-div";
  const atcButton = document.getElementById('atc-top');
  atcButton.parentNode.insertBefore(whiteDiv, atcButton);
  whiteDiv.appendChild(atcButton);
}

waitForElm("#atc-top").then((elm) => {
  wrapATCButton
});

waitForElm("#add-to-cart-button").then((elm) => {
  reviseATCScroll
});

function callSizeGuide() {
  $('[js-size-guide]').trigger('click');
}

jQuery(document).ready(function($) {
  var heightActiveTab = $("#product-detail-page__tabs").find(".first-tab").height();
  // Add height to $("#product-detail-page__tabs").find(".second-tab")
  $("#product-detail-page__tabs").find(".second-tab").css("height", heightActiveTab + "px");
  // Add overflow-y: auto to $("#product-detail-page__tabs").find(".second-tab")
  $("#product-detail-page__tabs").find(".second-tab").css("overflow-y", "auto");
});

function scrollToSizeGuideButtonMobile() {
  const accordion = document.querySelector('#sizeAndFitAccordion');
  if (!accordion) return;
  
  var $accordionHeader = $(accordion).find('.accordion-header');
  var isAlreadyOpen = $accordionHeader.hasClass('show');

  if (!isAlreadyOpen) {
    $accordionHeader.trigger('click');
  }

  const header = document.getElementById('header-container');
  const headerRect = header ? header.getBoundingClientRect() : { bottom: 0 };
  const accordionRect = accordion.getBoundingClientRect();
  const targetY = window.scrollY + accordionRect.top - headerRect.bottom;
  window.scrollTo({ top: targetY, behavior: 'smooth' });
}

function scrollToSizeGuideButtonDesktop() {
  $("#size_and_fit_desk_btn").trigger('click');

  var hOfMedia = $('.product-media__container').outerHeight();
  var hOfProductInfo = $('#product-info').outerHeight();
  var hOfHeader = 182;
  var tabLocation = $('#product-detail-page__tabs').offset().top;
  var scrollToPosition = tabLocation + hOfHeader + (hOfMedia - hOfProductInfo);

  if (hOfMedia < hOfProductInfo) {
    document.documentElement.scrollTop = $('#product-detail-page__tabs').offset().top - 182;
  } else {
    if ($('.product-media__container').outerHeight() - $('#product-info').outerHeight() > window.pageYOffset) {
      var scrollToPosition = (hOfMedia - hOfProductInfo + tabLocation - hOfHeader) - window.pageYOffset;
      scrollToPosition = window.pageYOffset < 50 ? scrollToPosition : scrollToPosition + 46;
      document.documentElement.scrollTop = scrollToPosition; // For Chrome, Firefox, IE and Opera
    } else {
      document.documentElement.scrollTop = $('#product-detail-page__tabs').offset().top - 184;
    }
  }
}

function scrollToSizeGuide() {
  var sizeDrawer = document.getElementById('mobile-sticky-atc-size-drawer');
  if (sizeDrawer && document.body.classList.contains('js-drawer-open-size-select')) {
    document.body.classList.remove('js-drawer-open', 'js-drawer-open-size-select');
    sizeDrawer.setAttribute('aria-hidden', 'true');
    sizeDrawer.classList.remove('is-adding');
    sizeDrawer.setAttribute('aria-busy', 'false');
  }

  if (window.innerWidth < 768) {
    scrollToSizeGuideButtonMobile();
  } else {
    scrollToSizeGuideButtonDesktop();
  }
}

function getYotpoRatingBottomline(productId) {
  return new Promise((resolve, reject) => {
    $.get("https://api.yotpo.com/v1/widget/enAOaNpJKUtBdeMh0FV2HDijFDYB2wkWZW9hbG5z/products/" + productId + "/reviews.json", function (data) {
       
      if (data.status.code == 200 && data.response && data.response.bottomline) {
        const bottomline = data.response.bottomline;
        const totalReview = bottomline.total_review;
        const average_score = bottomline.average_score;
        if (totalReview && totalReview >= 1) {
          if (average_score >= 4) {
            $("#product-info .wrap-yotpo_review").removeClass('opacity-0').removeClass('d-none');
          }
          $("#product-overview__wrapper .wrap--review").removeClass('d-none');
          $("#accordion-wrapper #reviewAccordion .wrap_yotpo-single-product").removeClass('d-none');

          $( '<span class="custom_yotpo-raiting">('+totalReview+')</span>' ).prependTo( "#reviewAccordion .accordion-header .yotpo-bottomline" );
        };

        resolve(data.response.bottomline);
      } else {
        reject("Can't get Yotpo bottomline for this product");
      }
    }).fail(function (error) {
      reject("Error fetching Yotpo data: " + error);
    });
  });
  /* Use example */
  /* 
    getYotpoRatingBottomline(productId)
    .then(bottomline => {
      // Do something with bottomline, e.g., update the UI
      console.log(bottomline);
    })
    .catch(error => {
      console.error(error);
    }); 
  */
}

function pluralize(word, count) {
  return count === 1 ? word : word + 's';
}

document.addEventListener("DOMContentLoaded", function() {
  var product = getProductJSON();
  if (!product || !product.id) return;

  getYotpoRatingBottomline(product.id);
});

theme.HomepageCarousel = (function(){
  var selectors = {
    carousel: '[js-homepage-carousel]'
  }

  function HomepageCarousel(container) {
    this.$container = $(container);
    var $carousel = $(selectors.carousel, this.$container);

    $carousel.slick({
      arrows: false,
      dots: true,
      fade: true,
      autoplay: true,
      autoplaySpeed: 5000,
      speed: 2000
    })
  }

  return HomepageCarousel;
})();

theme.LiveTextImageBanner = (function() {
  var selectors = {
    carousel: '.js-live-text-image-banner-carousel',
    pauseItem: '.live-text-image-banner__pause',
    slide: '.live-text-image-banner__slide',
    video: 'video'
  };

  var pauseIconUrl = 'https://cdn.shopify.com/s/files/1/0076/7075/9477/files/Pause_ed50db3f-4543-4af7-9d98-423fb789f49f.svg?v=1776453597';
  var playIconUrl = 'https://cdn.shopify.com/s/files/1/0076/7075/9477/files/Play_14b6bbe7-8936-45a7-a306-a678fcaf731b.svg?v=1776453597';

  function readBool(value) {
    return value === true || value === 'true';
  }

  function readNumber(value, fallback) {
    var parsed = parseInt(value, 10);
    return isNaN(parsed) ? fallback : parsed;
  }

  function LiveTextImageBanner(container) {
    this.$container = $(container);
    this.$carousel = $(selectors.carousel, this.$container);
    this.$shopifySection = this.$container.closest('.shopify-section');

    this.autoplayTimer = null;
    this.isPaused = false;
    this.pauseButtonSetState = null;
    this.windowEventNamespace = '.liveTextImageBanner-' + this.$container.attr('data-section-id');

    if (!this.$carousel.length || this.$carousel.hasClass('slick-initialized')) {
      return;
    }

    this.settings = {
      arrows: readBool(this.$container.attr('data-slider-arrows')),
      dots: readBool(this.$container.attr('data-slider-dots')),
      fade: readBool(this.$container.attr('data-slider-fade')),
      autoplay: readBool(this.$container.attr('data-slider-autoplay')),
      autoplaySpeed: readNumber(this.$container.attr('data-slider-autoplay-speed'), 5000),
      speed: readNumber(this.$container.attr('data-slider-speed'), 2000),
      singleVideoSlide: readBool(this.$container.attr('data-single-video-slide'))
    };

    this.durationList = this.$carousel.find(selectors.slide).map(function(index, item) {
      return readNumber(item.getAttribute('data-time'), 0);
    }).get();

    this._init();
  }

  LiveTextImageBanner.prototype = $.extend({}, LiveTextImageBanner.prototype, {
    _init: function() {
      var firstSectionId = $('#MainContent').find('.shopify-section').first().attr('id');

      this.isMainSlider = !!firstSectionId &&
        this.$shopifySection.length &&
        firstSectionId === this.$shopifySection.attr('id');

      this.$carousel.slick({
        arrows: this.settings.arrows,
        dots: this.settings.dots,
        fade: this.settings.fade,
        autoplay: this.isMainSlider ? false : this.settings.autoplay,
        autoplaySpeed: this.settings.autoplaySpeed,
        speed: this.settings.speed
      });

      if (this._isSingleVideoSlider()) {
        this._initSingleVideoControl();
        return;
      }

      if (this.isMainSlider) {
        if (this.settings.autoplay) {
          this._bindMainSliderEvents();
          this._appendPauseButton(this._toggleMainSliderPause.bind(this));
          this._scheduleCurrentSlide();
        }

        return;
      }

      if (this.settings.autoplay) {
        this._appendPauseButton(this._toggleAutoplay.bind(this));
      }
    },

    _isSingleVideoSlider: function() {
      if (!this.settings.singleVideoSlide) {
        return false;
      }

      var slickInstance = this.$carousel.hasClass('slick-initialized')
        ? this.$carousel.slick('getSlick')
        : null;

      if (!slickInstance || slickInstance.slideCount !== 1) {
        return false;
      }

      return this.$carousel
        .find(selectors.slide)
        .not('.slick-cloned')
        .first()
        .find(selectors.video)
        .length > 0;
    },

    _initSingleVideoControl: function() {
      this._appendPauseButton(this._toggleSingleVideoPause.bind(this), {
        allowSingleSlide: true,
        createWithoutDots: true,
        initialPaused: this._isCurrentVideoPaused(),
        pauseLabel: 'Pause video',
        playLabel: 'Play video'
      });

      this._bindSingleVideoEvents();
      this._syncSingleVideoButton();
    },

    _bindSingleVideoEvents: function() {
      this.$carousel
        .find(selectors.slide)
        .not('.slick-cloned')
        .find(selectors.video)
        .off('.liveTextImageBanner')
        .on(
          'play.liveTextImageBanner pause.liveTextImageBanner ended.liveTextImageBanner',
          function() {
            this._syncSingleVideoButton();
          }.bind(this)
        );

      $(window)
        .off(this.windowEventNamespace)
        .on('resize' + this.windowEventNamespace, function() {
          this._syncSingleVideoButton();
        }.bind(this));
    },

    _getCurrentVideo: function() {
      var slideIndex = this._getCurrentSlideIndex();

      var $slide = this.$carousel
        .find(selectors.slide)
        .not('.slick-cloned')
        .eq(slideIndex);

      var $videos = $slide.find(selectors.video);

      if (!$videos.length) {
        return $();
      }

      var $visibleVideos = $videos.filter(function() {
        return $(this).is(':visible');
      });

      return $visibleVideos.length ? $visibleVideos.first() : $videos.first();
    },

    _isCurrentVideoPaused: function() {
      var video = this._getCurrentVideo().get(0);

      if (!video) {
        return true;
      }

      return video.paused;
    },

    _toggleSingleVideoPause: function(paused) {
      var video = this._getCurrentVideo().get(0);

      if (!video) {
        return;
      }

      if (paused) {
        video.pause();
        this._syncSingleVideoButton();
        return;
      }

      var playPromise = video.play();

      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function() {
          this._syncSingleVideoButton();
        }.bind(this));
      }
    },

    _syncSingleVideoButton: function() {
      if (typeof this.pauseButtonSetState === 'function') {
        this.pauseButtonSetState(this._isCurrentVideoPaused());
      }
    },

    _bindMainSliderEvents: function() {
      this.$carousel.on('beforeChange.liveTextImageBanner', function() {
        this._clearAutoplayTimer();
      }.bind(this));

      this.$carousel.on('afterChange.liveTextImageBanner', function(event, slick, currentSlide) {
        if (this.isPaused) {
          return;
        }

        this._scheduleCurrentSlide(currentSlide);
      }.bind(this));
    },

    _appendPauseButton: function(onToggle, options) {
      options = options || {};

      var dots = this.$carousel.find('.slick-dots');
      var slickInstance = this.$carousel.hasClass('slick-initialized')
        ? this.$carousel.slick('getSlick')
        : null;

      if (!slickInstance || this.$carousel.find(selectors.pauseItem).length) {
        return;
      }

      if (!options.allowSingleSlide && slickInstance.slideCount < 2) {
        return;
      }

      if (!dots.length && !options.createWithoutDots) {
        return;
      }

      var controls = dots.length
        ? dots.closest('.live-text-image-banner__controls')
        : this.$carousel.children('.live-text-image-banner__controls').first();

      if (!controls.length) {
        if (dots.length) {
          dots.wrap('<div class="live-text-image-banner__controls d-flex align-items-center justify-content-end"></div>');
          controls = dots.parent();
        } else {
          controls = $('<div class="live-text-image-banner__controls d-flex align-items-center justify-content-end"></div>');
          this.$carousel.append(controls);
        }
      }

      var pauseLabel = options.pauseLabel || 'Pause autoplay';
      var playLabel = options.playLabel || 'Resume autoplay';
      var isButtonPaused = options.initialPaused === true;

      var pauseItem = $('<div class="live-text-image-banner__pause"></div>');
      var pauseButton = $('<button type="button" class="live-text-image-banner__pause-button"></button>');
      var pauseIcon = $('<img>');

      function setButtonState(paused) {
        isButtonPaused = paused;

        pauseButton
          .attr('aria-pressed', paused ? 'true' : 'false')
          .attr('aria-label', paused ? playLabel : pauseLabel);

        pauseIcon
          .attr('src', paused ? playIconUrl : pauseIconUrl)
          .attr('alt', paused ? playLabel : pauseLabel);
      }

      this.pauseButtonSetState = setButtonState;

      pauseButton.on('click', function() {
        var nextPausedState = !isButtonPaused;

        setButtonState(nextPausedState);
        onToggle(nextPausedState);
      });

      setButtonState(isButtonPaused);

      pauseButton.append(pauseIcon);
      pauseItem.append(pauseButton);
      controls.append(pauseItem);
    },

    _clearAutoplayTimer: function() {
      if (this.autoplayTimer) {
        clearTimeout(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    },

    _getCurrentSlideIndex: function() {
      if (!this.$carousel.hasClass('slick-initialized')) {
        return 0;
      }

      return this.$carousel.slick('slickCurrentSlide');
    },

    _scheduleCurrentSlide: function(currentSlide) {
      var self = this;
      var slideIndex = typeof currentSlide === 'number' ? currentSlide : this._getCurrentSlideIndex();
      var timing = this.durationList[slideIndex] || this.settings.autoplaySpeed;

      this._clearAutoplayTimer();

      if (!this.durationList.length || this.isPaused) {
        return;
      }

      this.autoplayTimer = setTimeout(function() {
        if (self.isPaused) {
          return;
        }

        self.$carousel.slick('slickNext');
      }, timing);
    },

    _toggleMainSliderPause: function(paused) {
      this.isPaused = paused;

      if (this.isPaused) {
        this._clearAutoplayTimer();
        return;
      }

      this._scheduleCurrentSlide();
    },

    _toggleAutoplay: function(paused) {
      if (paused) {
        this.$carousel.slick('slickPause');
        return;
      }

      this.$carousel.slick('slickPlay');
    },

    onUnload: function() {
      this._clearAutoplayTimer();

      $(window).off(this.windowEventNamespace);

      if (this.$carousel) {
        this.$carousel.find(selectors.video).off('.liveTextImageBanner');
      }

      if (this.$carousel && this.$carousel.hasClass('slick-initialized')) {
        this.$carousel.off('.liveTextImageBanner');
        this.$carousel.slick('unslick');
      }
    }
  });

  return LiveTextImageBanner;
})();
theme.HomepageFeaturedProducts = (function(){
  
    function HomepageFeaturedProducts(container) {
        enquire.register(theme.config.mediaQueries.largeUp,{
            match: function(){
                if ( $("[js-featured-collection]").hasClass("slick-initialized")){
                    $("[js-featured-collection]").slick("unslick");
                }
                $("[js-featured-collection]").slick({
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    centerPadding: '13%',
                    centerMode: true,
                    arrows: true,
                    prevArrow: '<button class="homepage-featured-products__content-prev"><svg width="12px" height="23px" viewBox="0 0 12 23" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Approved-Pages" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Product-Page-" transform="translate(-61.000000, -2679.000000)" fill="#000000" fill-rule="nonzero"><g id="Group-43" transform="translate(43.000000, 2460.000000)"><g id="Group-6" transform="translate(0.000000, 207.000000)"><g id="noun_right_753734-(1)" transform="translate(24.000000, 23.500000) scale(-1, 1) translate(-24.000000, -23.500000) translate(18.000000, 12.000000)"><polygon id="Path" points="0.99489085 23 0 21.9606329 10.0130051 11.5 0 1.03936709 0.99489085 0 12 11.5"></polygon></g></g></g></g></g></svg></button>',
                    nextArrow: '<button class="homepage-featured-products__content-next"><svg width="12px" height="23px" viewBox="0 0 12 23" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Approved-Pages" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Product-Page-" transform="translate(-1368.000000, -2679.000000)" fill="#000000" fill-rule="nonzero"><g id="Group-43" transform="translate(43.000000, 2460.000000)"><g id="Group-6-Copy" transform="translate(1331.500000, 230.500000) scale(-1, 1) translate(-1331.500000, -230.500000) translate(1308.000000, 207.000000)"><g id="noun_right_753734-(1)" transform="translate(24.000000, 23.500000) scale(-1, 1) translate(-24.000000, -23.500000) translate(18.000000, 12.000000)"><polygon id="Path" points="0.99489085 23 0 21.9606329 10.0130051 11.5 0 1.03936709 0.99489085 0 12 11.5"></polygon></g></g></g></g></g></svg></button>'
                })
            },
            unmatch: function(){
            }
        }).register(theme.config.mediaQueries.medium, {
            match: function(){
                if ( $("[js-featured-collection]").hasClass("slick-initialized")){
                    $("[js-featured-collection]").slick("unslick");
                }
                $("[js-featured-collection]").slick({
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerPadding: '16%',
                    centerMode: true,
                    arrows: true,
                    prevArrow: '<button class="homepage-featured-products__content-prev"><svg width="12px" height="23px" viewBox="0 0 12 23" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Approved-Pages" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Product-Page-" transform="translate(-61.000000, -2679.000000)" fill="#000000" fill-rule="nonzero"><g id="Group-43" transform="translate(43.000000, 2460.000000)"><g id="Group-6" transform="translate(0.000000, 207.000000)"><g id="noun_right_753734-(1)" transform="translate(24.000000, 23.500000) scale(-1, 1) translate(-24.000000, -23.500000) translate(18.000000, 12.000000)"><polygon id="Path" points="0.99489085 23 0 21.9606329 10.0130051 11.5 0 1.03936709 0.99489085 0 12 11.5"></polygon></g></g></g></g></g></svg></button>',
                    nextArrow: '<button class="homepage-featured-products__content-next"><svg width="12px" height="23px" viewBox="0 0 12 23" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Approved-Pages" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Product-Page-" transform="translate(-1368.000000, -2679.000000)" fill="#000000" fill-rule="nonzero"><g id="Group-43" transform="translate(43.000000, 2460.000000)"><g id="Group-6-Copy" transform="translate(1331.500000, 230.500000) scale(-1, 1) translate(-1331.500000, -230.500000) translate(1308.000000, 207.000000)"><g id="noun_right_753734-(1)" transform="translate(24.000000, 23.500000) scale(-1, 1) translate(-24.000000, -23.500000) translate(18.000000, 12.000000)"><polygon id="Path" points="0.99489085 23 0 21.9606329 10.0130051 11.5 0 1.03936709 0.99489085 0 12 11.5"></polygon></g></g></g></g></g></svg></button>'
                })
            },
            unmatch: function(){        
            }
        }).register(theme.config.mediaQueries.smallDown, {
            match: function(){
                if ( $("[js-featured-collection]").hasClass("slick-initialized")){
                    $("[js-featured-collection]").slick("unslick");
                }
                $("[js-featured-collection]").slick({
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows: true,
                    prevArrow: '<button class="homepage-featured-products__content-prev"><svg width="12px" height="23px" viewBox="0 0 12 23" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Approved-Pages" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Product-Page-" transform="translate(-61.000000, -2679.000000)" fill="#000000" fill-rule="nonzero"><g id="Group-43" transform="translate(43.000000, 2460.000000)"><g id="Group-6" transform="translate(0.000000, 207.000000)"><g id="noun_right_753734-(1)" transform="translate(24.000000, 23.500000) scale(-1, 1) translate(-24.000000, -23.500000) translate(18.000000, 12.000000)"><polygon id="Path" points="0.99489085 23 0 21.9606329 10.0130051 11.5 0 1.03936709 0.99489085 0 12 11.5"></polygon></g></g></g></g></g></svg></button>',
                    nextArrow: '<button class="homepage-featured-products__content-next"><svg width="12px" height="23px" viewBox="0 0 12 23" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Approved-Pages" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Product-Page-" transform="translate(-1368.000000, -2679.000000)" fill="#000000" fill-rule="nonzero"><g id="Group-43" transform="translate(43.000000, 2460.000000)"><g id="Group-6-Copy" transform="translate(1331.500000, 230.500000) scale(-1, 1) translate(-1331.500000, -230.500000) translate(1308.000000, 207.000000)"><g id="noun_right_753734-(1)" transform="translate(24.000000, 23.500000) scale(-1, 1) translate(-24.000000, -23.500000) translate(18.000000, 12.000000)"><polygon id="Path" points="0.99489085 23 0 21.9606329 10.0130051 11.5 0 1.03936709 0.99489085 0 12 11.5"></polygon></g></g></g></g></g></svg></button>'
                })
            },
            unmatch: function(){        
            }
        })

        // Initial Swatches for Featured Collection
        $(".homepage-featured-products .swatch-selection").each(function(){
            var $firstElement = $(this).find(".swatch-element:first-child");
            $firstElement.find(".color__border").addClass("active");
        })
        $(".homepage-featured-products .color__border").on("click", function(){
            var $parent = $(this).parent(".swatch-element");
            var $container = $parent.parent(".swatch-selection")
            $container.find(".color__border.active").removeClass("active");
            $(this).addClass("active");
        })

    }

    return HomepageFeaturedProducts;
})();
  
theme.HeroCarousel = (function(){
  var selectors = {
    carousel: '[js-hero-carousel]'
  }

  function HeroCarousel(container) {
    this.$container = $(container);
    var $carousel = $(selectors.carousel, this.$container);

    $carousel.slick({
      arrows: false,
      dots: true,
      fade: true,
      autoplay: true,
      autoplaySpeed: 5000,
      speed: 700
    })
  }

  return HeroCarousel;
})();

/**
 * RelatedProducts Section Script
 * Shopify Plus Only - https://help.shopify.com/en/themes/development/recommended-products
 * ------------------------------------------------------------------------------
 *
   * @namespace relatedProducts
 */

function _escapeHtmlRelated(str) {
  if (str == null) {
    return '';
  }
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function _renderRelatedProductImages(item) {
  var widths = '[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]';
  var html = '';

  if (item.variantImageArray && item.variantImageArray.length) {
    item.variantImageArray.forEach(function(img, index) {
      var activeClass = index === 0 ? ' active ' : ' ';
      html += '<img class="lazyload product-card__image' + activeClass + '" src="' + _escapeHtmlRelated(img.src) + '" data-src="' + _escapeHtmlRelated(img.lazyloadImage) + '" data-widths="' + widths + '" data-sizes="auto" alt="' + _escapeHtmlRelated(item.type) + ' ' + _escapeHtmlRelated(item.title) + ' ' + _escapeHtmlRelated(img.alt) + '" data-alt="' + _escapeHtmlRelated(img.alt) + '" data-product-card>';
    });
  } else {
    html += '<img class="lazyload product-card__image" src="' + _escapeHtmlRelated(item.image) + '" data-src="' + _escapeHtmlRelated(item.lazyloadMainImage) + '" data-widths="' + widths + '" data-sizes="auto" alt="' + _escapeHtmlRelated(item.type) + ' ' + _escapeHtmlRelated(item.title) + '" data-product-card>';
  }

  html += '<img class="lazyload product-card__image" src="' + _escapeHtmlRelated(item.image) + '" data-src="' + _escapeHtmlRelated(item.lazyloadMainImage) + '" data-widths="' + widths + '" data-sizes="auto" alt="' + _escapeHtmlRelated(item.type) + ' ' + _escapeHtmlRelated(item.title) + '" data-alt="featured-image" data-product-card>';

  if (item.secondLazyloadImage) {
    html += '<img class="lazyload product-card__second-image" src="' + _escapeHtmlRelated(item.secondImage) + '" data-src="' + _escapeHtmlRelated(item.secondLazyloadImage) + '" data-widths="' + widths + '" data-sizes="auto" alt="' + _escapeHtmlRelated(item.type) + ' ' + _escapeHtmlRelated(item.title) + '" data-product-card>';
  }

  return html;
}

function _renderRelatedProductSwatches(item) {
  if (!item.values || !item.values.length) {
    return '';
  }

  var html = '<div class="product-card__swatch-container">';
  item.values.forEach(function(value, index) {
    var activeClass = index === 0 ? ' active ' : ' ';
    var swatchUrl = 'https://cdn.shopify.com/s/files/1/0076/7075/9477/files/color-' + _escapeHtmlRelated(value.handleizedEachValue) + '.png';
    html += '<button class="product-card__swatch-border' + activeClass + '" data-swatch-name="' + _escapeHtmlRelated(value.eachValue) + '">';
    html += '<div class="product-card__swatch" style="background-color: ' + _escapeHtmlRelated(value.eachValue) + '; background-image: url(' + swatchUrl + ');" data-primary-img="' + swatchUrl + '" data-fallback-img="https://cdn.shopify.com/s/files/1/0076/7075/9477/files/color-' + _escapeHtmlRelated(value.handleizedEachValue) + '.jpg">';
    html += _escapeHtmlRelated(value.eachValue);
    html += '</div></button>';
  });
  html += '</div>';
  return html;
}

function _renderRelatedProductCard(item) {
  var html = '<div class="related-products__product-card-container"><div class="product-card">';
  html += '<div class="product-card__image-container">';
  html += '<a href="' + _escapeHtmlRelated(item.url) + '" class="product-card__link">';
  html += _renderRelatedProductImages(item);
  html += '</a>';
  html += '<button data-product-handle="' + _escapeHtmlRelated(item.handle) + '" class="product-card__quick-view-trigger">QUICKSHOP</button>';
  html += '</div>';
  html += '<div class="product-card__text-container">';
  html += '<p class="product-card__title">' + _escapeHtmlRelated(item.title) + '</p>';
  html += '<p class="product-card__price">' + item.price + '</p>';
  html += '</div>';
  html += _renderRelatedProductSwatches(item);
  html += '</div></div>';
  return html;
}

function _renderRelatedProducts(items) {
  var cards = items.map(_renderRelatedProductCard).join('');
  return '<div class="related-products" js-related-products>' + cards + '</div>';
}

theme.RelatedProducts = (function() {

    var selectors = {
      sectionSettingsJson: '[data-settings-json]',
      relatedProductsContainer: '#RelatedProducts-'
    };
  
    /**
     * RelatedProducts section constructor. Runs on page load as well as Theme Editor
     * `section:load` events.
     * @param {string} container - selector for the section container DOM element
     */
    function RelatedProducts(container) {
      this.$container = $(container);
  
      var sectionId = this.sectionId = this.$container.attr('data-section-id');
      var sectionSettings = JSON.parse($(selectors.sectionSettingsJson, this.$container).html());
  
      this.settings = sectionSettings;
      this.namespace = '.relatedProducts';
  
      // Selectors
      this.$shopifySection = $('#shopify-section-' + this.sectionId);
      this.$relatedProductsContainer = $(selectors.relatedProductsContainer + sectionId, this.$container);
  
      this.getProducts();
    }
  
    RelatedProducts.prototype = $.extend({}, RelatedProducts.prototype, {
  
      /**
       * Go get products via ajax
       */
      getProducts: function() {
        var url = "/recommendations/products.json?product_id=" + this.settings.id + "&limit=" + this.settings.limit;
        var self= this;
  
        $.ajax({
          type: 'GET',
          url: url,
          dataType: 'json'
        })
        .done(this.getProductsSuccess.bind(this))
        .fail(this.getProductsError.bind(this));
      },
  
      /**
       * Build product cards
       *
       * @param {object} results - Data sent back from Shopify
       * @param {array} results.products - Array of related products
       */
      getProductsSuccess: function(results) {
        if (results.products.length === 0) {
          return;
        }

        var products = results.products;
        var items = [];

        $.each(products, function(index, product){
          var item = {
            available: product.available,
            url: product.url,
            title: product.title,
            image: product.featured_image.replace('.jpg', '_300x.jpg'),
            price: slate.Currency.formatMoney(product.price),
            variantValues: product.options,
            variants: product.variants,
            handle: product.handle,
            images: product.images,
            tags: product.tags,
            type: product.type
          };
          $.each(item.variantValues, function(index, choice){
            if ( choice.name === 'Color' ){
              var handleizedValuesArray = [];
              $.each(choice.values, function(i){
                var handleizedEachValue = choice.values[i].toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
                var eachValue = choice.values[i];
                var addSwatch = true;

                if( item.tags.length > 0 ){
                  $.each(item.tags , function( i ,tag ){
                    var newTag;
                    if ( tag.indexOf("hide-") > -1 ){
                      newTag = tag.replace("hide-", "");
                      if ( handleizedEachValue == newTag ){
                        addSwatch = false;
                      }
                    }
                  });
                  if ( addSwatch == true ){
                    handleizedValuesArray.push({"handleizedEachValue" : handleizedEachValue, "eachValue": eachValue});
                  }
                }
                else{
                  handleizedValuesArray.push({"handleizedEachValue" : handleizedEachValue, "eachValue": eachValue});
                }
              });
              item.values = handleizedValuesArray;

              var variantImageArray = [];
              var lastColor;
              $.each(item.variants, function(index, choice){
                if ( choice.option1 != lastColor ){
                  if ( choice.featured_image != null ){
                    var imageSrc = choice.featured_image.src.replace(".jpg", '_300x.jpg');
                    var lazyloadImage = choice.featured_image.src.replace(".jpg", '_{width}x.jpg' );
                    var imageAlt = choice.option1;
                    variantImageArray.push( {"title": item.title, "type": item.type, "src": imageSrc, "alt": imageAlt, 'lazyloadImage': lazyloadImage} );
                  }
                }
                lastColor = choice.option1;
              });
              item.variantImageArray = variantImageArray;
            }
          });

          if (item.images[1]) {
            var secondLazyloadImage = item.images[1].replace(".jpg", '_{width}x.jpg' );
            item.secondLazyloadImage = secondLazyloadImage;
            item.secondImage = item.images[1].replace(".jpg", '_300x.jpg');
          }
          var lazyloadMainImage = product.featured_image.replace(".jpg", '_{width}x.jpg' );

          item.lazyloadMainImage = lazyloadMainImage;
          items.push(item);
        });

        this.$shopifySection.removeClass('hide');
        this.$relatedProductsContainer.append(_renderRelatedProducts(items));
        this.slickImages();
        if (typeof initializeProductCardSwatchImageFallbacks === 'function') {
          initializeProductCardSwatchImageFallbacks(this.$relatedProductsContainer[0]);
        }
      },
  
      /**
       * Log any errors
       */
      getProductsError: function(jqXHR, textStatus, errorThrown) {
        console.log(textStatus + ': ' + errorThrown);
      },
  
      /**
       * Event callback for Theme Editor `section:unload` event
       */
      slickImages: function(e){
          
          enquire.register(theme.config.mediaQueries.largeUp, {
            match: function(){
                if ( $("[js-related-products]").hasClass("slick-initialized")){
                    $("[js-related-products]").slick("unslick");
                }
                $("[js-related-products]").slick({
                    slidesToScroll: 1,
                    slidesToShow: 4,
                    arrows: true,
                    prevArrow: '<button class="related-products__prev-trigger"><svg width="12px" height="23px" viewBox="0 0 12 23" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Approved-Pages" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Product-Page-" transform="translate(-61.000000, -2679.000000)" fill="#000000" fill-rule="nonzero"><g id="Group-43" transform="translate(43.000000, 2460.000000)"><g id="Group-6" transform="translate(0.000000, 207.000000)"><g id="noun_right_753734-(1)" transform="translate(24.000000, 23.500000) scale(-1, 1) translate(-24.000000, -23.500000) translate(18.000000, 12.000000)"><polygon id="Path" points="0.99489085 23 0 21.9606329 10.0130051 11.5 0 1.03936709 0.99489085 0 12 11.5"></polygon></g></g></g></g></g></svg></button>',
                    nextArrow: '<button class="related-products__next-trigger"><svg width="12px" height="23px" viewBox="0 0 12 23" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Approved-Pages" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Product-Page-" transform="translate(-1368.000000, -2679.000000)" fill="#000000" fill-rule="nonzero"><g id="Group-43" transform="translate(43.000000, 2460.000000)">  <g id="Group-6-Copy" transform="translate(1331.500000, 230.500000) scale(-1, 1) translate(-1331.500000, -230.500000) translate(1308.000000, 207.000000)"><g id="noun_right_753734-(1)" transform="translate(24.000000, 23.500000) scale(-1, 1) translate(-24.000000, -23.500000) translate(18.000000, 12.000000)"><polygon id="Path" points="0.99489085 23 0 21.9606329 10.0130051 11.5 0 1.03936709 0.99489085 0 12 11.5"></polygon></g></g></g></g></g></svg></button>',
                    dots: false
                })
            },
            unmatch: function(){
            }
          }).register(theme.config.mediaQueries.medium, {
                match: function(){
                    if ( $("[js-related-products]").hasClass("slick-initialized")){
                    $("[js-related-products]").slick("unslick");
                    }
                    $("[js-related-products]").slick({
                        slidesToScroll: 1,
                        slidesToShow: 3,
                        arrows: true,
                        prevArrow: '<button class="related-products__prev-trigger"><svg width="12px" height="23px" viewBox="0 0 12 23" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Approved-Pages" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Product-Page-" transform="translate(-61.000000, -2679.000000)" fill="#000000" fill-rule="nonzero"><g id="Group-43" transform="translate(43.000000, 2460.000000)"><g id="Group-6" transform="translate(0.000000, 207.000000)"><g id="noun_right_753734-(1)" transform="translate(24.000000, 23.500000) scale(-1, 1) translate(-24.000000, -23.500000) translate(18.000000, 12.000000)"><polygon id="Path" points="0.99489085 23 0 21.9606329 10.0130051 11.5 0 1.03936709 0.99489085 0 12 11.5"></polygon></g></g></g></g></g></svg></button>',
                        nextArrow: '<button class="related-products__next-trigger"><svg width="12px" height="23px" viewBox="0 0 12 23" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Approved-Pages" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Product-Page-" transform="translate(-1368.000000, -2679.000000)" fill="#000000" fill-rule="nonzero"><g id="Group-43" transform="translate(43.000000, 2460.000000)">  <g id="Group-6-Copy" transform="translate(1331.500000, 230.500000) scale(-1, 1) translate(-1331.500000, -230.500000) translate(1308.000000, 207.000000)"><g id="noun_right_753734-(1)" transform="translate(24.000000, 23.500000) scale(-1, 1) translate(-24.000000, -23.500000) translate(18.000000, 12.000000)"><polygon id="Path" points="0.99489085 23 0 21.9606329 10.0130051 11.5 0 1.03936709 0.99489085 0 12 11.5"></polygon></g></g></g></g></g></svg></button>',
                        dots: false
                    })
                },
                unmatch: function(){
                }
            }).register(theme.config.mediaQueries.smallDown, {
            match: function(){
                if ( $("[js-related-products]").hasClass("slick-initialized")){
                  $("[js-related-products]").slick("unslick");
                }
                $("[js-related-products]").slick({
                    slidesToScroll: 1,
                    slidesToShow: 2,
                    arrows: true,
                    prevArrow: '<button class="related-products__prev-trigger"><svg width="12px" height="23px" viewBox="0 0 12 23" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Approved-Pages" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Product-Page-" transform="translate(-61.000000, -2679.000000)" fill="#000000" fill-rule="nonzero"><g id="Group-43" transform="translate(43.000000, 2460.000000)"><g id="Group-6" transform="translate(0.000000, 207.000000)"><g id="noun_right_753734-(1)" transform="translate(24.000000, 23.500000) scale(-1, 1) translate(-24.000000, -23.500000) translate(18.000000, 12.000000)"><polygon id="Path" points="0.99489085 23 0 21.9606329 10.0130051 11.5 0 1.03936709 0.99489085 0 12 11.5"></polygon></g></g></g></g></g></svg></button>',
                    nextArrow: '<button class="related-products__next-trigger"><svg width="12px" height="23px" viewBox="0 0 12 23" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Approved-Pages" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Product-Page-" transform="translate(-1368.000000, -2679.000000)" fill="#000000" fill-rule="nonzero"><g id="Group-43" transform="translate(43.000000, 2460.000000)">  <g id="Group-6-Copy" transform="translate(1331.500000, 230.500000) scale(-1, 1) translate(-1331.500000, -230.500000) translate(1308.000000, 207.000000)"><g id="noun_right_753734-(1)" transform="translate(24.000000, 23.500000) scale(-1, 1) translate(-24.000000, -23.500000) translate(18.000000, 12.000000)"><polygon id="Path" points="0.99489085 23 0 21.9606329 10.0130051 11.5 0 1.03936709 0.99489085 0 12 11.5"></polygon></g></g></g></g></g></svg></button>',
                    dots: false
                })
            },
            unmatch: function(){
            }
          })

          // On click of swatch change out swatches and change out featured image
          /* 
          $(".product-card__swatch-border").click(function(){
            var $productCard = $(this).closest(".product-card");
            var $swatchName = $(this).attr("data-swatch-name");
            $productCard.find(".product-card__swatch-border").removeClass("active");
            $(this).addClass("active");
            $productCard.find(".product-card__image.active").removeClass("active");
            console.log( $(".product-card__image[data-alt='"+$swatchName+"']").length)
            var $image = $productCard.find(".product-card__image[data-alt='" + $swatchName + "']");
            if ( $image.length < 1 ){
              $image = $productCard.find(".product-card__image[data-alt='featured-image']")
            }
            $image.each(function(index){
              if ( index === 0 ){
                  $(this).addClass("active");
              }
          })
        }) */
      },
      onUnload: function() {
        this.$container.off(this.namespace);
      }
    });
  
    return RelatedProducts;
})();

theme.Collection = (function(){
    function Collection(container) {
        // Changing Grid View
        // $(".collection-top__two").click(function(){
        //     $(".collection-card__product-card-container").addClass("collection-card__product-card-container--two")
        //     $(".collection-top__four").removeClass("active");
        //     $(this).addClass("active");
        // })
        // $(".collection-top__two").on('keyup', function (e) {
        //     if (e.keyCode == 13) {
        //         $(".collection-card__product-card-container").addClass("collection-card__product-card-container--two")
        //         $(".collection-top__four").removeClass("active");
        //         $(this).addClass("active");
        //     }
        // });
        // $(".collection-top__four").click(function(){
        //     $(".collection-top__two").removeClass("active");
        //     $(this).addClass("active");
        //     $(".collection-card__product-card-container").removeClass("collection-card__product-card-container--two")
        // })
        // $(".collection-top__four").on('keyup', function (e) {
        //     if (e.keyCode == 13) {
        //         $(".collection-top__two").removeClass("active");
        //         $(this).addClass("active");
        //         $(".collection-card__product-card-container").removeClass("collection-card__product-card-container--two")
        //     }
        // });
        // adjust arrow for linklist filter breadcrumb
        $("body").on("click", ".collection-dropdown__child-link--header", function(e){
            e.preventDefault();
            if ( $(this).hasClass("arrow-up")){
                $(this).removeClass("arrow-up")
                $("[js-dropdown-content]").slideUp();
            }
            else{
                $(this).addClass("arrow-up")
                $("[js-dropdown-content]").slideDown();
                $("[js-dropdown-content]").css("display", "flex")
            }
        })

        $('body').on('click', '.product-card__link', function() {
            var swatch = $(this).closest('.product-card').find('.product-card__swatch-border.active').data('swatch-name');
            sessionStorage.setItem('swatch-selected', swatch);
        });

        // when browser resizes
        $(window).resize(function(){
            $('.js-collection-filter-trigger').removeClass('active');

            if ( $(window).width() > 767 ){
                $(".collection-dropdown__grandchild").removeAttr("style")
            }
        })
        // Scroll Top
        $(window).scroll(function(){

        var $bannerHeight = 0;
        var $collectionTopHeight = $(".collection-top").outerHeight();
        var $singleProductCardHeight= $(".product-card:first-child").outerHeight();
        if(   $(".collection-banner").length > 0 ){
            $bannerHeight = $(".collection-banner").outerHeight();
        }
        var $top = $bannerHeight + $collectionTopHeight + $singleProductCardHeight;
            if ( $(window).scrollTop() > $top ){
                $(".collection__scroll-top").addClass("active");
            }
            else{
                $(".collection__scroll-top").removeClass("active");
            }
        })
        $(".collection__scroll-top-inner").click(function(){
            $("body, html").animate({scrollTop: 0}, "slow");
        })

    }
    return Collection;
})();
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var Filters = {
  config: {
    delay: 100
  },
  data: {},
  timer: 2000,
  init: function init() {
    if (_n.exists("[data-collection-filters]")) {
      Filters.start();
      Filters.bindURL();
    }
  },
  start: function start() {
    _n.qsa("form[data-collection-filters] input").forEach(function (input) {
      input.addEventListener("input", function (e) {
        console.log(" i heard you");

        _n.qs(".collection-products").classList.add("loading");

        if (Filters.timer) clearTimeout(Filters.timer);
        Filters.timer = setTimeout(function () {
          Filters.value();

          if (!!Collection.reset) {
            Collection.reset();
            setTimeout(Collection.load, 20);
          } else {
            Neptune.templates.render("Products");
          }

          _n.qs(".collection-products").classList.remove("loading");
        }, 1000);
      });
    });

  },
  value: function value() {
    var formData = new FormData(_n.qs("form[data-collection-filters]"));
    var json = {};

    var _iterator = _createForOfIteratorHelper(formData.entries()),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var pair = _step.value;

        if (typeof json[pair[0]] == "undefined") {
          json[pair[0]] = {
            tags: []
          };
        }

        json[pair[0]].tags.push(pair[1]);
        json[pair[0]].constraint = _n.qs("form[data-collection-filters] [data-constraint][name=\"".concat(pair[0], "\"]")).getAttribute("data-constraint") || false;
        json[pair[0]].field = _n.qs("form[data-collection-filters] [data-constraint][name=\"".concat(pair[0], "\"]")).getAttribute("data-field") || "~tags";
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    Filters.data = json;
    Filters.bindURL(Filters.data);
    return json;
  },
  clear: function clear(filter) {
    if (filter) {
      _n.qs('[value="' + filter.value + '"]').checked = false;
      var removedTags = Filters.data[filter.set].tags.filter(function (n) {
        return n != filter.value;
      });

      if (removedTags.length == 0) {
        delete Filters.data[filter.set];
      } else {
        Filters.data[filter.set].tags = removedTags;
      }

      Filters.bindURL(Filters.data);
    } else {
      Filters.data = {};
      Filters.flat_data = [];

      _n.qsa("[data-collection-filters] input[type=checkbox]").forEach(function (checkbox) {
        checkbox.checked = false;
      });
    }

    Filters.bindURL(Filters.data);

    if (!!Collection.reset) {
      Collection.reset();
      setTimeout(Collection.load, 20);
    } else {
      Neptune.templates.render("Products");
    }
  },
  bindURL: function bindURL(data) {
    console.log(data);

    if (!!data) {
      // SET
      var url = document.location.href.split("?")[0] + "?";
      Object.keys(data).forEach(function (key) {
        url += "filter[".concat(data[key].field, "]=").concat(data[key].tags.map(function (tag) {
          return tag.split(":").reverse()[0];
        }).join(), "&");
      });
      url = url.substring(0, url.length - 1);
      window.history.replaceState(window.history.state || {}, document.title, url);
    } else {
      // GET
      Filters.data = {};
      Filters.flat_data = [];

      try {
        document.location.href.split("?")[1].split("&").forEach(function (param) {
          var p = param.split("=");
          if (p[0].indexOf("filter[") == -1) return false;
          var key = p[0].split("[")[1].split("]")[0];
          var field = key;

          if (key.includes("~")) {
            key = key.split("~")[0];
          }

          if (key) {
            Filters.data[key] = {
              tags: p[1].split(","),
              field: field
            };
          } else {
            p[1].split(",").forEach(function (val) {
              Filters.flat_data.push(val);
            });
          }
        });
      } catch (e) {}

      _n.qsa("[data-collection-filters] input[type=checkbox]").forEach(function (checkbox) {
        checkbox.checked = false;
      });

      Object.keys(Filters.data).forEach(function (key) {
        Filters.data[key].tags.map(function (val) {
          val = val.replace("%20", " ");
          if (_n.exists("[value*=\"".concat(val, "\"]"))) _n.qs("[value*=\"".concat(val, "\"]")).checked = true;
        });
      });
      Filters.flat_data.forEach(function (val) {
        val = val.replace("%20", " ");
        if (_n.exists("[value=\"".concat(val, "\"]"))) _n.qs("[value=\"".concat(val, "\"]")).checked = true;
      });

      if (_n.exists(".filter-format-range .ghost")) {
        _n.qsa(".filter-format-range").forEach(function (rangeholder) {
          var range = _n.array(_n.qsa("input[type=checkbox]", rangeholder)).map(function (cb, i) {
            if (cb.checked) return i + 1;
          }).filter(function (i) {
            return i != undefined;
          });

          var min = Math.min.apply(Math, _toConsumableArray(range));
          var max = Math.max.apply(Math, _toConsumableArray(range));

          var slider = _n.qs(".multirange.original");

          slider.value = min + "," + max;

          var ghost = _n.qs(".multirange.ghost");

          ghost.style.setProperty("--low", 100 * ((slider.valueLow - slider.min) / (slider.max - slider.min)) + 1 + "%");
          ghost.style.setProperty("--high", 100 * ((slider.valueHigh - slider.min) / (slider.max - slider.min)) - 1 + "%");
        });
      }

      return Filters.data;
    }
  },
  toggleSet: function toggleSet(option) {
    $('#' + option + '_filter_container').slideToggle();
    $('#' + option + '_filter_title').toggleClass('close');
  }
};
window.Filters = Filters;

theme.LandingPageFtCarousel = (function(){
  var selectors = {
    carousel: '[js-ft-carousel]'
  }

  function LandingPageFtCarousel(container) {
    this.$container = $(container);
    var $carousel = $(selectors.carousel, this.$container);

    enquire.register(theme.config.mediaQueries.mediumUp, {
      match: function(){
          if ( $carousel.hasClass("slick-initialized")){
              $carousel.slick("unslick");
          }
          $carousel.slick({
            arrows: true,
            prevArrow: '<button class="landingpage-ft-carousel__prev-trigger"><svg width="12px" height="23px" viewBox="0 0 12 23" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Approved-Pages" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Product-Page-" transform="translate(-61.000000, -2679.000000)" fill="#000000" fill-rule="nonzero"><g id="Group-43" transform="translate(43.000000, 2460.000000)"><g id="Group-6" transform="translate(0.000000, 207.000000)"><g id="noun_right_753734-(1)" transform="translate(24.000000, 23.500000) scale(-1, 1) translate(-24.000000, -23.500000) translate(18.000000, 12.000000)"><polygon id="Path" points="0.99489085 23 0 21.9606329 10.0130051 11.5 0 1.03936709 0.99489085 0 12 11.5"></polygon></g></g></g></g></g></svg></button>',
            nextArrow: '<button class="landingpage-ft-carousel__next-trigger"><svg width="12px" height="23px" viewBox="0 0 12 23" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Approved-Pages" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Product-Page-" transform="translate(-1368.000000, -2679.000000)" fill="#000000" fill-rule="nonzero"><g id="Group-43" transform="translate(43.000000, 2460.000000)">  <g id="Group-6-Copy" transform="translate(1331.500000, 230.500000) scale(-1, 1) translate(-1331.500000, -230.500000) translate(1308.000000, 207.000000)"><g id="noun_right_753734-(1)" transform="translate(24.000000, 23.500000) scale(-1, 1) translate(-24.000000, -23.500000) translate(18.000000, 12.000000)"><polygon id="Path" points="0.99489085 23 0 21.9606329 10.0130051 11.5 0 1.03936709 0.99489085 0 12 11.5"></polygon></g></g></g></g></g></svg></button>',
            dots: false,
            infinite: true,
            rows: 1,
            slidesToShow: 4,
          })
      },
      unmatch: function(){
      }
    }).register(theme.config.mediaQueries.mediumDown, {
        match: function(){
          if ( $carousel.hasClass("slick-initialized")){
          $carousel.slick("unslick");
          }
          $carousel.slick({
            arrows: true,
            prevArrow: '<button class="landingpage-ft-carousel__prev-trigger"><svg width="12px" height="23px" viewBox="0 0 12 23" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Approved-Pages" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Product-Page-" transform="translate(-61.000000, -2679.000000)" fill="#000000" fill-rule="nonzero"><g id="Group-43" transform="translate(43.000000, 2460.000000)"><g id="Group-6" transform="translate(0.000000, 207.000000)"><g id="noun_right_753734-(1)" transform="translate(24.000000, 23.500000) scale(-1, 1) translate(-24.000000, -23.500000) translate(18.000000, 12.000000)"><polygon id="Path" points="0.99489085 23 0 21.9606329 10.0130051 11.5 0 1.03936709 0.99489085 0 12 11.5"></polygon></g></g></g></g></g></svg></button>',
            nextArrow: '<button class="landingpage-ft-carousel__next-trigger"><svg width="12px" height="23px" viewBox="0 0 12 23" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Approved-Pages" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Product-Page-" transform="translate(-1368.000000, -2679.000000)" fill="#000000" fill-rule="nonzero"><g id="Group-43" transform="translate(43.000000, 2460.000000)">  <g id="Group-6-Copy" transform="translate(1331.500000, 230.500000) scale(-1, 1) translate(-1331.500000, -230.500000) translate(1308.000000, 207.000000)"><g id="noun_right_753734-(1)" transform="translate(24.000000, 23.500000) scale(-1, 1) translate(-24.000000, -23.500000) translate(18.000000, 12.000000)"><polygon id="Path" points="0.99489085 23 0 21.9606329 10.0130051 11.5 0 1.03936709 0.99489085 0 12 11.5"></polygon></g></g></g></g></g></svg></button>',
            dots: false,
            infinite: true,
            rows: 2,
            slidesToShow: 2,
          })
        },
        unmatch: function(){
        }
    })
  }

  return LandingPageFtCarousel;
})();

theme.LandingPageProductCarousel = (function(){
  var selectors = {
    carousel: '[js-product-carousel]'
  }

  function LandingPageProductCarousel(container) {
    this.$container = $(container);
    var $carousel = $(selectors.carousel, this.$container);

    enquire.register(theme.config.mediaQueries.largeUp, {
      match: function(){
          if ( $carousel.hasClass("slick-initialized")){
              $carousel.slick("unslick");
          }
          $carousel.slick({
            arrows: true,
            prevArrow: '<button class="landingpage-ft-carousel__prev-trigger"><svg width="12px" height="23px" viewBox="0 0 12 23" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Approved-Pages" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Product-Page-" transform="translate(-61.000000, -2679.000000)" fill="#000000" fill-rule="nonzero"><g id="Group-43" transform="translate(43.000000, 2460.000000)"><g id="Group-6" transform="translate(0.000000, 207.000000)"><g id="noun_right_753734-(1)" transform="translate(24.000000, 23.500000) scale(-1, 1) translate(-24.000000, -23.500000) translate(18.000000, 12.000000)"><polygon id="Path" points="0.99489085 23 0 21.9606329 10.0130051 11.5 0 1.03936709 0.99489085 0 12 11.5"></polygon></g></g></g></g></g></svg></button>',
            nextArrow: '<button class="landingpage-ft-carousel__next-trigger"><svg width="12px" height="23px" viewBox="0 0 12 23" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Approved-Pages" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Product-Page-" transform="translate(-1368.000000, -2679.000000)" fill="#000000" fill-rule="nonzero"><g id="Group-43" transform="translate(43.000000, 2460.000000)">  <g id="Group-6-Copy" transform="translate(1331.500000, 230.500000) scale(-1, 1) translate(-1331.500000, -230.500000) translate(1308.000000, 207.000000)"><g id="noun_right_753734-(1)" transform="translate(24.000000, 23.500000) scale(-1, 1) translate(-24.000000, -23.500000) translate(18.000000, 12.000000)"><polygon id="Path" points="0.99489085 23 0 21.9606329 10.0130051 11.5 0 1.03936709 0.99489085 0 12 11.5"></polygon></g></g></g></g></g></svg></button>',
            dots: false,
            infinite: true,
            rows: 2,
            slidesPerRow: 4
          })
      },
      unmatch: function(){
      }
    }).register(theme.config.mediaQueries.medium, {
        match: function(){
          if ( $carousel.hasClass("slick-initialized")){
          $carousel.slick("unslick");
          }
          $carousel.slick({
            arrows: true,
            prevArrow: '<button class="landingpage-ft-carousel__prev-trigger"><svg width="12px" height="23px" viewBox="0 0 12 23" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Approved-Pages" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Product-Page-" transform="translate(-61.000000, -2679.000000)" fill="#000000" fill-rule="nonzero"><g id="Group-43" transform="translate(43.000000, 2460.000000)"><g id="Group-6" transform="translate(0.000000, 207.000000)"><g id="noun_right_753734-(1)" transform="translate(24.000000, 23.500000) scale(-1, 1) translate(-24.000000, -23.500000) translate(18.000000, 12.000000)"><polygon id="Path" points="0.99489085 23 0 21.9606329 10.0130051 11.5 0 1.03936709 0.99489085 0 12 11.5"></polygon></g></g></g></g></g></svg></button>',
            nextArrow: '<button class="landingpage-ft-carousel__next-trigger"><svg width="12px" height="23px" viewBox="0 0 12 23" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Approved-Pages" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Product-Page-" transform="translate(-1368.000000, -2679.000000)" fill="#000000" fill-rule="nonzero"><g id="Group-43" transform="translate(43.000000, 2460.000000)">  <g id="Group-6-Copy" transform="translate(1331.500000, 230.500000) scale(-1, 1) translate(-1331.500000, -230.500000) translate(1308.000000, 207.000000)"><g id="noun_right_753734-(1)" transform="translate(24.000000, 23.500000) scale(-1, 1) translate(-24.000000, -23.500000) translate(18.000000, 12.000000)"><polygon id="Path" points="0.99489085 23 0 21.9606329 10.0130051 11.5 0 1.03936709 0.99489085 0 12 11.5"></polygon></g></g></g></g></g></svg></button>',
            dots: false,
            infinite: true,
            slidesToShow: 3
          })
        },
        unmatch: function(){
        }
    }).register(theme.config.mediaQueries.smallDown, {
        match: function(){
          if ( $carousel.hasClass("slick-initialized")){
          $carousel.slick("unslick");
          }
          $carousel.slick({
            arrows: true,
            prevArrow: '<button class="landingpage-ft-carousel__prev-trigger"><svg width="12px" height="23px" viewBox="0 0 12 23" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Approved-Pages" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Product-Page-" transform="translate(-61.000000, -2679.000000)" fill="#000000" fill-rule="nonzero"><g id="Group-43" transform="translate(43.000000, 2460.000000)"><g id="Group-6" transform="translate(0.000000, 207.000000)"><g id="noun_right_753734-(1)" transform="translate(24.000000, 23.500000) scale(-1, 1) translate(-24.000000, -23.500000) translate(18.000000, 12.000000)"><polygon id="Path" points="0.99489085 23 0 21.9606329 10.0130051 11.5 0 1.03936709 0.99489085 0 12 11.5"></polygon></g></g></g></g></g></svg></button>',
            nextArrow: '<button class="landingpage-ft-carousel__next-trigger"><svg width="12px" height="23px" viewBox="0 0 12 23" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Approved-Pages" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Product-Page-" transform="translate(-1368.000000, -2679.000000)" fill="#000000" fill-rule="nonzero"><g id="Group-43" transform="translate(43.000000, 2460.000000)">  <g id="Group-6-Copy" transform="translate(1331.500000, 230.500000) scale(-1, 1) translate(-1331.500000, -230.500000) translate(1308.000000, 207.000000)"><g id="noun_right_753734-(1)" transform="translate(24.000000, 23.500000) scale(-1, 1) translate(-24.000000, -23.500000) translate(18.000000, 12.000000)"><polygon id="Path" points="0.99489085 23 0 21.9606329 10.0130051 11.5 0 1.03936709 0.99489085 0 12 11.5"></polygon></g></g></g></g></g></svg></button>',
            dots: false,
            infinite: true,
            slidesToShow: 2
          })
        },
        unmatch: function(){
        }
    })
  }

  return LandingPageProductCarousel;
})();



window.addEventListener("load", function(){

	// Create a condition that targets viewports at least 768px wide
	const mediaQuery = window.matchMedia('(min-width: 768px)')

	function handleTabletChange(e) {
		// Check if the media query is true
		if (typeof $.fn.slick === 'function') {
			if (e.matches) {
				$('.horizontal-slider').slick({
					slidesToShow: 4,
					arrows: false,
					spaceBetween: 50
				});
				$('.vertical-slider__essential').slick({
					vertical: true,
					arrows: false,
					swipe: false
				});
			} else {
				$('.horizontal-slider').slick({
					slidesToShow: 2,
					rows: 2,
					arrows: false,
					spaceBetween: 50
				});
				$('.vertical-slider__essential').slick({
					arrows: false,
					swipe: false
				});

				$('.wrap-essential-slider').slick({
					slidesToShow: 1,
					slidesToScroll: 1,
					swipeToSlide: true,
					infinite: false
				});
			}
		}
	}

	// Register event listener
	mediaQuery.addListener(handleTabletChange)

	// Initial check
	handleTabletChange(mediaQuery);

});

function updateRecomdationProductCard() {
  var rtImages = $(".rktheme-carousel-wrap");
  var classForBtn = 'view-more-colors__btn';
  rtImages.find(".product-card").each(function(){
    var ptodUrl = $(this).find(".product-card__title").attr("href");
    $(this).find('.swatch-element').slice(3,-1).css("display","none");
    if ( $(this).find("."+classForBtn).length < 1 && $(this).find('.swatch-element').length > 3) {
      $(this).find('.swatch-selection').append("<a class='"+classForBtn+"' href="+ptodUrl+">+</a>");
    }
  });
}

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#address_form_new');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  $('[js-address-edit]').on('click', function() {
    var formId = $(this).data('form-id');
    $('#address_form_' + formId).toggle();
    $('.account-address__edit').toggle();
    $('.account-address__listing').toggle();
  });

  $('[js-address-delete]').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '[js-show-recover]',
    hideRecoverPasswordLink: '[js-hide-recover]'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('.login__recover').toggle();
    $('.login__login').toggle();
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

theme.AccountDashboard = (function(){
  function AccountDashboard(container) {
    this.$container = $(container);
    
    enquire.register(theme.config.mediaQueries.smallDown,{
      match: function(){
        $('#account__overview', this.$container).attr('aria-hidden', true);
        $('[aria-controls="account__overview"]', this.$container).attr('aria-expanded', false);
      },
      unmatch: function(){
        $('.account__accordion-header', this.$container).attr('aria-expanded', true)
        $('#account__history, #account__overview', this.$container).removeAttr('aria-hidden').removeAttr('style')
      }
    })
  }

  return AccountDashboard;
})();

theme.AccountAddress = (function(){
  function AccountAddress(container) {
    this.$container = $(container);
    
    enquire.register(theme.config.mediaQueries.smallDown,{
      match: function(){
        $('#account-address-new', this.$container).attr('aria-hidden', true);
        $('[aria-controls="account-address-new"]', this.$container).attr('aria-expanded', false);
        $('[aria-controls="account-address-list"]', this.$container).attr('aria-expanded', true);
      },
      unmatch: function(){
        $('.account__accordion-header', this.$container).attr('aria-expanded', true)
        $('#account-address-new, #account-address-list', this.$container).removeAttr('aria-hidden').removeAttr('style')
      }
    })
  }

  return AccountAddress;
})();

theme.AccountOrders = (function(){
  function AccountOrders(container) {
    this.$container = $(container);
    
    enquire.register(theme.config.mediaQueries.smallDown,{
      match: function(){
        $('#order__details', this.$container).attr('aria-hidden', true);
        $('[aria-controls="order__details"]', this.$container).attr('aria-expanded', false);
      },
      unmatch: function(){
        $('.account__accordion-header', this.$container).attr('aria-expanded', true)
        $('#order__overview, #order__details', this.$container).removeAttr('aria-hidden').removeAttr('style')
      }
    })
  }

  return AccountOrders;
})();
theme.Blog = (function() {
  function Blog() {
    $('.blog-linklist__mobile-select').on('change', function() {
      var url = $(this).val();
      window.location.href = url;
    });

    updateSelectValue();
  }
  
  function updateSelectValue() {
    var pathname = window.location.pathname;
    $('.blog-linklist__mobile-select').val(pathname);
  }

  return Blog;
})();
theme.PasswordPage = (function(){
    function PasswordPage(container) {
        $("body").on("click", ".password-top__btn", function(){ 
            $('html,body').animate({
                scrollTop: $(".password__store-locator").offset().top},
                'slow');
        })   
    }
    return PasswordPage;
})();

/*================ Scripts that compile to assets/theme.js file and can be used alone ================*/
$(document).ready(function () {
  var sections = new slate.Sections();
  sections.register('accordion', theme.Accordion);
  sections.register('product', theme.Product);
  sections.register('account-dashboard', theme.AccountDashboard);
  sections.register('account-address', theme.AccountAddress);
  sections.register('account-orders', theme.AccountOrders);
  sections.register('promo-bar', theme.PromoBar);
  sections.register('blog', theme.Blog);
  sections.register('homepage-carousel', theme.HomepageCarousel);
  sections.register('live-text-image-banner', theme.LiveTextImageBanner);
  sections.register('hero-carousel', theme.HeroCarousel);
  sections.register('nav-login', theme.LoginToggle);
  sections.register("swatch", theme.swatches);
  sections.register("related-products", theme.RelatedProducts);
  sections.register("collection", theme.Collection);
  sections.register("header-section", theme.HeaderFunction);
  sections.register('homepage-featured-products', theme.HomepageFeaturedProducts);
  sections.register('password-page', theme.PasswordPage);
  sections.register('footer-newsletter', theme.FooterSubscription);
  sections.register('landing-page-ft-carousel', theme.LandingPageFtCarousel);
  sections.register('landing-page-product-carousel', theme.LandingPageProductCarousel);
  sections.register('essential-products-carousel', theme.EssentialProductCarousel);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function (evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  // init Geolocation
  theme.Geolocation.init();

  // init mobile drawer
  theme.MobileNav.init();
  // Remove extra text under product card
  // 	function removeText() {
  //     $( "#bc-sf-filter-products > div" ).each(function( index ) {
  //         if ($(this).text() == "{{itemBadges}}") {
  //             $(this).find('.product-card__image-container').appendTo($(this));
  //             $(this).find(">:first-child").not(".product-card__swatch-container").not(".product-card__image-container").remove();
  //         }
  //      });
  //   }
  // setTimeout(function() {
  //     removeText();
  //   }, 1000);
});

/* Make element clickable
Using some elements as the <a> attribute changes the style of that element. 
Also sometimes we can't use the <a> tag. 
For such cases, the script below is used. The element must have a class ".clickable"
and an 'attr-url' attribute that contains a link */
document.addEventListener("DOMContentLoaded", function(e){
  $('.clickable').click(function(){
    window.location = $(this).attr('attr-url');
  });
});
// End

document.addEventListener("DOMContentLoaded", function (e) {

  Neptune.manifest.init()
  Neptune.engage.init()
  Neptune.templates.init()

  if (window.Filters) {
    window.Filters.init()
  }
})

document.addEventListener('template:rendered', function (e) {
  const el = e.detail.info.el

  Neptune.manifest.init(el)
  Neptune.engage.init(el)
  Neptune.templates.init(el)
});

document.addEventListener('periscope:viewed', function (e) {
  const el = e.detail.info.el

  Neptune.manifest.init(el)
  Neptune.engage.init(el)
  Neptune.templates.init(el)
});

document.addEventListener("shopify:section:load", function (event) {
  Neptune.manifest.init();
  Neptune.engage.init();
  Neptune.templates.init();

  if (window.Filters) {
    window.Filters.init()
  }
});

